import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import SEO, { breadcrumbSchema, faqSchema, serviceSchema } from '@/components/SEO';
import { ArrowLeft, ArrowRight, Check, Star, CheckCircle2, Quote, Phone, Users, Shield, Target, Heart, Zap, Award, Clock, MapPin, Camera, Sparkles, User, Eye, Key, Flower2, Medal, Hourglass, ChevronDown, Flame, Maximize2, MessageCircle } from 'lucide-react';
import { buildWhatsAppUrl } from '@/components/WhatsAppLink';
import ImageLightbox from '@/components/ImageLightbox';
import CarouselPauseButton from '@/components/CarouselPauseButton';
import { services } from '@/data/services';
import FlammeOlympiqueCarousel from '@/components/FlammeOlympiqueCarousel';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import CTASection from '@/components/CTASection';
import ServiceContactCTA from '@/components/ServiceContactCTA';
import { ServiceFAQRichAnswer } from '@/components/ServiceFAQRichAnswer';
import NotFound from './NotFound';
import ServiceStickyBar from '@/components/ServiceStickyBar';

import borneEssentielle from '@/assets/borne-selfie-tarifs.jpg';
import bornePremium from '@/assets/borne-selfie-option-ia.jpg';
import borneVip from '@/assets/borne-selfie-vip.jpg';
import weddingPlanning from '@/assets/wedding-planning.jpg';
import weddingCoordination from '@/assets/wedding-coordination.jpg';
import weddingCoaching from '@/assets/wedding-coaching.jpg';
import artisticFull from '@/assets/artistic-full.jpg';
import artisticSingle from '@/assets/artistic-single.jpg';
import artisticSupport from '@/assets/artistic-support.jpg';
import badgeMariagesNet from '@/assets/badge-mariages-net.png';
import borneContent1 from '@/assets/location-carousel-27.png';
import borneContent2 from '@/assets/location-carousel-26.png';
import borneContent3 from '@/assets/borne-content-3.jpg';
import borneContent4 from '@/assets/photobooth-carousel-12.png';
import borneCorporate from '@/assets/borne-selfie-corporate.jpg';
import mascotteCorporateGenerated from '@/assets/mascotte-corporate-generated.jpg';
import mascotteCarousel01 from '@/assets/mascotte-carousel-01.webp';
import mascotteCarousel02 from '@/assets/mascotte-carousel-02.webp';
import mascotteCarousel03 from '@/assets/mascotte-carousel-03.webp';
import mascotteCarousel04 from '@/assets/mascotte-carousel-04.webp';
import mascotteCarousel05 from '@/assets/mascotte-carousel-05.webp';
import mascotteCarousel06 from '@/assets/mascotte-carousel-06.webp';
import mascotteCarousel07 from '@/assets/mascotte-carousel-07.webp';
import mascotteCarousel08 from '@/assets/mascotte-carousel-08.webp';
import mascotteCarousel09 from '@/assets/mascotte-carousel-09.webp';
import mascotteCarousel10 from '@/assets/mascotte-carousel-10.webp';
import mascotteCarousel11 from '@/assets/mascotte-carousel-11.webp';
import materielContent1 from '@/assets/materiel-content-1.jpg';
import materielContent2 from '@/assets/materiel-content-2.jpg';
import materielContent3 from '@/assets/materiel-content-3.jpg';
import materielContent4 from '@/assets/materiel-content-4.jpg';
import eventContent1 from '@/assets/event-content-1.jpg';
import eventContent2 from '@/assets/event-content-2.jpg';
import eventContent3 from '@/assets/event-content-3.jpg';
import eventContent4 from '@/assets/event-content-4.jpg';
import eventContent5 from '@/assets/event-content-5.jpg';
import formulaEventFull from '@/assets/formula-event-full.jpg';
import formulaEventCoord from '@/assets/formula-event-coord.jpg';
import formulaEventConsulting from '@/assets/formula-event-consulting.jpg';
import talentContent1 from '@/assets/talent-content-1-replacement.png';
import talentContent2 from '@/assets/talent-content-2-replacement.png';
import talentContent3 from '@/assets/talent-content-3-replacement.jpg';
import talentContent4 from '@/assets/talent-content-4.jpg';
import talentContent5 from '@/assets/talent-content-5.jpg';
import weddingContent1 from '@/assets/wedding-content-1.jpg';
import weddingContent2 from '@/assets/wedding-content-2.jpg';
import weddingContent3 from '@/assets/wedding-content-3.jpg';
import weddingContent4 from '@/assets/wedding-content-4.jpg';
import weddingContent5 from '@/assets/wedding-content-5.jpg';
import ceremonyContent1 from '@/assets/ceremonie-carousel-03.webp';
import ceremonyContent2 from '@/assets/ceremonie-carousel-36.webp';
import ceremonyContent3 from '@/assets/ceremonie-carousel-39.webp';
import ceremonyContent4 from '@/assets/ceremonie-carousel-46.webp';
import kidsContent1 from '@/assets/kids-content-1.jpg';
import kidsContent2 from '@/assets/kids-content-2.jpg';
import kidsContent4 from '@/assets/kids-content-4.jpg';
import musicContent1 from '@/assets/music-content-1.jpg';
import musicContent2 from '@/assets/music-content-2.jpg';
import musicContent3 from '@/assets/music-content-3.jpg';
import musicContent4 from '@/assets/music-content-4.jpg';
import lieuxContent1 from '@/assets/lieux-point-1-reception.jpg';
import lieuxContent2 from '@/assets/lieux-point-2-traiteurs.png';
import lieuxContent3 from '@/assets/lieux-content-3.jpg';
import lieuxContent4 from '@/assets/lieux-content-4.jpg';
import specialContent1 from '@/assets/special-content-1-replacement.png';
import specialContent2 from '@/assets/special-content-2.jpg';
import specialContent3 from '@/assets/special-content-3.jpg';
import specialContent4 from '@/assets/special-content-4.jpg';
import asBartender01 from '@/assets/animations-speciales-bartender-01.jpeg';
import asBartender02 from '@/assets/animations-speciales-bartender-02.jpg';
import asBartender03 from '@/assets/animations-speciales-bartender-03.png';
import asBartender04 from '@/assets/animations-speciales-bartender-04.jpeg';
import asBartender05 from '@/assets/animations-speciales-bartender-05.jpg';
import asBartender06 from '@/assets/animations-speciales-bartender-06.png';
import asBartender07 from '@/assets/animations-speciales-bartender-07.jpg';
import asBartender08 from '@/assets/animations-speciales-bartender-08.png';
import asBartender09 from '@/assets/animations-speciales-bartender-09.png';
import asBartender10 from '@/assets/animations-speciales-bartender-10.png';
import asBartender11 from '@/assets/animations-speciales-bartender-11.jpg';
import asBartender12 from '@/assets/animations-speciales-bartender-12.png';
import asBartender13 from '@/assets/animations-speciales-bartender-13.jpg';
import asBartender14 from '@/assets/animations-speciales-bartender-14.png';
import animateurContent1 from '@/assets/animateur-carousel-01.png';
import animateurContent2 from '@/assets/animateur-carousel-02.png';

import artRueContent2 from '@/assets/art-rue-content-2.jpg';
import artSceneContent1 from '@/assets/art-scene-content-1.jpg';
import artSceneContent2 from '@/assets/art-scene-content-2.jpg';
import artSceneContent3 from '@/assets/art-scene-content-03.webp';
import artSceneContent4 from '@/assets/art-scene-content-04.webp';
import artSceneBurlesque from '@/assets/art-scene-content-burlesque.jpg';
import artSceneHumour from '@/assets/art-scene-humour.jpg';
import artSceneSosie from '@/assets/art-scene-sosie.jpg';
import artCirqueContent1 from '@/assets/cirque-clown-portrait.jpg';
import artCirqueContent2 from '@/assets/cirque-aerialiste-suspension-lumieres.png';
import artCirqueContent3 from '@/assets/cirque-acrobates-equilibre-plateforme.png';
import artCirquePoint1 from '@/assets/cirque-aerialiste-nuit.png';
import artCirquePoint3 from '@/assets/art-cirque-point-3-acrobaties.jpg';
import scenePoint1Swing from '@/assets/scene-point-1-swing.webp';
import scenePoint4ComedieMusicale from '@/assets/scene-point-4-comedie-musicale.webp';
import scenePoint6Humour from '@/assets/scene-point-6-humour.webp';
import scenePoint7Danseur from '@/assets/scene-point-7-danseur.webp';
import scenePoint8Flair from '@/assets/scene-point-8-flair.webp';
import scenePoint9Hypnotiseur from '@/assets/scene-point-9-hypnotiseur.webp';
import scenePoint10Magie from '@/assets/scene-point-10-magie.webp';
import scenePoint12Led from '@/assets/scene-point-12-led.webp';
import scenePoint13Sosie from '@/assets/scene-point-13-sosie.webp';
import artsVisuelsContent1 from '@/assets/arts-visuels-content-1-v2.png';
import avBodyPaintingGala from '@/assets/arts-visuels-content-1.jpg';
import artsVisuelsContent2 from '@/assets/av-caricaturiste-plein-air.png';
import artsVisuelsContent3 from '@/assets/arts-visuels-content-3-v2.png';
import artsVisuelsContent4 from '@/assets/arts-visuels-content-04.webp';
import artsVisuelsPoint1 from '@/assets/arts-visuels-point-1-body-painting.png';
import artsVisuelsPoint2 from '@/assets/arts-visuels-point-2-caricaturiste.png';
import artsVisuelsPoint3 from '@/assets/av-speedpainting-mariage-duo.jpg';
import sportSpectacleContent1 from '@/assets/sport-spectacle-content-1.jpg';
import sportSpectacleContent2 from '@/assets/sport-spectacle-content-2.jpg';
import sportSpectacleContent3 from '@/assets/sport-spectacle-content-03.webp';
import sportPoint1Shows from '@/assets/sport-new-basket-freestyle-02.png';
import sportPoint2Football from '@/assets/sports-point-2-football-freestyle.png';
import sportPoint3Bmx from '@/assets/sport-new-bmx-freestyle.png';
import lieuxReceptionC1 from '@/assets/lieux-reception-point-1-exception.png';
import lieuxReceptionC2 from '@/assets/lieux-reception-content-02.jpg';
import lieuxReceptionC3 from '@/assets/lieux-reception-content-03.jpg';
import lieuxReceptionC4 from '@/assets/lieux-reception-content-04.jpg';
import liChateau01 from '@/assets/lieux-reception-content-01.jpg';
import liChateau02 from '@/assets/lieux-reception-chateau-02.webp';
import liChateau03 from '@/assets/lieux-reception-chateau-03.webp';
import liChateau04 from '@/assets/lieux-reception-chateau-04.webp';
import liChateau06 from '@/assets/lieux-reception-chateau-06.webp';
import liChateau07 from '@/assets/lieux-reception-chateau-07.webp';
import liChateau08 from '@/assets/lieux-reception-chateau-08.webp';
import liChateau09 from '@/assets/lieux-reception-chateau-09.webp';
import liChateau10 from '@/assets/lieux-reception-chateau-10.webp';
import liChateau11 from '@/assets/lieux-reception-chateau-11.webp';
import liChateau12 from '@/assets/lieux-reception-chateau-12.webp';
import liChateau13 from '@/assets/lieux-reception-chateau-13.webp';
import liChateau14 from '@/assets/lieux-reception-chateau-14.webp';
import liChateau15 from '@/assets/lieux-reception-chateau-15.webp';
import liChateau16 from '@/assets/lieux-reception-chateau-16.webp';
import restaurationC1 from '@/assets/restauration-point-1-traiteurs.jpg';
import restaurationC2 from '@/assets/restauration-point-2-foodtrucks.png';
import restaurationC3 from '@/assets/restauration-point-3-patisserie.png';
import restaurationC4 from '@/assets/restauration-point-4-bars.png';
import imageSouvenirsC1 from '@/assets/image-souvenirs-content-02-replacement.png';
import imageSouvenirsC2 from '@/assets/image-souvenirs-content-03-replacement.png';
import imageSouvenirsC3 from '@/assets/image-souvenirs-content-04-replacement.png';
import imageSouvenirsC4 from '@/assets/image-souvenirs-carousel-03.jpg';
import beauteBienEtrePremium from '@/assets/beaute-point-4-bien-etre-premium.png';
import beautePoint1Maquillage from '@/assets/beaute-carousel-34.jpg';
import beauteBabysittingPremium from '@/assets/beaute-content-babysitting-premium.png';
import transportC1 from '@/assets/transport-carousel-01.png';
import transportC2 from '@/assets/transport-carousel-caleche-02.webp';
import transportC3 from '@/assets/transport-content-03.png';
import aventureC1 from '@/assets/aventure-content-01.jpg';
import aventureC2 from '@/assets/aventure-carousel-06.webp';
import aventureC3 from '@/assets/aventure-carousel-13.jpg';
import aventureOutdoor from '@/assets/aventure-carousel-07.jpg';
import aventureBienetre from '@/assets/aventure-carousel-15.jpg';
import artistMagic from '@/assets/artist-magic.jpg';
import artistBand from '@/assets/artist-band.jpg';
import artistPerformer from '@/assets/artist-performer.jpg';
import artistCircus from '@/assets/artist-circus.jpg';
import artistComedian from '@/assets/artist-comedian.jpg';
import artistPyro from '@/assets/artist-pyro.jpg';
import weddingDecoration from '@/assets/wedding-decoration.jpg';
import weddingPackSerenite from '@/assets/wedding-pack-serenite.jpg';
import weddingPackTranquillite from '@/assets/wedding-pack-tranquillite.jpg';
import feuDeJour6 from '@/assets/feu-de-jour-6.jpg';
import feuDeJour8 from '@/assets/location-carousel-10.png';
import catAnimateurMicro from '@/assets/cat-animateur-micro.jpg';
import catMusique from '@/assets/cat-musique.jpg';
import catArtRue from '@/assets/cat-art-rue.jpg';
import catArtScene from '@/assets/cat-art-scene.jpg';
import catArtCirque from '@/assets/cat-art-cirque.jpg';
import catArtsVisuels from '@/assets/cat-arts-visuels.jpg';
import catEnfants from '@/assets/cat-enfants.jpg';
import catSportSpectacle from '@/assets/cat-sport-spectacle.jpg';
import catLieuxReception from '@/assets/cat-lieux-reception.jpg';
import catRestaurationTraiteur from '@/assets/cat-restauration-traiteur.jpg';
import catImageSouvenirs from '@/assets/cat-image-souvenirs.jpg';
import catBeauteBienEtre from '@/assets/cat-beaute-bien-etre.jpg';
import catTransportVoyages from '@/assets/cat-transport-voyages.jpg';
import catAventureLoisirs from '@/assets/cat-aventure-loisirs.jpg';
import catMascottes from '@/assets/en-mascotte-11.jpg';
import catPhotobooth from '@/assets/photobooth-carousel-05.webp';

import wdCarousel01 from '@/assets/wedding-carousel-01.webp';
import wdCarousel02 from '@/assets/wedding-carousel-02.webp';
import wdCarousel03 from '@/assets/wedding-carousel-03.webp';
import wdCarousel04 from '@/assets/wedding-carousel-04.webp';
import wdCarousel05 from '@/assets/wedding-carousel-05.webp';
import wdCarousel06 from '@/assets/wedding-carousel-06.webp';
import wdCarousel07 from '@/assets/wedding-carousel-07.webp';
import wdCarousel08 from '@/assets/wedding-carousel-08.webp';
import wdCarousel09 from '@/assets/wedding-carousel-09.webp';
import wdCarousel10 from '@/assets/wedding-carousel-10.webp';
import wdCarousel11 from '@/assets/wedding-carousel-11.webp';
import wdCarousel12 from '@/assets/wedding-carousel-12.webp';
import wdCarousel13 from '@/assets/wedding-carousel-13.webp';
import wdCarousel14 from '@/assets/wedding-carousel-14.webp';
import wdCarousel15 from '@/assets/wedding-carousel-15.webp';
import wdCarousel16 from '@/assets/wedding-carousel-16.webp';
import wdCarousel17 from '@/assets/wedding-carousel-17.webp';
import wdCarousel18 from '@/assets/wedding-carousel-18.webp';
import wdCarousel19 from '@/assets/wedding-carousel-19.webp';
import wdCarousel20 from '@/assets/wedding-carousel-20.webp';
import wdCarousel21 from '@/assets/wedding-carousel-21.webp';
import wdCarousel22 from '@/assets/wedding-carousel-22.webp';
import wdCarousel23 from '@/assets/wedding-carousel-23.webp';
import wdCarousel24 from '@/assets/wedding-carousel-24.webp';
import wdCarousel25 from '@/assets/wedding-carousel-25.webp';
import wdCarousel26 from '@/assets/wedding-carousel-26.webp';
import wdCarousel27 from '@/assets/wedding-carousel-27.webp';
import wdCarousel28 from '@/assets/wedding-carousel-28.webp';
import wdCarousel29 from '@/assets/wedding-carousel-29.webp';
import wdCarousel30 from '@/assets/wedding-carousel-30.webp';
import wdCarousel31 from '@/assets/wedding-carousel-31.webp';
import wdCarousel32 from '@/assets/wedding-carousel-32.webp';
import wdCarousel33 from '@/assets/wedding-carousel-33.webp';
import wdCarousel34 from '@/assets/wedding-carousel-34.webp';
import wdCarousel35 from '@/assets/wedding-carousel-35.webp';

import ofCarousel01 from '@/assets/officiant-carousel-01.webp';
import ofCarousel02 from '@/assets/officiant-carousel-02.webp';
import ofCarousel03 from '@/assets/officiant-carousel-03.webp';
import ofCarousel04 from '@/assets/officiant-carousel-04.webp';
import ofCarousel05 from '@/assets/officiant-carousel-05.webp';
import ofCarousel06 from '@/assets/officiant-carousel-06.webp';
import ofCarousel07 from '@/assets/officiant-carousel-07.webp';
import ofCarousel08 from '@/assets/officiant-carousel-08.webp';
import ofCarousel09 from '@/assets/officiant-carousel-09.webp';
import ofCarousel11 from '@/assets/officiant-carousel-11.webp';
import ofCarousel12 from '@/assets/officiant-carousel-12.webp';
import ofCarousel13 from '@/assets/officiant-carousel-13.webp';
import ofCarousel14 from '@/assets/officiant-carousel-14.webp';
import ofCarousel15 from '@/assets/officiant-carousel-15.webp';
import ofCarousel16 from '@/assets/officiant-carousel-16.webp';
import ofCarousel17 from '@/assets/officiant-carousel-17.webp';
import ofCarousel18 from '@/assets/officiant-carousel-18.webp';
import ofCarousel19 from '@/assets/officiant-carousel-19.webp';
import ofCarousel20 from '@/assets/officiant-carousel-20.webp';
import ofCarousel21 from '@/assets/officiant-carousel-21.webp';
import ofCarousel22 from '@/assets/officiant-carousel-22.webp';
import ofCarousel23 from '@/assets/officiant-carousel-23.webp';
import ofCarousel24 from '@/assets/officiant-carousel-24.webp';
import ceCarousel01 from '@/assets/ceremonie-carousel-01.webp';
import ceCarousel02 from '@/assets/ceremonie-carousel-02.webp';
import ceCarousel04 from '@/assets/ceremonie-carousel-04.webp';
import ceCarousel05 from '@/assets/ceremonie-carousel-05.webp';
import ceCarousel06 from '@/assets/ceremonie-carousel-06.webp';
import ceCarousel07 from '@/assets/ceremonie-carousel-07.webp';
import ceCarousel08 from '@/assets/ceremonie-carousel-08.webp';
import ceCarousel09 from '@/assets/ceremonie-carousel-09.webp';
import ceCarousel10 from '@/assets/ceremonie-carousel-10.webp';
import ceCarousel11 from '@/assets/ceremonie-carousel-11.webp';
import ceCarousel12 from '@/assets/ceremonie-carousel-12.webp';
import ceCarousel13 from '@/assets/ceremonie-carousel-13.webp';
import ceCarousel14 from '@/assets/ceremonie-carousel-14.webp';
import ceCarousel15 from '@/assets/ceremonie-carousel-15.webp';
import ceCarousel16 from '@/assets/ceremonie-carousel-16.webp';
import ceCarousel17 from '@/assets/ceremonie-carousel-17.webp';
import ceCarousel18 from '@/assets/ceremonie-carousel-18.webp';
import ceCarousel19 from '@/assets/ceremonie-carousel-19.webp';
import ceCarousel20 from '@/assets/ceremonie-carousel-20.webp';
import ceCarousel21 from '@/assets/ceremonie-carousel-21.webp';
import ceCarousel22 from '@/assets/ceremonie-carousel-22.webp';
import ceCarousel23 from '@/assets/ceremonie-carousel-23.webp';
import ceCarousel24 from '@/assets/ceremonie-carousel-24.webp';
import ceCarousel25 from '@/assets/ceremonie-carousel-25.webp';
import ceCarousel26 from '@/assets/ceremonie-carousel-26.webp';
import ceCarousel27 from '@/assets/ceremonie-carousel-27.webp';
import ceCarousel28 from '@/assets/ceremonie-carousel-28.webp';
import ceCarousel29 from '@/assets/ceremonie-carousel-29.webp';
import ceCarousel30 from '@/assets/ceremonie-carousel-30.webp';
import ceCarousel31 from '@/assets/ceremonie-carousel-31.webp';
import ceCarousel32 from '@/assets/ceremonie-carousel-32.webp';
import ceCarousel33 from '@/assets/ceremonie-carousel-33.webp';
import ceCarousel34 from '@/assets/ceremonie-carousel-34.webp';
import ceCarousel35 from '@/assets/ceremonie-carousel-35.webp';
import ceCarousel38 from '@/assets/ceremonie-carousel-38.webp';
import ceCarousel40 from '@/assets/ceremonie-carousel-40.webp';
import ceCarousel41 from '@/assets/ceremonie-carousel-41.webp';
import ceCarousel42 from '@/assets/ceremonie-carousel-42.webp';
import ceCarousel43 from '@/assets/ceremonie-carousel-43.webp';
import ceCarousel44 from '@/assets/ceremonie-carousel-44.webp';
import ceCarousel45 from '@/assets/ceremonie-carousel-45.webp';
import ceCarousel47 from '@/assets/ceremonie-carousel-47.webp';
import ceCarousel48 from '@/assets/ceremonie-carousel-48.webp';
import ceCarousel49 from '@/assets/ceremonie-carousel-49.webp';
import ceCarousel50 from '@/assets/ceremonie-carousel-50.webp';
import ceCarousel51 from '@/assets/ceremonie-carousel-51.webp';
import ceCarousel52 from '@/assets/ceremonie-carousel-52.webp';
import ceCarousel53 from '@/assets/ceremonie-carousel-53.webp';
import ceCarousel54 from '@/assets/ceremonie-carousel-54.webp';


import arCarousel01 from '@/assets/art-rue-aaa-fanfare-cover.webp';
import arCarousel02 from '@/assets/artrue-carousel-02.webp';
import arCarousel03 from '@/assets/artrue-carousel-03.webp';
import arCarousel04 from '@/assets/artrue-carousel-04.webp';
import arCarousel05 from '@/assets/artrue-carousel-05.webp';
import arCarousel06 from '@/assets/artrue-carousel-06.webp';
import arCarousel07 from '@/assets/artrue-carousel-07.webp';
import arCarousel08 from '@/assets/artrue-carousel-08.webp';
import arCarousel09 from '@/assets/artrue-carousel-09.webp';
import arCarousel10 from '@/assets/artrue-carousel-10.webp';
import arCarousel11 from '@/assets/artrue-carousel-11.webp';
import arCarousel12 from '@/assets/artrue-carousel-12.webp';
import arCarousel13 from '@/assets/artrue-carousel-13.webp';
import arCarousel14 from '@/assets/artrue-carousel-14.webp';
import arCarousel15 from '@/assets/artrue-carousel-15.webp';
import arCarousel16 from '@/assets/artrue-carousel-16.webp';
import arCarousel17 from '@/assets/artrue-carousel-17.webp';
import arCarousel18 from '@/assets/artrue-carousel-18.webp';
import arCarousel19 from '@/assets/artrue-carousel-19.webp';
import arCarousel20 from '@/assets/artrue-carousel-20.webp';
import arCarousel21 from '@/assets/artrue-carousel-21.webp';
import arCarousel22 from '@/assets/artrue-carousel-22.webp';
import arCarousel23 from '@/assets/artrue-carousel-23.webp';
import arCarousel24 from '@/assets/artrue-carousel-24.webp';
import arCarousel25 from '@/assets/artrue-carousel-25.webp';
import artRueContent3 from '@/assets/art-rue-content-3.jpg';
import artRueContent4 from '@/assets/art-rue-content-4.jpg';
import artRuePoint1Cascadeur from '@/assets/art-rue-point-1-cascadeur.jpg';
import artRuePoint3CirqueDeRue from '@/assets/art-rue-point-3-cirque-de-rue.jpg';
import artRuePoint4Echassier from '@/assets/art-rue-point-4-echassier.png';
import artRuePoint5Fanfare from '@/assets/art-rue-point-5-fanfare.png';
import artRuePoint6FeuPyroLed from '@/assets/art-rue-point-6-feu-pyrotechnie-led.jpg';
import artRuePoint10MimeStatue from '@/assets/art-rue-mime-06.png';
import artRueMime01 from '@/assets/art-rue-mime-01.png';
import artRueMime02 from '@/assets/art-rue-mime-02.png';
import artRueMime04 from '@/assets/art-rue-mime-04.png';
import artRueMime07 from '@/assets/art-rue-mime-07.png';
import artRueMime08 from '@/assets/art-rue-mime-08.png';
import artRueMime378 from '@/assets/art-rue-mime-378.png';
import artRueMime379 from '@/assets/art-rue-mime-379.png';
import artRueMusique01 from '@/assets/art-rue-musique-01.png';
import artRueMusique02 from '@/assets/art-rue-musique-02.png';
import artRueMusique03 from '@/assets/art-rue-musique-03.png';
import artRueMusique04 from '@/assets/art-rue-musique-04.png';
import artRueMusique06 from '@/assets/art-rue-musique-06.png';
import artRueMusique07 from '@/assets/art-rue-musique-07.png';
import artRueMusique08 from '@/assets/art-rue-musique-08.png';
import artRueMusique09 from '@/assets/art-rue-musique-09.png';
import artRueMusique10 from '@/assets/art-rue-musique-10.png';
import artRueDanse01 from '@/assets/art-rue-danse-01.jpg';
import artRueDanse02 from '@/assets/art-rue-danse-02.jpg';
import artRueDanse03 from '@/assets/art-rue-danse-03.jpg';
import artRueDanse04 from '@/assets/art-rue-danse-04.jpg';
import artRueDanse05 from '@/assets/art-rue-danse-05.jpg';
import artRueDanse06 from '@/assets/art-rue-danse-06.png';
import artRueDanse07 from '@/assets/art-rue-danse-07.png';
import artRueDanse08 from '@/assets/art-rue-danse-08.png';
import artRueDanse09 from '@/assets/art-rue-danse-09.png';
import artRueDanse10 from '@/assets/art-rue-danse-10.png';
import artRueDanse11 from '@/assets/art-rue-danse-11.png';
import artRueDanse12 from '@/assets/art-rue-danse-12.png';
import artRueDanse13 from '@/assets/art-rue-danse-13.png';
import artRueDanse14 from '@/assets/art-rue-danse-14.png';
import artRueDanse15 from '@/assets/art-rue-danse-15.png';
import artRueDanse16 from '@/assets/art-rue-danse-16.png';
import artRueDanse17 from '@/assets/art-rue-danse-17.png';
import artRueLed01 from '@/assets/art-rue-led-01.png';
import asCarousel01 from '@/assets/artscene-carousel-01.webp';
import asCarousel02 from '@/assets/artscene-carousel-02.webp';
import asCarousel03 from '@/assets/artscene-carousel-03.webp';
import asCarousel04 from '@/assets/artscene-carousel-04.webp';
import asCarousel05 from '@/assets/artscene-carousel-05.webp';
import asCarousel06 from '@/assets/artscene-carousel-06.webp';
import asCarousel07 from '@/assets/artscene-carousel-07.webp';
import asCarousel08 from '@/assets/artscene-carousel-08.webp';
import asCarousel09 from '@/assets/artscene-carousel-09.webp';
import asCarousel10 from '@/assets/artscene-carousel-10.webp';
import asCarousel11 from '@/assets/artscene-carousel-11.webp';
import asCarousel12 from '@/assets/artscene-carousel-12.webp';
import asCarousel13 from '@/assets/artscene-carousel-13.webp';
import asCarousel14 from '@/assets/artscene-carousel-14.webp';
import asCarousel15 from '@/assets/artscene-carousel-15.webp';
import asCarousel16 from '@/assets/artscene-carousel-16.webp';
import asCarousel17 from '@/assets/artscene-carousel-17.webp';
import asCarousel18 from '@/assets/artscene-carousel-18.webp';
import asCarousel19 from '@/assets/artscene-carousel-19.webp';
import asCarousel20 from '@/assets/artscene-carousel-20.webp';
import asCarousel21 from '@/assets/artscene-carousel-21.webp';
import asCarousel22 from '@/assets/artscene-carousel-22.webp';
import asCarousel23 from '@/assets/artscene-carousel-23.webp';
import asCarousel24 from '@/assets/artscene-carousel-24.webp';
import asCarousel25 from '@/assets/artscene-carousel-25.webp';
import avSilhouettistePortraitRue from '@/assets/av-silhouettiste-portrait-rue.png';
import avSilhouettisteRue from '@/assets/av-silhouettiste-rue.png';
import avCaricatureRibery from '@/assets/av-caricature-ribery.png';
import avCaricatureGainsbourg from '@/assets/av-caricature-gainsbourg.png';
import avCaricaturesFamille from '@/assets/av-caricatures-famille.png';
import avCaricaturesHumoristiques from '@/assets/av-caricatures-humoristiques.png';
import avSilhouettePrecision from '@/assets/av-silhouette-precision.png';
import avGarconPortraitCaricatural from '@/assets/av-garcon-portrait-caricatural.png';
import avSpeedpaintingChevalLive from '@/assets/av-speedpainting-cheval-live.jpeg';
import avSpeedpaintingDuoNeon from '@/assets/av-speedpainting-duo-neon.jpg';
import avSpeedpaintingScenePortrait from '@/assets/av-speedpainting-scene-portrait.png';
import avGlitterMercedesClasseB from '@/assets/av-glitter-mercedes-classe-b.jpg';
import avSpeedpaintingScenePortrait2 from '@/assets/av-speedpainting-scene-portrait-2.png';
import avGlitterMercedesLogo from '@/assets/av-glitter-mercedes-logo.jpg';
import avGlitterMariagePoussiere from '@/assets/av-glitter-mariage-poussiere.png';
import avGlitterPortraitFemme from '@/assets/av-glitter-portrait-femme.png';
import avGlitterCitroenStage from '@/assets/av-glitter-citroen-stage.jpg';
import avGlitterMariageCoupleCouleurs from '@/assets/av-glitter-mariage-couple-couleurs.png';
import avGlitterDsAutomobiles from '@/assets/av-glitter-ds-automobiles.jpg';
import avSpeedpaintingPortraitDuoBleu from '@/assets/av-speedpainting-portrait-duo-bleu.png';
import avGlitterPortraitHommeCigarette from '@/assets/av-glitter-portrait-homme-cigarette.jpg';
import avSpeedpaintingCoupleAtelier from '@/assets/av-speedpainting-couple-atelier.png';
import avGlitterGainsbourgBirkin from '@/assets/av-glitter-gainsbourg-birkin.jpg';
import avArtsVisuelsCollage from '@/assets/av-arts-visuels-collage.png';
import enAtelierCreatif01 from '@/assets/en-atelier-creatif-01.webp';
import enAtelierCreatif02 from '@/assets/en-atelier-creatif-02.webp';
import enAtelierCreatif03 from '@/assets/en-atelier-creatif-03.webp';
import enAtelierCreatif04 from '@/assets/en-atelier-creatif-04.webp';
import enAtelierCreatif05 from '@/assets/en-atelier-creatif-05.webp';
import enAtelierCreatif06 from '@/assets/en-atelier-creatif-06.webp';
import enAtelierCreatif07 from '@/assets/en-atelier-creatif-07.webp';
import enAtelierCreatif08 from '@/assets/en-atelier-creatif-08.webp';
import enAtelierCreatif09 from '@/assets/en-atelier-creatif-09.webp';
import enAtelierCreatif10 from '@/assets/en-atelier-creatif-10.webp';
import enChasseTresor01 from '@/assets/en-chasse-tresor-01.png';
import enChasseTresor02 from '@/assets/en-chasse-tresor-02.png';
import enChasseTresor03 from '@/assets/en-chasse-tresor-03.png';
import enChasseTresor04 from '@/assets/en-chasse-tresor-04.png';
import enChasseTresor05 from '@/assets/en-chasse-tresor-05.png';
import enChasseTresor06 from '@/assets/en-chasse-tresor-06.png';
import enChasseTresor07 from '@/assets/en-chasse-tresor-07.png';
import enChasseTresor08 from '@/assets/en-chasse-tresor-08.png';
import enCirqueClown01 from '@/assets/en-cirque-clown-01.jpg';
import enCirqueClown02 from '@/assets/en-cirque-clown-02.jpg';
import enCirqueClown03 from '@/assets/en-cirque-clown-03.jpg';
import enCirqueClown04 from '@/assets/en-cirque-clown-04.jpg';
import enCirqueClown05 from '@/assets/en-cirque-clown-05.jpg';
import enCirqueClown06 from '@/assets/en-cirque-clown-06-replacement.webp';
import enCirqueClown07 from '@/assets/en-cirque-clown-07.png';
import enCirqueClown08 from '@/assets/en-cirque-clown-08.png';
import enCirqueClown09 from '@/assets/en-cirque-clown-09.jpg';
import enCarousel06 from '@/assets/enfants-carousel-06.webp';
import enCarousel07 from '@/assets/enfants-carousel-07.webp';
import enCarousel08 from '@/assets/enfants-carousel-08.webp';
import enCirqueClown10 from '@/assets/en-cirque-clown-10-replacement.webp';
import enCirqueNoel01 from '@/assets/en-cirque-noel-01.png';
import enConteEnfants01 from '@/assets/en-conte-enfants-01-replacement.webp';
import enConteEnfants02 from '@/assets/en-conte-enfants-02.png';
import enConteEnfants03 from '@/assets/en-conte-enfants-03.png';
import enConteEnfants04 from '@/assets/en-conte-enfants-04.png';
import enConteEnfants05 from '@/assets/en-conte-enfants-05.png';
import enConteEnfants06 from '@/assets/en-conte-enfants-06.png';
import enConteEnfants07 from '@/assets/en-conte-enfants-07.png';
import enConteEnfants08 from '@/assets/en-conte-enfants-08.png';
import enConteEnfants09 from '@/assets/en-conte-enfants-09.png';
import enConteEnfants10 from '@/assets/en-conte-enfants-10.png';
import enConteEnfants11 from '@/assets/en-conte-enfants-11.png';
import enConteEnfants12 from '@/assets/en-conte-enfants-12.png';
import enEscapeGame01 from '@/assets/en-escape-game-01.png';
import enEscapeGame02 from '@/assets/en-escape-game-02.png';
import enEscapeGame03 from '@/assets/en-escape-game-03.png';
import enEscapeGame04 from '@/assets/en-escape-game-04.png';
import enEscapeGame05 from '@/assets/en-escape-game-05.png';
import enEscapeGame06 from '@/assets/en-escape-game-06.png';
import enEscapeGame07 from '@/assets/en-escape-game-07.png';
import enEscapeGame08 from '@/assets/en-escape-game-08.png';
import enEscapeGame09 from '@/assets/en-escape-game-09.png';
import enEscapeGame10 from '@/assets/en-escape-game-10.png';
import enMaquillageTatouage01 from '@/assets/en-maquillage-tatouage-01.jpg';
import enMaquillageTatouage02 from '@/assets/en-maquillage-tatouage-02.png';
import enMaquillageTatouage03 from '@/assets/en-maquillage-tatouage-03.jpg';
import enMaquillageTatouage04 from '@/assets/en-maquillage-tatouage-04.png';
import enMaquillageTatouage05 from '@/assets/en-maquillage-tatouage-05.jpg';
import enMaquillageTatouage06 from '@/assets/en-maquillage-tatouage-06.png';
import enMaquillageTatouage07 from '@/assets/en-maquillage-tatouage-07.png';
import enMaquillageTatouage08 from '@/assets/en-maquillage-tatouage-08.png';
import enMaquillageTatouage09 from '@/assets/en-maquillage-tatouage-09.png';
import enMaquillageTatouage10 from '@/assets/en-maquillage-tatouage-10.png';
import enMaquillageTatouage11 from '@/assets/en-maquillage-tatouage-11.png';
import enMaquillageTatouage12 from '@/assets/en-maquillage-tatouage-12.jpg';
import enMaquillageTatouage13 from '@/assets/en-maquillage-tatouage-13.png';
import enMaquillageTatouage14 from '@/assets/en-maquillage-tatouage-14.jpg';
import enMaquillageTatouage15 from '@/assets/en-maquillage-tatouage-15.png';
import enMaquillageTatouage16 from '@/assets/en-maquillage-tatouage-16.jpg';
import enMaquillageTatouage17 from '@/assets/en-maquillage-tatouage-17.png';
import enMaquillageTatouage18 from '@/assets/en-maquillage-tatouage-18.jpg';
import enMaquillageTatouage19 from '@/assets/en-maquillage-tatouage-19.png';
import enMaquillageTatouage20 from '@/assets/en-maquillage-tatouage-20.jpg';
import enMaquillageTatouage21 from '@/assets/en-maquillage-tatouage-21.jpg';
import enMaquillageTatouage22 from '@/assets/en-maquillage-tatouage-22.jpg';
import enMaquillageTatouage23 from '@/assets/en-maquillage-tatouage-23-replacement.webp';
import feuDeJourContent1 from '@/assets/feu-de-jour-carousel-01.webp';
import feuDeJourContent2 from '@/assets/feu-de-jour-carousel-02.webp';
import feuDeJourContent3 from '@/assets/feu-de-jour-carousel-08.webp';
import feuDeJourContent4 from '@/assets/feu-de-jour-carousel-15.webp';
import enMascotte01 from '@/assets/en-mascotte-01.jpg';
import enMascotte02 from '@/assets/en-mascotte-02.png';
import enMascotte03 from '@/assets/en-mascotte-03.jpg';
import enMascotte04 from '@/assets/en-mascotte-04.png';
import enMascotte05 from '@/assets/en-mascotte-05.png';
import enMascotte06 from '@/assets/en-mascotte-06.jpg';
import enMascotte07 from '@/assets/en-mascotte-07.png';
import enMascotte08 from '@/assets/en-mascotte-08.png';
import enMascotte09 from '@/assets/en-mascotte-09.jpg';
import enMascotte10 from '@/assets/en-mascotte-10.png';
import enMascotte12 from '@/assets/en-mascotte-12.png';
import enChasseOeufs01 from '@/assets/en-chasse-oeufs-01.png';
import enPereNoel01 from '@/assets/en-pere-noel-01.png';
import enPereNoel10 from '@/assets/en-pere-noel-03.png';
import enStructureGonflable30 from '@/assets/en-structure-gonflable-02.png';
import enPereNoel02 from '@/assets/en-pere-noel-02.png';
import enPereNoel04 from '@/assets/en-pere-noel-04.png';
import enBallon01 from '@/assets/en-ballon-01.png';
import enBallon02 from '@/assets/en-ballon-02.jpg';
import enBallon03 from '@/assets/en-ballon-03.png';
import enBallon04 from '@/assets/en-ballon-04.jpg';
import enBallon05 from '@/assets/en-ballon-05.jpg';
import enBallon06 from '@/assets/en-ballon-06.png';
import enBallon07 from '@/assets/en-ballon-07.jpg';
import enBallon08 from '@/assets/en-ballon-08.png';
import enBallon09 from '@/assets/en-ballon-09.png';
import enStructureGonflable01 from '@/assets/en-structure-gonflable-01.jpg';
import enStructureGonflable03 from '@/assets/en-structure-gonflable-03.jpg';
import enStructureGonflable04 from '@/assets/en-structure-gonflable-04.png';
import enStructureGonflable05 from '@/assets/en-structure-gonflable-05.jpg';
import enStructureGonflable06 from '@/assets/en-structure-gonflable-06.png';
import enStructureGonflable07 from '@/assets/en-structure-gonflable-07.jpg';
import enStructureGonflable08 from '@/assets/en-structure-gonflable-08.jpg';
import enStructureGonflable09 from '@/assets/en-structure-gonflable-09.jpg';
import enStructureGonflable10 from '@/assets/en-structure-gonflable-10.jpg';
import enStructureGonflable11 from '@/assets/en-structure-gonflable-11.jpg';
import enStructureGonflable12 from '@/assets/en-structure-gonflable-12.jpg';
import enStructureGonflable13 from '@/assets/en-structure-gonflable-13.jpg';
import enStructureGonflable14 from '@/assets/en-structure-gonflable-14.jpg';
import enStructureGonflable15 from '@/assets/en-structure-gonflable-15.jpg';
import enStructureGonflable16 from '@/assets/en-structure-gonflable-16.jpg';
import enVentriloque01 from '@/assets/en-ventriloque-01.png';
import enVentriloque02 from '@/assets/en-ventriloque-02.png';
import enVentriloque03 from '@/assets/en-ventriloque-03.png';
import enVentriloque04 from '@/assets/en-ventriloque-04.png';
import enVentriloque05 from '@/assets/en-ventriloque-05.png';
import enVentriloque06 from '@/assets/en-ventriloque-06.png';
import enVentriloque07 from '@/assets/en-ventriloque-07-replacement.webp';
import enVentriloque08 from '@/assets/en-ventriloque-08.jpg';
import enVentriloque09 from '@/assets/en-ventriloque-09.png';
import enVentriloque10 from '@/assets/en-ventriloque-10.jpg';
import enVentriloque11 from '@/assets/en-ventriloque-11.png';
import enVentriloque12 from '@/assets/en-ventriloque-12.png';
import enStructureGonflable17 from '@/assets/en-structure-gonflable-17.jpg';
import enStructureGonflable18 from '@/assets/en-structure-gonflable-18.jpg';
import enCarousel15 from '@/assets/enfants-carousel-15.webp';
import amCarousel03 from '@/assets/animateur-carousel-03.png';
import amCarousel04 from '@/assets/animateur-carousel-04.png';
import amCarousel05 from '@/assets/animateur-carousel-05.png';
import muCarousel01 from '@/assets/musique-carousel-01.jpg';
import muCarousel02 from '@/assets/musique-carousel-02.png';
import muCarousel03 from '@/assets/musique-carousel-03.jpg';
import muCarousel04 from '@/assets/musique-carousel-04.jpg';
import muCarousel05 from '@/assets/musique-carousel-05.jpg';
import muCarousel06 from '@/assets/musique-carousel-06.png';
import muCarousel07 from '@/assets/musique-carousel-07.jpg';
import muCarousel08 from '@/assets/musique-carousel-08.jpg';
import muCarousel09 from '@/assets/musique-carousel-09.jpg';
import muCarousel10 from '@/assets/musique-carousel-10.jpg';
import muCarousel11 from '@/assets/musique-carousel-11.png';
import muCarousel12 from '@/assets/musique-carousel-12.jpg';
import muCarousel13 from '@/assets/musique-carousel-13.jpg';
import muCarousel14 from '@/assets/musique-carousel-14.jpg';
import muCarousel15 from '@/assets/musique-carousel-15.png';
import muCarousel16 from '@/assets/musique-carousel-16.jpg';
import muCarousel17 from '@/assets/musique-carousel-17.png';
import muCarousel18 from '@/assets/musique-carousel-18.jpg';
import muCarousel19 from '@/assets/musique-carousel-19.png';
import muCarousel20 from '@/assets/musique-carousel-20.jpg';
import muCarousel21 from '@/assets/musique-carousel-21.png';
import muCarousel22 from '@/assets/musique-carousel-22.jpg';
import muCarousel23 from '@/assets/musique-carousel-23.png';
import muCarousel24 from '@/assets/musique-carousel-24.jpg';
import muCarousel25 from '@/assets/musique-carousel-25.png';
import muCarousel26 from '@/assets/musique-carousel-26.jpg';
import muCarousel27 from '@/assets/musique-carousel-27.png';
import muCarousel28 from '@/assets/musique-carousel-28.jpg';
import muCarousel29 from '@/assets/musique-carousel-29.jpg';
import muCarousel30 from '@/assets/musique-carousel-30.jpg';
import muCarousel31 from '@/assets/musique-carousel-31.jpg';
import muCarousel32 from '@/assets/musique-carousel-32.jpg';
import muCarousel33 from '@/assets/musique-carousel-33.jpg';
import muCarousel52 from '@/assets/musique-carousel-52.webp';
import muCarousel53 from '@/assets/musique-carousel-53.webp';
import muCarousel54 from '@/assets/musique-carousel-54.webp';
import muCarousel55 from '@/assets/musique-carousel-55.webp';
import muCarousel56 from '@/assets/musique-carousel-56.webp';
import muCarousel57 from '@/assets/musique-carousel-57.webp';
import muCarousel58 from '@/assets/musique-carousel-58.webp';
import muCarousel59 from '@/assets/musique-carousel-59.webp';
import muCarousel60 from '@/assets/musique-carousel-60.webp';
import muCarousel61 from '@/assets/musique-carousel-61.webp';
import muCarousel62 from '@/assets/musique-carousel-62.webp';
import muCarousel63 from '@/assets/musique-carousel-63.webp';
import muCarousel64 from '@/assets/musique-carousel-64.webp';
import muCarousel65 from '@/assets/musique-carousel-65.webp';
import muCarousel66 from '@/assets/musique-carousel-66.webp';
import muCarousel67 from '@/assets/musique-carousel-67.webp';
import muCarousel68 from '@/assets/musique-carousel-68.webp';
import muCarousel69 from '@/assets/musique-carousel-69.webp';
import muCarousel70 from '@/assets/musique-carousel-70.webp';
import muCarousel71 from '@/assets/musique-carousel-71.webp';
import muCarousel72 from '@/assets/musique-carousel-72.webp';
import muCarousel73 from '@/assets/musique-carousel-73.webp';
import muCarousel74 from '@/assets/musique-carousel-74.webp';
import muCarousel75 from '@/assets/musique-carousel-75.webp';
import muCarousel76 from '@/assets/musique-carousel-76.webp';
import muCarousel77 from '@/assets/musique-carousel-77.webp';
import muCarousel78 from '@/assets/musique-carousel-78.webp';
import muCarousel79 from '@/assets/musique-carousel-79.webp';
import muCarousel80 from '@/assets/musique-carousel-80.webp';
import muCarousel81 from '@/assets/musique-carousel-81.webp';
import muCarousel82 from '@/assets/musique-carousel-82.webp';
import muCarousel83 from '@/assets/musique-carousel-83.webp';
import muCarousel84 from '@/assets/musique-carousel-84.webp';
import muCarousel85 from '@/assets/musique-carousel-85.webp';
import muCarousel86 from '@/assets/musique-carousel-86.webp';
import muCarousel87 from '@/assets/musique-carousel-87.webp';
import muCarousel88 from '@/assets/musique-carousel-88.webp';
import muCarousel89 from '@/assets/musique-carousel-89.webp';
import muCarousel90 from '@/assets/musique-carousel-90.webp';
import muCarousel91 from '@/assets/musique-carousel-91.webp';
import muCarousel92 from '@/assets/musique-carousel-92.webp';
import muCarousel93 from '@/assets/musique-carousel-93.webp';
import muCarousel94 from '@/assets/musique-carousel-94.webp';
import muCarousel95 from '@/assets/musique-carousel-95.webp';
import muCarousel96 from '@/assets/musique-carousel-96.webp';
import muCarousel97 from '@/assets/musique-carousel-97.webp';
import muCarousel98 from '@/assets/musique-carousel-98.webp';
import muCarousel99 from '@/assets/musique-carousel-99.webp';
import muCarousel100 from '@/assets/musique-carousel-100.webp';
import muCarousel101 from '@/assets/musique-carousel-101.webp';
import muCarousel102 from '@/assets/musique-carousel-102.webp';
import muCarousel103 from '@/assets/musique-carousel-103.webp';
import musiquePoint1Dj from '@/assets/musique-point-1-dj.jpg';
import musiquePoint2Groupe from '@/assets/musique-point-2-groupe.jpg';
import musiquePoint4Tribute from '@/assets/musique-point-4-tribute.png';
import muCarousel104 from '@/assets/musique-carousel-104.webp';
import muCarousel105 from '@/assets/musique-carousel-105.webp';
import muCarousel106 from '@/assets/musique-carousel-106.webp';
import muCarousel107 from '@/assets/musique-carousel-107.webp';
import muCarousel108 from '@/assets/musique-carousel-108.webp';
import muCarousel109 from '@/assets/musique-carousel-109.webp';
import muCarousel110 from '@/assets/musique-carousel-110.webp';
import muCarousel111 from '@/assets/musique-carousel-111.webp';
import muCarousel112 from '@/assets/musique-carousel-112.webp';
import muCarousel113 from '@/assets/musique-carousel-113.webp';
import muCarousel114 from '@/assets/musique-carousel-114.webp';
import muCarousel115 from '@/assets/musique-carousel-115.webp';
import muCarousel116 from '@/assets/musique-carousel-116.webp';
import ciCarousel01 from '@/assets/cirque-carousel-01.webp';
import ciCarousel02 from '@/assets/cirque-carousel-02.webp';
import ciCarousel03 from '@/assets/cirque-carousel-03.webp';
import ciCarousel04 from '@/assets/cirque-carousel-04.webp';
import ciCarousel05 from '@/assets/cirque-carousel-05.webp';
import ciCarousel06 from '@/assets/cirque-carousel-06.webp';
import ciCarousel07 from '@/assets/cirque-carousel-07.webp';
import ciCarousel08 from '@/assets/cirque-carousel-08.webp';
import cirqueAcrobateSuspendu from '@/assets/cirque-acrobate-suspendu-vol.png';
import cirqueAcrobatesPyramide from '@/assets/cirque-acrobates-pyramide-brume.png';
import cirqueAerialisteTheatre from '@/assets/cirque-aerialiste-theatre.png';
import cirqueArtisteCerceaux from '@/assets/cirque-artiste-cerceaux.png';
import cirqueAthletePlanche from '@/assets/cirque-athlete-planche-scene.png';
import cirqueContorsionnisteEquilibre from '@/assets/cirque-contorsionniste-equilibre-bleu.png';
import cirqueContorsionnistePerformance from '@/assets/cirque-contorsionniste-performance-acrobatique.png';
import cirqueContorsionnistePose from '@/assets/cirque-contorsionniste-pose-extreme.png';
import cirqueContorsionnisteDouce from '@/assets/cirque-contorsionniste-lumiere-douce.png';
import cirqueDanseAerienne from '@/assets/cirque-danse-aerienne-equilibre.png';
import cirqueDanseuseAiles from '@/assets/cirque-danseuse-ailes-translucides.png';
import cirqueDuetAerien from '@/assets/cirque-duet-aerien-dramatique.png';
import cirqueJongleurDiabolo from '@/assets/cirque-jongleur-diabolo-noire.png';
import cirqueArcherPomme from '@/assets/cirque-archer-pomme-equilibre.png';
import cirqueDuoPluie from '@/assets/cirque-duo-pluie-aerien.jpg';
import cirqueDuoClowns from '@/assets/cirque-duo-clowns-parapluies.jpg';
import cirqueClownScene from '@/assets/cirque-clown-scene-rouge.jpg';
import cirqueCerceauSpotlight from '@/assets/cirque-cerceau-spotlight.jpg';
import cirqueElfeNoel from '@/assets/cirque-elfe-noel.jpg';
import cirqueClownBouleCristal from '@/assets/cirque-clown-boule-cristal.jpg';
import cirqueAcrobateCannes from '@/assets/cirque-acrobate-cannes.jpg';
import cirqueEquilibreBallon from '@/assets/cirque-equilibre-ballon.jpg';
import cirqueClownJauneVelo from '@/assets/cirque-clown-jaune-velo.jpg';
import spCarousel01 from '@/assets/sport-carousel-01.webp';
import spCarousel02 from '@/assets/sport-carousel-02.webp';
import spCarousel03 from '@/assets/sport-carousel-03.webp';
import spCarousel04 from '@/assets/sport-carousel-04.webp';
import spCarousel05 from '@/assets/sport-carousel-05.webp';
import spCarousel06 from '@/assets/sport-carousel-06.webp';
import spCarousel07 from '@/assets/sport-carousel-07.webp';
import spCarousel08 from '@/assets/sport-carousel-08.webp';
import spCarousel09 from '@/assets/sport-carousel-09.webp';
import spCarousel10 from '@/assets/sport-carousel-10.webp';
import spCarousel11 from '@/assets/sport-carousel-11.webp';
import spCarousel12 from '@/assets/sport-carousel-12.webp';
import spCarousel13 from '@/assets/sport-carousel-13.webp';
import spCarousel14 from '@/assets/sport-carousel-14.webp';
import spCarousel15 from '@/assets/sport-carousel-15.webp';
import spCarousel16 from '@/assets/sport-carousel-16.webp';
import spCarousel17 from '@/assets/sport-carousel-17.webp';
import spCarousel18 from '@/assets/sport-carousel-18.webp';
import spCarousel19 from '@/assets/sport-carousel-19.webp';
import spCarousel20 from '@/assets/sport-carousel-20.webp';
import spCarousel21 from '@/assets/sport-carousel-21.webp';
import spNew01 from '@/assets/sport-new-art-martial-01.png';
import spNew03 from '@/assets/sport-new-basket-freestyle-01.png';
import spNew04 from '@/assets/sport-new-bmx-02.jpg';
import spNew06 from '@/assets/sport-new-bmx-01.jpg';
import spNew07 from '@/assets/sport-new-bmx-scene.png';
import spNew08 from '@/assets/sport-new-danse-gymnastique.png';
import spNew09 from '@/assets/sport-new-danseur-aerien-09.png';
import spNew10 from '@/assets/sport-new-foot-freestyle-10.png';
import spNew11 from '@/assets/sport-new-moto-rodeo-11.png';
import spNew12 from '@/assets/sport-new-moto-voltige-12.png';
import spNew13 from '@/assets/sport-new-roller-13.png';
import spNew14 from '@/assets/sport-new-skateboard-14.png';
import spNew15 from '@/assets/sport-new-skateboard-15.png';
import spNew16 from '@/assets/sport-new-sport-combat-16.png';
import spNew17 from '@/assets/sport-new-double-dutch-17.png';
import spNew18 from '@/assets/sport-new-sport-street-18.png';
import spNew19 from '@/assets/sport-new-sport-street-19.png';
import spNew20 from '@/assets/sport-new-trampoline-20.png';
import spNew21 from '@/assets/sport-new-trial-bmx-moto-21.png';
import spNew22 from '@/assets/sport-new-velo-22.webp';

import liCarousel01 from '@/assets/lieux-carousel-01.webp';
import liCarousel02 from '@/assets/lieux-carousel-02.webp';
import liCarousel03 from '@/assets/lieux-carousel-03.webp';
import liCarousel04 from '@/assets/lieux-carousel-04.webp';
import liCarousel05 from '@/assets/lieux-carousel-05.webp';
import liCarousel06 from '@/assets/lieux-carousel-06.webp';
import liCarousel07 from '@/assets/lieux-carousel-07.webp';
import liCarousel08 from '@/assets/lieux-carousel-08.webp';
import liCarousel09 from '@/assets/lieux-carousel-09.webp';
import liCarousel10 from '@/assets/lieux-carousel-10.webp';
import liCarousel11 from '@/assets/lieux-carousel-11.webp';
import liCarousel12 from '@/assets/lieux-carousel-12.webp';
import liCarousel13 from '@/assets/lieux-carousel-13.webp';
import liCarousel14 from '@/assets/lieux-carousel-14.webp';
import liCarousel15 from '@/assets/lieux-carousel-15.webp';
import reCarousel01 from '@/assets/resto-carousel-01.webp';
import reCarousel02 from '@/assets/resto-carousel-02.webp';
import reCarousel03 from '@/assets/resto-carousel-03.webp';
import reCarousel04 from '@/assets/resto-carousel-04.webp';
import reCarousel05 from '@/assets/resto-carousel-05.webp';
import reCarousel06 from '@/assets/resto-carousel-06.webp';
import reCarousel07 from '@/assets/resto-carousel-07.webp';
import reCarousel08 from '@/assets/resto-carousel-08.webp';
import reCarousel09 from '@/assets/resto-carousel-09.webp';
import reCarousel10 from '@/assets/resto-carousel-10.webp';
import reCarousel11 from '@/assets/resto-carousel-11.webp';
import reCarousel12 from '@/assets/resto-carousel-12.webp';
import reCarousel13 from '@/assets/resto-carousel-13.webp';
import reCarousel14 from '@/assets/resto-carousel-14.webp';
import reCarousel15 from '@/assets/resto-carousel-15.webp';
import reCarousel16 from '@/assets/resto-carousel-16.webp';
import reCarousel17 from '@/assets/resto-carousel-17.webp';
import reCarousel18 from '@/assets/resto-carousel-18.webp';
import reCarousel19 from '@/assets/resto-carousel-19.webp';
import reCarousel20 from '@/assets/resto-carousel-20.webp';
import reCarousel21 from '@/assets/resto-carousel-21.webp';
import reCarousel22 from '@/assets/resto-carousel-22.webp';
import reCarousel23 from '@/assets/resto-carousel-23.webp';
import reCarousel24 from '@/assets/resto-carousel-24.webp';
import reCarousel25 from '@/assets/resto-carousel-25.webp';
import reCarousel26 from '@/assets/resto-carousel-26.webp';
import reCarousel27 from '@/assets/resto-carousel-27.webp';
import reCarousel28 from '@/assets/resto-carousel-28.webp';
import reCarousel29 from '@/assets/resto-carousel-29.webp';
import reCarousel30 from '@/assets/resto-carousel-30.webp';
import reCarousel31 from '@/assets/resto-carousel-31.webp';
import reCarousel32 from '@/assets/resto-carousel-32.webp';
import reCarousel33 from '@/assets/resto-carousel-33.webp';
import reCarousel35 from '@/assets/resto-carousel-35.webp';
import reCarousel36 from '@/assets/resto-carousel-36.webp';
import reCarousel37 from '@/assets/resto-carousel-37.webp';
import reCarousel38 from '@/assets/resto-carousel-38.webp';
import reCarousel39 from '@/assets/resto-carousel-39.webp';
import reCarousel40 from '@/assets/resto-carousel-40.webp';
import reCarousel41 from '@/assets/resto-carousel-41.webp';
import reCarousel42 from '@/assets/resto-carousel-42.webp';
import reCarousel43 from '@/assets/resto-carousel-43.webp';
import reCarousel44 from '@/assets/resto-carousel-44.webp';
import reCarousel45 from '@/assets/resto-carousel-45.webp';
import reCarousel46 from '@/assets/resto-carousel-46.webp';
import reCarousel47 from '@/assets/resto-carousel-47.webp';
import reCarousel48 from '@/assets/resto-carousel-48.webp';
import reCarousel49 from '@/assets/resto-carousel-49.webp';
import reCarousel50 from '@/assets/resto-carousel-50.webp';
import reCarousel51 from '@/assets/resto-carousel-51.webp';
import reCarousel52 from '@/assets/resto-carousel-52.webp';
import reCarousel53 from '@/assets/resto-carousel-53.webp';
import reCarousel54 from '@/assets/resto-carousel-54.webp';
import reCarousel55 from '@/assets/resto-carousel-55.webp';
import reCarousel56 from '@/assets/resto-carousel-56.webp';
import reCarousel57 from '@/assets/resto-carousel-57.webp';
import reCarousel58 from '@/assets/resto-carousel-58.webp';
import reCarousel59 from '@/assets/resto-carousel-59.webp';
import reCarousel60 from '@/assets/resto-carousel-60.webp';
import reCarousel61 from '@/assets/resto-carousel-61.webp';
import reCarousel62 from '@/assets/resto-carousel-62.webp';
import reCarousel63 from '@/assets/resto-carousel-63.webp';
import reCarousel64 from '@/assets/resto-carousel-64.webp';
import reCarousel65 from '@/assets/resto-carousel-65.webp';
import reCarousel66 from '@/assets/resto-carousel-66.webp';
import reCarousel67 from '@/assets/resto-carousel-67.webp';
import reCarousel68 from '@/assets/resto-carousel-68.webp';
import reCarousel69 from '@/assets/resto-carousel-69.webp';
import reCarousel70 from '@/assets/resto-carousel-70.webp';
import reCarousel71 from '@/assets/resto-carousel-71.webp';
import reCarousel72 from '@/assets/resto-carousel-72.webp';
import reCarousel73 from '@/assets/resto-carousel-73.webp';
import reCarousel74 from '@/assets/resto-carousel-74.webp';
import reCarousel75 from '@/assets/resto-carousel-75.webp';
import reCarousel76 from '@/assets/resto-carousel-76.webp';
import reCarousel77 from '@/assets/resto-carousel-77.webp';
import reCarousel78 from '@/assets/resto-carousel-78.webp';
import reCarousel79 from '@/assets/resto-carousel-79.webp';
import reCarousel80 from '@/assets/resto-carousel-80.webp';
import reCarousel81 from '@/assets/resto-carousel-81.webp';
import reCarousel82 from '@/assets/resto-carousel-82.webp';
import reCarousel83 from '@/assets/resto-carousel-83.webp';
import reCarousel84 from '@/assets/resto-carousel-84.webp';
import reCarousel85 from '@/assets/resto-carousel-85.webp';
import reCarousel86 from '@/assets/resto-carousel-86.webp';
import reCarousel87 from '@/assets/resto-carousel-87.webp';
import reCarousel88 from '@/assets/resto-carousel-88.webp';
import reCarousel89 from '@/assets/resto-carousel-89.webp';
import reCarousel90 from '@/assets/resto-carousel-90.webp';
import reCarousel91 from '@/assets/resto-carousel-91.webp';
import reCarousel92 from '@/assets/resto-carousel-92.webp';
import reCarousel93 from '@/assets/resto-carousel-93.webp';
import reCarousel94 from '@/assets/resto-carousel-94.webp';
import reCarousel95 from '@/assets/resto-carousel-95.webp';
import reCarousel96 from '@/assets/resto-carousel-96.webp';
import reCarousel97 from '@/assets/resto-carousel-97.webp';
import reCarousel98 from '@/assets/resto-carousel-98.webp';
import reCarousel99 from '@/assets/resto-carousel-99.webp';
import reCarousel100 from '@/assets/resto-carousel-100.webp';
import reCarousel101 from '@/assets/resto-carousel-101.webp';
import reCarousel102 from '@/assets/resto-carousel-102.webp';
import reCarousel103 from '@/assets/resto-carousel-103.webp';
import transportVoyage from '@/assets/transport-point-4-voyage-noces.png';
import trCarousel02 from '@/assets/transport-carousel-02.png';
import trCarousel03 from '@/assets/transport-carousel-03.png';
import trCarousel04 from '@/assets/transport-carousel-04.png';
import trCarousel05 from '@/assets/transport-carousel-05.png';
import trCarousel06 from '@/assets/transport-carousel-06.png';
import trCarousel07 from '@/assets/transport-carousel-07.png';
import trCarousel08 from '@/assets/transport-carousel-08.png';
import trCarousel09 from '@/assets/transport-carousel-09.png';
import trCarouselCaleche01 from '@/assets/transport-carousel-caleche-01.png';
import trCarouselCaleche03 from '@/assets/transport-carousel-caleche-03.png';
import trCarouselCaleche04 from '@/assets/transport-carousel-caleche-04.png';
import trCarouselCaleche05 from '@/assets/transport-carousel-caleche-05.png';
import trCarouselCaleche06 from '@/assets/transport-carousel-caleche-06.png';
import trVtc01 from '@/assets/transport-vtc-01.webp';
import trVtc02 from '@/assets/transport-vtc-02.webp';
import trVtc03 from '@/assets/transport-vtc-03.webp';
import trVtc04 from '@/assets/transport-vtc-04.webp';
import trVtc05 from '@/assets/transport-vtc-05.webp';
import trVtc06 from '@/assets/transport-vtc-06.webp';
import trVtc07 from '@/assets/transport-vtc-07.webp';
import trVtc08 from '@/assets/transport-vtc-08.webp';
import trVtc09 from '@/assets/transport-vtc-09.webp';
import trVtc10 from '@/assets/transport-vtc-10.webp';
import trVtc11 from '@/assets/transport-vtc-11.webp';
import trVtc12 from '@/assets/transport-vtc-12.webp';
import trVtc13 from '@/assets/transport-vtc-13.webp';
import trVtc14 from '@/assets/transport-vtc-14.webp';
import trVtc15 from '@/assets/transport-vtc-15.webp';
import trVtc16 from '@/assets/transport-vtc-16.webp';
import trVtc17 from '@/assets/transport-vtc-17.webp';
import trVtc18 from '@/assets/transport-vtc-18.webp';
import trVtc19 from '@/assets/transport-vtc-19.webp';
import trVtc20 from '@/assets/transport-vtc-20.webp';
import trVtc21 from '@/assets/transport-vtc-21.webp';
import trVtc22 from '@/assets/transport-vtc-22.webp';
import trVtc23 from '@/assets/transport-vtc-23.webp';
import trVtc24 from '@/assets/transport-vtc-24.webp';
import trVtc25 from '@/assets/transport-vtc-25.webp';
import trVtc26 from '@/assets/transport-vtc-26.webp';
import trVtc27 from '@/assets/transport-vtc-27.webp';
import trVtc28 from '@/assets/transport-vtc-28.webp';
import trVtc29 from '@/assets/transport-vtc-29.webp';
import asJeuxBois01 from '@/assets/animations-speciales-jeux-bois-01.jpg';
import asJeuxBois02 from '@/assets/animations-speciales-jeux-bois-02.jpg';
import asJeuxBois03 from '@/assets/animations-speciales-jeux-bois-03.jpg';
import asJeuxBois04 from '@/assets/animations-speciales-jeux-bois-04.png';
import asJeuxBois05 from '@/assets/animations-speciales-jeux-bois-05.png';
import asJeuxBois06 from '@/assets/animations-speciales-jeux-bois-06.png';
import asJeuxBois07 from '@/assets/animations-speciales-jeux-bois-07.png';
import asJeuxBois08 from '@/assets/animations-speciales-jeux-bois-08.png';
import beCarousel01 from '@/assets/beaute-carousel-01.webp';
import beCarousel02 from '@/assets/beaute-carousel-02.webp';
import beCarousel03 from '@/assets/beaute-carousel-03.webp';
import beCarousel04 from '@/assets/beaute-carousel-04.webp';
import beCarousel05 from '@/assets/beaute-carousel-05.webp';
import beCarousel06 from '@/assets/beaute-carousel-06.webp';
import beCarousel07 from '@/assets/beaute-carousel-07.webp';
import beCarousel08 from '@/assets/beaute-carousel-08.png';
import beCarousel09 from '@/assets/beaute-carousel-09.jpg';
import beCarousel10 from '@/assets/beaute-carousel-10.jpg';
import beCarousel11 from '@/assets/beaute-carousel-11.jpg';
import beCarousel12 from '@/assets/beaute-carousel-12.jpg';
import beCarousel13 from '@/assets/beaute-carousel-13.jpg';
import beCarousel14 from '@/assets/beaute-carousel-14.jpg';
import beCarousel15 from '@/assets/beaute-carousel-15.jpg';
import beCarousel16 from '@/assets/beaute-carousel-16.png';
import beCarousel17 from '@/assets/beaute-carousel-17.jpg';
import beCarousel18 from '@/assets/beaute-carousel-18.png';
import beCarousel19 from '@/assets/beaute-carousel-19.jpg';
import beCarousel20 from '@/assets/beaute-carousel-20.png';
import beCarousel21 from '@/assets/beaute-carousel-21.jpg';
import beCarousel22 from '@/assets/beaute-carousel-22.png';
import beCarousel23 from '@/assets/beaute-carousel-23.jpg';
import beCarousel24 from '@/assets/beaute-carousel-24.png';
import beCarousel25 from '@/assets/beaute-carousel-25.png';
import beCarousel26 from '@/assets/beaute-carousel-26.jpg';
import beCarousel27 from '@/assets/beaute-carousel-27.png';
import beCarousel28 from '@/assets/beaute-carousel-28.jpg';
import beCarousel29 from '@/assets/beaute-carousel-29.png';
import beCarousel30 from '@/assets/beaute-carousel-30.png';
import beCarousel31 from '@/assets/beaute-carousel-31.png';
import beCarousel32 from '@/assets/beaute-carousel-32.jpg';
import beCarousel33 from '@/assets/beaute-carousel-33.png';
import beCarousel35 from '@/assets/beaute-carousel-35.png';
import beCarousel36 from '@/assets/beaute-carousel-36.jpg';
import beCarousel37 from '@/assets/beaute-carousel-37.png';
import beCarousel38 from '@/assets/beaute-carousel-38.jpg';
import beCarousel39 from '@/assets/beaute-carousel-39.jpg';
import beCarousel40 from '@/assets/beaute-carousel-40.jpg';
import beCarousel41 from '@/assets/beaute-carousel-41.jpg';
import beCarousel42 from '@/assets/beaute-carousel-42.png';
import beCarousel43 from '@/assets/beaute-carousel-43.png';
import beCarousel44 from '@/assets/beaute-carousel-44.png';
import beCarousel45 from '@/assets/beaute-carousel-45.png';
import beCarousel46 from '@/assets/beaute-carousel-46.png';
import beCarousel47 from '@/assets/beaute-carousel-47.jpg';
import beCarousel48 from '@/assets/beaute-carousel-48.jpg';
import beCarousel49 from '@/assets/beaute-carousel-49.png';
import beCarousel50 from '@/assets/beaute-carousel-50.jpg';
import beCarousel51 from '@/assets/beaute-carousel-51.png';
import beCarousel52 from '@/assets/beaute-carousel-52.jpg';
import beCarousel53 from '@/assets/beaute-carousel-53.png';
import beCarousel54 from '@/assets/beaute-carousel-54.jpg';
import beCarousel55 from '@/assets/beaute-carousel-55.png';
import beCarousel56 from '@/assets/beaute-carousel-56.jpg';
import beCarousel57 from '@/assets/beaute-carousel-57.png';
import beCarousel58 from '@/assets/beaute-carousel-58.jpg';
import beCarousel59 from '@/assets/beaute-carousel-59.png';
import beCarousel60 from '@/assets/beaute-carousel-60.png';
import beCarousel61 from '@/assets/beaute-carousel-61.png';
import beCarousel62 from '@/assets/beaute-carousel-62.png';
import adCarousel01 from '@/assets/aventure-carousel-01.webp';
import adCarousel02 from '@/assets/aventure-carousel-02.webp';
import adCarousel03 from '@/assets/aventure-carousel-03.webp';
import adCarousel04 from '@/assets/aventure-carousel-04.webp';
import adCarousel05 from '@/assets/aventure-carousel-05.webp';
import adCarousel08 from '@/assets/aventure-carousel-08.png';
import adCarousel09 from '@/assets/aventure-carousel-09.jpg';
import adCarousel10 from '@/assets/aventure-carousel-10.png';
import adCarousel11 from '@/assets/aventure-carousel-11.jpg';
import adCarousel12 from '@/assets/aventure-carousel-12.jpg';
import adCarousel14 from '@/assets/aventure-carousel-14.jpg';
import adCarousel16 from '@/assets/aventure-carousel-16.jpg';
import lhCarousel01 from '@/assets/lieuxhub-carousel-01.webp';
import lhCarousel02 from '@/assets/lieuxhub-carousel-02.webp';
import lhCarousel03 from '@/assets/lieuxhub-carousel-03.webp';
import lhCarousel04 from '@/assets/lieuxhub-carousel-04.webp';
import lhCarousel05 from '@/assets/lieuxhub-carousel-05.webp';
import lhCarousel06 from '@/assets/lieuxhub-carousel-06.webp';
import lhCarousel07 from '@/assets/lieuxhub-carousel-07.webp';
import lhCarousel08 from '@/assets/lieuxhub-carousel-08.webp';
import lhCarousel09 from '@/assets/lieuxhub-carousel-09.webp';
import lhCarousel10 from '@/assets/lieuxhub-carousel-10.webp';
import lhCarousel11 from '@/assets/lieuxhub-carousel-11.webp';
import lhCarousel12 from '@/assets/lieuxhub-carousel-12.webp';
import lhCarousel13 from '@/assets/lieuxhub-carousel-13.webp';
import lhCarousel14 from '@/assets/lieuxhub-carousel-14.webp';
import lhCarousel15 from '@/assets/lieuxhub-carousel-15.webp';
import lhCarousel16 from '@/assets/lieuxhub-carousel-16.webp';
import lhCarousel17 from '@/assets/lieuxhub-carousel-17.webp';
import lhCarousel18 from '@/assets/lieuxhub-carousel-18.webp';
import lhCarousel19 from '@/assets/lieuxhub-carousel-19.webp';
import lhCarousel20 from '@/assets/lieuxhub-carousel-20.webp';
import lhCarousel21 from '@/assets/lieuxhub-carousel-21.webp';
import lhCarousel22 from '@/assets/lieuxhub-carousel-22.webp';
import lhCarousel23 from '@/assets/lieuxhub-carousel-23.webp';
import lhCarousel24 from '@/assets/lieuxhub-carousel-24.webp';
import lhCarousel25 from '@/assets/lieuxhub-carousel-25.webp';


const formulaImages: Record<string, string> = {
  'photobooth-essential': borneEssentielle,
  'photobooth-premium': bornePremium,
  'photobooth-corporate': borneCorporate,
  'wedding-planning': weddingPlanning,
  'wedding-coordination': weddingCoordination,
  'wedding-coaching': weddingCoaching,
  'artistic-full': artisticFull,
  'artistic-single': artisticSingle,
  'artistic-support': artisticSupport,
  'event-full': formulaEventFull,
  'event-coord': formulaEventCoord,
  'event-consulting': formulaEventConsulting,
  'ceremony': ceremonyContent1,
  'coaching-ceremony': ceremonyContent2,
  'artist-magic': artistMagic,
  'artist-band': artistBand,
  'artist-performer': artistPerformer,
  'artist-circus': artistCircus,
  'artist-comedian': artistComedian,
  'artist-pyro': artistPyro,
  'wedding-decoration': weddingDecoration,
  'wedding-pack-serenite': weddingPackSerenite,
  'wedding-pack-tranquillite': weddingPackTranquillite,
  'feu-jour-ceremonie': feuDeJour6,
  'feu-jour-final': feuDeJour8,
  'mascotte-catalogue': mascotteCarousel02,
  'mascotte-corporate': mascotteCarousel03,
  'materiel-son-lumiere': materielContent1,
  'materiel-machines': materielContent3,
  'materiel-mobilier': materielContent4,
};

const categoryImages: Record<string, string> = {
  'cat-animateur-micro': catAnimateurMicro,
  'cat-musique': catMusique,
  'cat-art-rue': catArtRue,
  'cat-art-scene': catArtScene,
  'cat-art-cirque': catArtCirque,
  'cat-arts-visuels': catArtsVisuels,
  'cat-enfants': catEnfants,
  'cat-sport-spectacle': catSportSpectacle,
  'cat-lieux-reception': catLieuxReception,
  'cat-restauration-traiteur': catRestaurationTraiteur,
  'cat-image-souvenirs': catImageSouvenirs,
  'cat-beaute-bien-etre': catBeauteBienEtre,
  'cat-transport-voyages': catTransportVoyages,
  'cat-aventure-loisirs': catAventureLoisirs,
  'animations-speciales-bartender-03': asBartender03,
  'cat-feu-de-jour': feuDeJour6,
  'cat-mascottes': catMascottes,
  'cat-materiels': materielContent1,
  'photobooth-carousel-05': catPhotobooth,
};

const contentImages: Record<string, string[]> = {
  'a-la-location': [materielContent1, materielContent2, materielContent3, materielContent4, borneContent1, borneContent2],
  'evenements-publics-prives': [eventContent1, eventContent2, eventContent3, eventContent4, eventContent5],
  'booking-artistes-spectacles': [talentContent1, talentContent2, talentContent3, talentContent4, talentContent5],
  'wedding-planner-designer': [weddingContent1, weddingContent2, weddingContent3, weddingContent4, weddingContent5],
  'officiant-ceremonies-laiques': [ceremonyContent1, ceremonyContent2, ceremonyContent3, ceremonyContent4],
  'animations-enfants-famille': [enAtelierCreatif01, enChasseTresor07, enCirqueClown10, enConteEnfants01, enCirqueClown06, enMascotte06, enMaquillageTatouage23, enVentriloque08, enPereNoel10, enBallon01, enStructureGonflable30, enVentriloque07, mascotteCarousel11, enEscapeGame02],
  'musique-ambiance': [musiquePoint1Dj, musiquePoint2Groupe, muCarousel56, musiquePoint4Tribute, muCarousel103],
  'lieux-services-associes': [lieuxContent1, lieuxContent2, lieuxContent3, lieuxContent4],
  'animations-speciales-experiences': [specialContent1, specialContent2, specialContent3, specialContent4],
  'feu-de-jour': [feuDeJourContent1, feuDeJourContent2, feuDeJourContent3, feuDeJourContent4],
  'mascottes': [mascotteCarousel03, mascotteCarousel04, mascotteCarousel09, mascotteCarousel10],
  'materiels': [materielContent1, materielContent2, materielContent3, materielContent4],
  'photobooth': [borneContent1, borneContent2, borneContent3, borneContent4],
  'animateur-micro': [animateurContent1, animateurContent2],
  'art-de-la-rue': [artRuePoint1Cascadeur, artRueContent3, artRuePoint3CirqueDeRue, artRuePoint4Echassier, artRuePoint5Fanfare, artRuePoint6FeuPyroLed, arCarousel09, arCarousel17, arCarousel20, artRuePoint10MimeStatue, arCarousel13],
  'art-de-la-scene': [
    scenePoint1Swing,
    '/art-de-la-scene/burlesque18-02-plumes-rose.jpg',
    '/art-de-la-scene/burlesque-cabaret-01-eventail-rouge.png',
    scenePoint4ComedieMusicale,
    '/art-de-la-scene/comedien-01-faux-serveur-mariage.png',
    scenePoint6Humour,
    scenePoint7Danseur,
    scenePoint8Flair,
    scenePoint9Hypnotiseur,
    scenePoint10Magie,
    '/art-de-la-scene/theatre-01-troupe-clowns-valises.png',
    scenePoint12Led,
    scenePoint13Sosie,
  ],
  'art-du-cirque': [artCirquePoint1, artCirqueContent1, artCirquePoint3],
  'arts-visuels': [artsVisuelsPoint1, artsVisuelsPoint2, artsVisuelsPoint3],
  'sport-spectacle': [sportPoint1Shows, sportPoint2Football, sportPoint3Bmx],
  'lieux-reception': [lieuxReceptionC1, lieuxReceptionC2, lieuxReceptionC3, lieuxReceptionC4],
  'restauration-traiteur': [restaurationC1, restaurationC2, restaurationC3, restaurationC4],
  'image-souvenirs': [imageSouvenirsC1, imageSouvenirsC2, imageSouvenirsC3, imageSouvenirsC4],
  'beaute-bien-etre': [beautePoint1Maquillage, beCarousel36, beCarousel29, beauteBienEtrePremium, beauteBabysittingPremium],
  'transport-voyages': [transportC1, transportC2, transportC3, transportVoyage],
  'aventure-loisirs': [aventureOutdoor, aventureC2, aventureBienetre, aventureC3],
};

const whyUsItems = [
  { icon: Users, title: 'Interlocuteur unique', desc: 'Cyrille gère tout de A à Z. Un seul contact pour toute votre organisation. Pas de sous-traitance masquée, pas de commercial intermédiaire.' },
  { icon: Award, title: '25 ans d\'expérience', desc: 'Plus de 250 événements réussis dans tous les formats et toutes les tailles. Des références solides, vérifiables et diversifiées.' },
  { icon: Heart, title: 'Sur-mesure absolu', desc: 'Aucun copier-coller, aucun template. Votre événement sera unique, conçu à partir de votre histoire, vos envies et votre personnalité.' },
  { icon: Shield, title: 'Réseau premium', desc: '100+ prestataires et artistes sélectionnés avec exigence dans toute la région. Chaque partenaire est testé et validé sur plusieurs événements.' },
];

const processSteps = [
  { icon: Phone, label: 'Premier échange', desc: 'Appel découverte ou rdv physique — offert' },
  { icon: Target, label: 'Devis détaillé', desc: 'Proposition claire, précise et sur-mesure sous 48 à 72h' },
  { icon: Zap, label: 'Préparation', desc: 'Organisation, design et coordination de A à Z' },
  { icon: Clock, label: 'Jour J', desc: 'Présence discrète, supervision complète, zéro stress' },
];

const eventsCarouselAlts = [
  'Feu d\'artifice pyrotechnique devant la foule',
  'Spectacle pyrotechnique silhouettes nocturnes',
  'Décoration cérémonie bohème chic en grange',
  'Animation couleurs Holi festival',
  'Animateur micro conférence corporate',
  'Mosaïque événements variés',
  'Cérémonie en plein air arches fleuries',
  'Soirée cocktail champagne entre amis',
  'Fête confettis dorés entre collègues',
  'Calèche devant un château au coucher du soleil',
  'Mariés heureux applaudis par les invités',
  'Lancement de produit automobile scénographié',
  'Cocktail buffet networking corporate',
  'Table dressée tournesols et couverts bleus',
  'Rituel sable coloré cérémonie laïque',
  'Soirée dansante confettis dorés',
  'Cérémonie sous les arbres bouquets de fleurs',
  'Tables dressées en extérieur nappes colorées',
  'Mariée de dos robe dentelle jardin',
  'Wedding planner coordination tablette',
  'Salle de réception grand gala fleurs rouges',
  'Baby shower décorée avec ballons',
  'Réception luxueuse lustres et fleurs',
  'Table élégante éclairage violet',
  'Séminaire conférence applaudissements',
  'Cocktail dînatoire corporate networking',
  'Anniversaire en famille avec gâteau',
  'Réception champêtre guirlandes en plein air',
  'Saxophoniste cocktail en terrasse',
  'Concert scène festival nocturne fumée',
  'Saxophoniste DJ show lumineux',
  'Concert scène feux et confettis',
  'Concert scène arche lumières nocturne',
  'Team building jeux en équipe plein air',
  'Course en sac team building',
  'Team building bowling géant extérieur',
  'Team building jeux collaboratifs intérieur',
  'Séminaire auditorium grande salle',
];
const eventsCarouselImages = eventsCarouselAlts.map((alt, i) => ({
  src: `/images/evenements/ev-${String(i + 1).padStart(2, '0')}.webp`,
  alt,
}));

import maCarousel01 from '@/assets/mariage-carousel-01.webp';
import maCarousel02 from '@/assets/mariage-carousel-02.webp';
import maCarousel03 from '@/assets/mariage-carousel-03.webp';
import maCarousel04 from '@/assets/mariage-carousel-04.webp';
import maCarousel05 from '@/assets/mariage-carousel-05.webp';
import maCarousel06 from '@/assets/mariage-carousel-06.webp';
import maCarousel07 from '@/assets/mariage-carousel-07.webp';
import maCarousel08 from '@/assets/mariage-carousel-08.webp';
import maCarousel09 from '@/assets/mariage-carousel-09.webp';
import maCarousel10 from '@/assets/mariage-carousel-10.webp';
import maCarousel11 from '@/assets/mariage-carousel-11.webp';
import maCarousel12 from '@/assets/mariage-carousel-12.webp';
import maCarousel13 from '@/assets/mariage-carousel-13.webp';
import maCarousel14 from '@/assets/mariage-carousel-14.webp';
import maCarousel15 from '@/assets/mariage-carousel-15.webp';
import maCarousel16 from '@/assets/mariage-carousel-16.webp';
import maCarousel17 from '@/assets/mariage-carousel-17.webp';
import maCarousel18 from '@/assets/mariage-carousel-18.webp';
import maCarousel19 from '@/assets/mariage-carousel-19.webp';
import maCarousel20 from '@/assets/mariage-carousel-20.webp';
import maCarousel21 from '@/assets/mariage-carousel-21.webp';
import maCarousel22 from '@/assets/mariage-carousel-22.webp';
import maCarousel23 from '@/assets/mariage-carousel-23.webp';
import maCarousel24 from '@/assets/mariage-carousel-24.webp';
import maCarousel25 from '@/assets/mariage-carousel-25.webp';
import maCarousel26 from '@/assets/mariage-carousel-26.webp';
import maCarousel27 from '@/assets/mariage-carousel-27.webp';
import maCarousel28 from '@/assets/mariage-carousel-28.webp';
import maCarousel29 from '@/assets/mariage-carousel-29.webp';
import maCarousel30 from '@/assets/mariage-carousel-30.webp';
import maCarousel31 from '@/assets/mariage-carousel-31.webp';
import maCarousel32 from '@/assets/mariage-carousel-32.webp';
import maCarousel33 from '@/assets/mariage-carousel-33.webp';
import maCarousel34 from '@/assets/mariage-carousel-34.webp';
import maCarousel35 from '@/assets/mariage-carousel-35.webp';
import maCarousel36 from '@/assets/mariage-carousel-36.webp';
import maCarousel37 from '@/assets/mariage-carousel-37.webp';
import maCarousel38 from '@/assets/mariage-carousel-38.webp';
import maCarousel39 from '@/assets/mariage-carousel-39.webp';
import maCarousel40 from '@/assets/mariage-carousel-40.webp';
import maCarousel41 from '@/assets/mariage-carousel-41.webp';
import maCarousel42 from '@/assets/mariage-carousel-42.webp';
import maCarousel43 from '@/assets/mariage-carousel-43.webp';
import maCarousel44 from '@/assets/mariage-carousel-44.webp';
import maCarousel45 from '@/assets/mariage-carousel-45.webp';
import maCarousel46 from '@/assets/mariage-carousel-46.webp';
import maCarousel47 from '@/assets/mariage-carousel-47.webp';
import maCarousel48 from '@/assets/mariage-carousel-48.webp';
import maCarousel49 from '@/assets/mariage-carousel-49.webp';
import maCarousel50 from '@/assets/mariage-carousel-50.webp';
import maCarousel51 from '@/assets/mariage-carousel-51.webp';
import maCarousel52 from '@/assets/mariage-carousel-52.webp';
import maCarousel53 from '@/assets/mariage-carousel-53.webp';
import maCarousel54 from '@/assets/mariage-carousel-54.webp';
import maCarousel55 from '@/assets/mariage-carousel-55.webp';
import maCarousel56 from '@/assets/mariage-carousel-56.webp';
import maCarousel57 from '@/assets/mariage-carousel-57.webp';
import maCarousel58 from '@/assets/mariage-carousel-58.webp';
import maCarousel59 from '@/assets/mariage-carousel-59.webp';
import maCarousel60 from '@/assets/mariage-carousel-60.webp';
import maCarousel61 from '@/assets/mariage-carousel-61.webp';
import maCarousel63 from '@/assets/mariage-carousel-63.webp';
import maCarousel64 from '@/assets/mariage-carousel-64.webp';
import maCarousel65 from '@/assets/mariage-carousel-65.webp';
import maCarousel66 from '@/assets/mariage-carousel-66.webp';
import maCarousel67 from '@/assets/mariage-carousel-67.webp';
import maCarousel68 from '@/assets/mariage-carousel-68.webp';
import maCarousel69 from '@/assets/mariage-carousel-69.webp';
import maCarousel70 from '@/assets/mariage-carousel-70.webp';
import maCarousel71 from '@/assets/mariage-carousel-71.webp';
import maCarousel72 from '@/assets/mariage-carousel-72.webp';
import maCarousel73 from '@/assets/mariage-carousel-73.webp';
import maCarousel74 from '@/assets/mariage-carousel-74.webp';
import maCarousel75 from '@/assets/mariage-carousel-75.webp';
import maCarousel76 from '@/assets/mariage-carousel-76.webp';
import maCarousel77 from '@/assets/mariage-carousel-77.webp';
import maCarousel78 from '@/assets/mariage-carousel-78.webp';
import maCarousel79 from '@/assets/mariage-carousel-79.webp';
import maCarousel80 from '@/assets/mariage-carousel-80.webp';
import maCarousel81 from '@/assets/mariage-carousel-81.webp';
import maCarousel82 from '@/assets/mariage-carousel-82.webp';
import maCarousel83 from '@/assets/mariage-carousel-83.webp';
import maCarousel84 from '@/assets/mariage-carousel-84.webp';
import maCarousel85 from '@/assets/mariage-carousel-85.webp';
import maCarousel86 from '@/assets/mariage-carousel-86.webp';
import maCarousel87 from '@/assets/mariage-carousel-87.webp';
import maCarousel88 from '@/assets/mariage-carousel-88.webp';
import maCarousel89 from '@/assets/mariage-carousel-89.webp';
import maCarousel90 from '@/assets/mariage-carousel-90.webp';
import maCarousel91 from '@/assets/mariage-carousel-91.webp';
import maCarousel93 from '@/assets/mariage-carousel-93.webp';
import maCarousel94 from '@/assets/mariage-carousel-94.webp';
import maCarousel95 from '@/assets/mariage-carousel-95.webp';
import maCarousel96 from '@/assets/mariage-carousel-96.webp';
import maCarousel97 from '@/assets/mariage-carousel-97.webp';
import maCarousel98 from '@/assets/mariage-carousel-98.webp';
import maCarousel99 from '@/assets/mariage-carousel-99.webp';
import maCarousel100 from '@/assets/mariage-carousel-100.webp';
import maCarousel101 from '@/assets/mariage-carousel-101.webp';
import maCarousel102 from '@/assets/mariage-carousel-102.webp';
import maCarousel103 from '@/assets/mariage-carousel-103.webp';
import maCarousel104 from '@/assets/mariage-carousel-104.webp';
import maCarousel105 from '@/assets/mariage-carousel-105.webp';
import maCarousel106 from '@/assets/mariage-carousel-106.webp';
import maCarousel107 from '@/assets/mariage-carousel-107.webp';
import maCarousel108 from '@/assets/mariage-carousel-108.webp';
import maCarousel109 from '@/assets/mariage-carousel-109.webp';
import maCarousel113 from '@/assets/mariage-carousel-113.webp';
import maCarousel114 from '@/assets/mariage-carousel-114.webp';
import maCarousel115 from '@/assets/mariage-carousel-115.webp';
import maCarousel116 from '@/assets/mariage-carousel-116.webp';
import maCarousel117 from '@/assets/mariage-carousel-117.webp';
import maCarousel118 from '@/assets/mariage-carousel-118.webp';
import maCarousel119 from '@/assets/mariage-carousel-119.webp';
import maCarousel120 from '@/assets/mariage-carousel-120.webp';
import locCarousel01 from '@/assets/location-carousel-01.jpg';
import locCarousel02 from '@/assets/location-carousel-02.png';
import locCarousel03 from '@/assets/location-carousel-03.jpg';
import locCarousel04 from '@/assets/location-carousel-04.png';
import locCarousel05 from '@/assets/location-carousel-05.jpg';
import locCarousel06 from '@/assets/location-carousel-06.png';
import locCarousel07 from '@/assets/location-carousel-07.jpg';
import locCarousel08 from '@/assets/location-carousel-08.png';
import locCarousel09 from '@/assets/location-carousel-09.jpg';
import locCarousel11 from '@/assets/location-carousel-11.jpg';
import locCarousel12 from '@/assets/location-carousel-12.png';
import locCarousel13 from '@/assets/location-carousel-13.jpg';
import locCarousel14 from '@/assets/location-carousel-14.png';
import locCarousel15 from '@/assets/location-carousel-15.jpg';
import locCarousel16 from '@/assets/location-carousel-16.jpg';
import locCarousel17 from '@/assets/location-carousel-17.jpg';
import locCarousel18 from '@/assets/location-carousel-18.jpg';
import locCarousel19 from '@/assets/location-carousel-19.png';
import locCarousel20 from '@/assets/location-carousel-20.png';
import locCarousel21 from '@/assets/location-carousel-21.png';
import locCarousel22 from '@/assets/location-carousel-22.png';
import locCarousel23 from '@/assets/location-carousel-23.png';
import locCarousel24 from '@/assets/location-carousel-24.png';
import locCarousel25 from '@/assets/location-carousel-25.png';
import locCarousel28 from '@/assets/location-carousel-28.png';
import locCarousel29 from '@/assets/location-carousel-29.png';
import locCarousel30 from '@/assets/location-carousel-30.png';
import locCarousel31 from '@/assets/location-carousel-31.png';
import locCarousel32 from '@/assets/location-carousel-32.png';

const weddingCarouselImages: { src: string; alt: string }[] = [
  { src: maCarousel01, alt: 'Mariés s’embrassant dans l’allée fleurie pendant leur cérémonie en plein air' },
  { src: maCarousel02, alt: 'Mariés enlacés au bord d’une piscine tropicale entourée de palmiers' },
  { src: maCarousel03, alt: 'Mariés s’embrassant derrière des lunettes en forme de cœur en pleine nature' },
  { src: maCarousel04, alt: 'Mariés indiens recevant une pluie de pétales colorés lors de leur cérémonie traditionnelle' },
  { src: maCarousel05, alt: 'Mariés au pied d’un arbre lors de leur cérémonie en extérieur' },
  { src: maCarousel06, alt: 'Mariés rayonnants applaudis par leurs invités devant une arche de ballons' },
  { src: maCarousel07, alt: 'Mariés joyeux acclamés par leurs proches sous les guirlandes lumineuses' },
  { src: maCarousel08, alt: 'Détail noir et blanc d’un marié ajustant son gilet brodé avant la cérémonie' },
  { src: maCarousel09, alt: 'Mariés sous une arche fleurie en pampa et roses pâles lors d’une cérémonie en forêt' },
  { src: maCarousel10, alt: 'Bouteille de Châteauneuf-du-Pape ornée de rubans posée dans l’herbe' },
  { src: maCarousel11, alt: 'Mariée souriante en robe à bretelles tenant son bouquet pastel dans une allée fleurie au soleil couchant' },
  { src: maCarousel12, alt: 'Marié à genou dansant avec sa mariée sur la piste enfumée bleutée de la salle de réception' },
  { src: maCarousel13, alt: 'Mariés dos à dos jouant avec humour au jeu des chaussures pendant la soirée' },
  { src: maCarousel14, alt: 'Portrait de la mariée en robe à dentelle et bouquet blanc sous une arche d’oliviers en patio méditerranéen' },
  { src: maCarousel15, alt: 'Mariée de dos tenant haut le bouquet entouré de rubans pour la tradition du ruban' },
  { src: maCarousel16, alt: 'Mariés s’embrassant dans une voiture de collection cabriolet noire devant un château en forêt' },
  { src: maCarousel17, alt: 'Mariés et invités jouant au tir à la corde sous les arbres lors des animations en extérieur' },
  { src: maCarousel18, alt: 'Vue aérienne des mariés allongés au sol dans une robe en éventail parsemée de feuilles d’automne' },
  { src: maCarousel19, alt: 'Calèche blanche tirée par des chevaux blancs emportant les mariés devant un château au soleil couchant' },
  { src: maCarousel20, alt: 'Mariés et invités riant pendant le jeu du tir à la corde sur la pelouse au bord de l’eau' },
  { src: maCarousel21, alt: 'Mariés posant avec leurs deux chats roux et blanc dans les bras devant un mur de pierre fleuri' },
  { src: maCarousel22, alt: 'Mariée et demoiselle d’honneur disposant les marque-places sur la table dressée sous les guirlandes lumineuses' },
  { src: maCarousel23, alt: 'Mariés posant main dans la main sur le grand escalier d’honneur de l’hôtel de ville de Sens' },
  { src: maCarousel24, alt: 'Mariés enlacés front contre front au coucher du soleil dans une forêt illuminée de bougies' },
  { src: maCarousel25, alt: 'Baiser passionné des mariés tenant leur bouquet d’eucalyptus devant une façade Art déco' },
  { src: maCarousel26, alt: 'Mariés rieurs acclamés par leurs invités à la sortie de la cérémonie en plein air' },
  { src: maCarousel27, alt: 'Mariés se tenant les mains au pied d’un arbre majestueux dans une clairière en forêt' },
  { src: maCarousel28, alt: 'Mariés courant main dans la main sur un sentier baigné de lumière dorée en pleine forêt' },
  { src: maCarousel29, alt: 'Mariés enlacés sous une arche fleurie de roses blanches devant un château au coucher du soleil' },
  { src: maCarousel30, alt: 'Mariés trinquant au champagne devant leurs invités lors du cocktail en extérieur' },
  { src: maCarousel31, alt: 'Mariés tirant sur les rubans colorés du jeu du ruban à la sortie de la cérémonie' },
  { src: maCarousel32, alt: 'Mariée de profil en robe à dentelle et long voile traversant la place devant l’hôtel de ville' },
  { src: maCarousel33, alt: 'Alliances en or suspendues à une branche de cerisier en fleurs au printemps' },
  { src: maCarousel34, alt: 'Mariés rieurs courant main dans la main sur un sentier forestier doré' },
  { src: maCarousel35, alt: 'Mariés posant à l’intérieur d’une voiture de collection blanche cabriolet, portière ouverte' },
  { src: maCarousel36, alt: 'Mariés et invitée tenant des torches enflammées lors d’un spectacle de feu nocturne' },
  { src: maCarousel37, alt: 'Détail d’escarpins dorés, alliances et bouquet de mariée posés sur le parquet en bois' },
  { src: maCarousel38, alt: 'Portrait noir et blanc des mariés souriants à l’arrière d’une voiture de collection décorée' },
  { src: maCarousel39, alt: 'Vue aérienne des mariées entourées de leurs invités formant un cœur autour d’elles dans la cour' },
  { src: maCarousel40, alt: 'Mariées rayonnantes dansant avec leurs invités sur la pelouse au bord de l’eau lors de la sortie' },
  { src: maCarousel41, alt: 'Mariées joyeuses acclamées par leurs invités lors de la sortie de cérémonie en pleine nature' },
  { src: maCarousel42, alt: 'Silhouette romantique des mariées s’embrassant à contre-jour devant un coucher de soleil champêtre' },
  { src: maCarousel43, alt: 'Mariés rayonnants sortant sous une pluie de bulles de savon, bouquet levé en signe de victoire' },
  { src: maCarousel44, alt: 'Cérémonie laïque en plein air sous une arche fleurie, mariée avec longue traîne face à l’officiant' },
  { src: maCarousel45, alt: 'Gros plan poétique sur les mains entrelacées des mariés portant leurs alliances dorées' },
  { src: maCarousel46, alt: 'Mariés trinquant avec des verres à martini lors d’un cocktail élégant dans un jardin illuminé de guinguettes' },
  { src: maCarousel47, alt: 'Sortie festive des mariés sous une pluie de confettis multicolores et un baiser passionné' },
  { src: maCarousel48, alt: 'Première danse spectaculaire des mariés sur un nuage de fumée lourde sous un chapiteau majestueux' },
  { src: maCarousel49, alt: 'Sortie d’église émotionnelle sous une pluie de pétales blancs, mariés rieurs et complices' },
  { src: maCarousel50, alt: 'Décoration féerique d’une longue table de réception en extérieur sous une voûte d’ampoules suspendues et de gypsophile' },
  { src: maCarousel51, alt: 'Mosaïque d’inspirations design : arts de la table, scénographie florale, arche cérémoniale et signalétique miroir' },
  { src: maCarousel52, alt: 'Salle de réception monumentale dressée de tables rondes nappées d’or sous une charpente architecturale en bois' },
  { src: maCarousel53, alt: 'Chemin de table opulent mêlant hauts vases en cristal, fleurs printanières et verres en verre émeraude' },
  { src: maCarousel54, alt: 'Décoration romantique d’une table en bois avec hortensias roses et lampions lumineux suspendus dans les arbres' },
  { src: maCarousel55, alt: 'Composition florale raffinée en boîte rose pâle mêlant renoncules, roses et eucalyptus poudré' },
  { src: maCarousel56, alt: 'Scénographie de réception sous voûte ancienne avec lustres en franges suspendues et compositions de pampa' },
  { src: maCarousel57, alt: 'Centre de table bohème sculpté en pampa séchée et fleurs roses dans un écrin en bois noué d’un ruban de lin' },
  { src: maCarousel58, alt: 'Mise en place élégante d’une table d’honneur avec hautes compositions florales blanches et serviettes pliées en éventail' },
  { src: maCarousel59, alt: 'Wedding designer en plein travail vérifiant les drapés et bouquets de roses fixés sur les chaises de cérémonie' },
  { src: maCarousel60, alt: 'Détail romantique d’une chaise Chiavari blanche habillée d’une couronne de feuillage et d’un mini bouquet pastel' },
  { src: maCarousel61, alt: 'Wedding designer ajustant un centre de table de roses blanches et poudrées sous une terrasse illuminée de guirlandes' },
  { src: maCarousel63, alt: 'Décoratrice mettant la touche finale à une table d’honneur fuchsia avec orchidées, roses et bougies dégradées' },
  { src: maCarousel64, alt: 'Tables rondes habillées de housses blanches et nœuds en organza vert d’eau dans une salle en pierre apparente' },
  { src: maCarousel65, alt: 'Mise en place d’une salle de réception avec hauts supports floraux dorés, tulipes blanches et chaises ghost' },
  { src: maCarousel66, alt: 'Tablée d’honneur intimiste aux tons terracotta avec roses, pampa, bougies hautes et flûtes de champagne rosé' },
  { src: maCarousel67, alt: 'Vue d’ensemble d’une salle de mariage habillée d’une enseigne lumineuse Love et de chemins de feuillages suspendus' },
  { src: maCarousel68, alt: 'Wedding planner en robe sauge installant les serviettes sur la table d’honneur tandis que les mariés trinquent en arrière-plan' },
  { src: maCarousel69, alt: 'Composition florale spectaculaire en pampa, roses préservées et feuillages bordeaux dans une explosion d’éclaboussures' },
  { src: maCarousel70, alt: 'Salle de réception industrielle en pierre habillée d’une enseigne lumineuse Love et d’un chemin de feuillages suspendu en mezzanine' },
  { src: maCarousel71, alt: 'Centre de table en hauts vases coniques avec tulipes, eucalyptus et illumination LED verte au pied du bouquet' },
  { src: maCarousel72, alt: 'Arche cérémoniale en bois ornée de drapé blanc, roses pastel, eucalyptus et guirlande lumineuse en pleine forêt' },
  { src: maCarousel73, alt: 'Gros plan sur un vase flûte rempli de tulipes blanches et eucalyptus avec base illuminée en vert émeraude' },
  { src: maCarousel74, alt: 'Salle de bal classique aux lustres en cristal monumentaux et tables rondes dressées de nœuds rouges et nappes ivoire' },
  { src: maCarousel75, alt: 'Centre de table sur structure dorée surélevée avec composition de tulipes, gypsophile et eucalyptus sous une enseigne Love néon' },
  { src: maCarousel76, alt: 'Tablée d’honneur romantique aux roses poudrées, bougies effilées dorées et arts de la table en porcelaine cerclée d’or' },
  { src: maCarousel77, alt: 'Vue d’ensemble d’une salle de mariage en pierre avec hauts supports floraux dorés et nœuds en organza vert sur chaises ghost' },
  { src: maCarousel78, alt: 'Salle de réception illuminée par une enseigne Love néon, drapé floral en mezzanine et hautes compositions de tulipes blanches' },
  { src: maCarousel79, alt: 'Mise en place complète d’une salle de mariage avec centre de table en hauteur, chaises ghost et nœuds en organza vert sapin' },
  { src: maCarousel80, alt: 'Détail d’un grand vase en verre rempli de gypsophile illuminé en vert avec bougie ivoire et cadre photo souvenir' },
  { src: maCarousel81, alt: 'Gros plan sur les alliances en or et diamants posées sur un bouquet de roses rouges, dahlias et baies pastel' },
  { src: maCarousel82, alt: 'Bouquet artisanal en fleurs de papier crépon mêlant pivoines corail, roses poudrées et hortensias' },
  { src: maCarousel83, alt: 'Composition florale en papier crépon aux tons rouge et corail avec pivoines, œillets et fleurs séchées' },
  { src: maCarousel84, alt: 'Décoration de table en extérieur avec hortensias roses, bouquets de roses fuchsia et lampions suspendus' },
  { src: maCarousel85, alt: 'Bar à bonbons rétro avec bocaux en verre garnis de sucreries colorées et ardoise « Bar pour petits et grands gourmands »' },
  { src: maCarousel86, alt: 'Marque-place champêtre en rondin de bois gravé « Champomy » avec bouchons de champagne et fleurs séchées roses' },
  { src: maCarousel87, alt: 'Plan de table champêtre dans un cadre doré avec étiquettes bouteilles de vin et décoration de pampa séchée' },
  { src: maCarousel88, alt: 'Détail de table chic avec verre doré renversé, bouquet de roses blanches et serviettes bleu cobalt' },
  { src: maCarousel89, alt: 'Arche cérémoniale boho en drapé beige et pampa séchée devant un étang avec table en bois pour les mariés' },
  { src: maCarousel90, alt: 'Allée de cérémonie laïque en plein air avec chaises Napoléon habillées de tulle pêche et hortensias blancs' },
  { src: maCarousel91, alt: 'Détail bouquet de chaise sur Chiavari blanche : roses pâles, gypsophile et eucalyptus liés à la ficelle de jute' },
  { src: maCarousel93, alt: 'Décoration de chaise dorée avec bouquet de roses blanches et bordeaux noué d’un ruban de soie crème' },
  { src: maCarousel94, alt: 'Espace lounge des mariés avec mur végétal, lettres « Mr & Mrs » et fauteuil capitonné entouré de lanternes blanches' },
  { src: maCarousel95, alt: 'Composition florale Art déco en vase doré avec lys blancs et palmes vertes devant un drapé immaculé' },
  { src: maCarousel96, alt: 'Table de banquet élégante avec roses blanches en soliflores, bougies et suspensions cuivrées tamisées' },
  { src: maCarousel97, alt: 'Vase médicis blanc garni de roses pêche et eucalyptus en bordure d’allée de cérémonie au coucher de soleil' },
  { src: maCarousel98, alt: 'Décoration de capot de voiture des mariés en cœur de roses pastel et raphia tressé rose poudré' },
  { src: maCarousel99, alt: 'Cœur en osier blanc fleuri de roses rose et pêche posé sur le capot d’une voiture de mariage' },
  { src: maCarousel100, alt: 'Décoration champêtre d’allée de cérémonie : caisses en bois, jute, romarin et bouquets de fleurs des champs' },
  { src: maCarousel101, alt: 'Détail d’arche florale en feuillage avec œillets rose poudré, pivoines blanches et pampa séchée' },
  { src: maCarousel102, alt: 'Bouts de banc de cérémonie : pots en verre garnis de roses rose vif et gypsophile sur chaises blanches' },
  { src: maCarousel103, alt: 'Détail romantique de chaises bistrot habillées de tulle ivoire et colliers de perles nacrées' },
  { src: maCarousel104, alt: 'Chaises crossback en bois drapées de voile crème, perles et bague dorée pour cérémonie élégante' },
  { src: maCarousel105, alt: 'Bouquet de la mariée en roses rose poudré et gypsophile noué d’un ruban satin sur faire-part' },
  { src: maCarousel106, alt: 'Chemin de table luxuriant de fleurs roses, blanches et verdoyantes pour banquet de réception' },
  { src: maCarousel107, alt: 'Allée de cérémonie en plein air avec arbres de cerisiers blancs, drapés et guirlandes guinguette' },
  { src: maCarousel108, alt: 'Décor de table romantique aux tons bordeaux : chemin de table gaze, centre floral et bougies bubble' },
  { src: maCarousel109, alt: 'Arche hexagonale boho en pampa séchée et drapés terracotta et sauge au bord de l’étang' },
  { src: maCarousel113, alt: 'Panneau de bienvenue en bois gravé et fleuri pour mariage aux tons terracotta et ivoire' },
  { src: maCarousel114, alt: 'Plan de table graphique noir et blanc avec prénoms dorés sur support chevalet' },
  { src: maCarousel115, alt: 'Numéro de table Hill Flower imprimé sur chevalet en bois au cœur d’une décoration florale' },
  { src: maCarousel116, alt: 'Portrait mosaïque en noir et blanc composé de carrés sur panneau souvenir de mariage' },
  { src: maCarousel117, alt: 'Faire-part élégant glissé dans son enveloppe avec dorure et illustration florale' },
  { src: maCarousel118, alt: 'Suite de papeterie mariage vert profond avec cachet de cire et escarpins blancs' },
  { src: maCarousel119, alt: 'Livrets de cérémonie ou marque-pages imprimés avec couronnes végétales sur présentoir miroir' },
  { src: maCarousel120, alt: 'Arbre à empreintes des invités sur toile avec chevalet et espace signature de mariage' },
];

const ImageCarouselSection = ({ images, title }: { images: { src: string; alt: string }[]; title: string }) => {
  const [current, setCurrent] = useState(0);
  const [paused, setPaused] = useState(false);
  const [lightbox, setLightbox] = useState<number | null>(null);
  const total = images.length;
  const prev = () => setCurrent((c) => (c - 1 + total) % total);
  const next = () => setCurrent((c) => (c + 1) % total);
  useEffect(() => {
    if (total === 0 || paused || lightbox !== null) return;
    const timer = setInterval(() => setCurrent((c) => (c + 1) % total), 5000);
    return () => clearInterval(timer);
  }, [total, paused, lightbox]);
  if (total === 0) return null;
  return (
    <section className="py-16 md:py-20 bg-petrol overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-10">
          <p className="text-sm md:text-base font-heading font-semibold uppercase tracking-[0.15em] text-primary mb-2">{title}</p>
        </div>
      </div>
      <div className="relative max-w-5xl mx-auto px-6 lg:px-8">
        <button
          type="button"
          onClick={() => setLightbox(current)}
          className="relative block w-full aspect-[16/9] overflow-hidden group cursor-zoom-in"
          aria-label="Agrandir la photo"
        >
          {images.map((img, i) => (
            <img key={i} src={img.src} alt={img.alt} width={960} height={540} className={`absolute inset-0 w-full h-full object-contain transition-opacity duration-700 ${i === current ? 'opacity-100' : 'opacity-0'}`} loading={i === 0 ? 'eager' : 'lazy'} />
          ))}
          <span className="absolute top-3 right-3 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-petrol/70 backdrop-blur-sm text-petrol-foreground text-xs font-heading opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
            <Maximize2 size={12} strokeWidth={1.5} /> Agrandir
          </span>
        </button>
        <button onClick={prev} className="absolute left-2 lg:-left-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-petrol/60 backdrop-blur-sm text-petrol-foreground flex items-center justify-center hover:bg-petrol/80 transition-colors" aria-label="Image précédente">
          <ChevronDown size={20} className="rotate-90" />
        </button>
        <button onClick={next} className="absolute right-2 lg:-right-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-petrol/60 backdrop-blur-sm text-petrol-foreground flex items-center justify-center hover:bg-petrol/80 transition-colors" aria-label="Image suivante">
          <ChevronDown size={20} className="-rotate-90" />
        </button>
        <div className="flex justify-center mt-4">
          <CarouselPauseButton paused={paused} onToggle={() => setPaused((p) => !p)} variant="dark" />
        </div>
      </div>
      {lightbox !== null && (
        <ImageLightbox
          images={images}
          currentIndex={lightbox}
          onClose={() => setLightbox(null)}
          onPrev={() => setLightbox((i) => ((i ?? 0) - 1 + total) % total)}
          onNext={() => setLightbox((i) => ((i ?? 0) + 1) % total)}
        />
      )}
    </section>
  );
};

const WeddingImageCarousel = () => <ImageCarouselSection images={weddingCarouselImages} title="Nos mariages en images" />;

const officiantCarouselImages: { src: string; alt: string }[] = [
  { src: ceCarousel01, alt: 'Allée de cérémonie laïque en forêt avec arche fleurie et bancs en bois' },
  { src: ceCarousel02, alt: 'Cérémonie laïque extérieure avec arche circulaire fleurie' },
  { src: ceremonyContent1, alt: 'Mariés main dans la main pendant une cérémonie laïque en extérieur' },
  { src: ceCarousel04, alt: 'Allée de cérémonie laïque décorée de tournesols et daisies' },
  { src: ceCarousel05, alt: 'Chat portant un nœud lors d’une cérémonie laïque' },
  { src: ceCarousel06, alt: 'Jeunes mariés souriants assis pendant la cérémonie laïque' },
  { src: ceCarousel07, alt: 'Entrée de cérémonie laïque avec grandes portes blanches fleuries' },
  { src: ceCarousel08, alt: 'Portrait de couple sous une arche pampas et fleurs en soirée' },
  { src: ceCarousel09, alt: 'Portrait de mariés dans une arche florale bohème' },
  { src: ceCarousel10, alt: 'Mariés vus de dos pendant une cérémonie laïque en bord de mer' },
  { src: ceCarousel11, alt: 'Entrée avec portes blanches fleuries vers une cérémonie laïque en plein air' },
  { src: ceCarousel12, alt: 'Cérémonie laïque champêtre avec bottes de paille et fauteuils rotin' },
  { src: ceCarousel13, alt: 'Sortie joyeuse des mariées sous les applaudissements au bord de l’eau' },
  { src: ceCarousel14, alt: 'Mariés assis sur fauteuils en rotin pendant la cérémonie laïque' },
  { src: ceCarousel15, alt: 'Deux mariées assises souriantes pendant la cérémonie laïque' },
  { src: ceCarousel16, alt: 'Deux mariées éclatant de rire pendant la cérémonie laïque' },
  { src: ceCarousel17, alt: 'Moment d’émotion entre deux mariées pendant la cérémonie laïque' },
  { src: ceCarousel18, alt: 'Hug collectif et discours émouvant pendant une cérémonie laïque' },
  { src: ceCarousel19, alt: 'Allée de cérémonie laïque décorée de compositions florales colorées' },
  { src: ceCarousel20, alt: 'Chaises blanches décorées pour une cérémonie laïque en extérieur' },
  { src: ceCarousel21, alt: 'Allée de cérémonie laïque tropicale ornée de palmiers et compositions florales colorées' },
  { src: ceCarousel22, alt: 'Arche en bois drapée de voilages blancs ouvrant sur une allée fleurie' },
  { src: ceCarousel23, alt: 'Vue aérienne d’une cérémonie laïque en extérieur avec disposition de chaises en éventail' },
  { src: ceCarousel24, alt: 'Détail de chaises blanches alignées au cordeau près d’un parterre fleuri' },
  { src: ceCarousel25, alt: 'Composition florale pastel d’hortensias et gypsophile au pied d’une chaise de cérémonie' },
  { src: ceCarousel26, alt: 'Décor bohème de cérémonie laïque avec bancs en bois, coussins berbères et plumes de pampa' },
  { src: ceCarousel27, alt: 'Composition florale automnale avec roses orange, pampas et eucalyptus en bord d’allée' },
  { src: ceCarousel28, alt: 'Arche de cérémonie laïque en intérieur avec drapés rouges et fauteuils en rotin' },
  { src: ceCarousel29, alt: 'Officiante de cérémonie laïque s’adressant aux mariés assis sur des fauteuils en rotin' },
  { src: ceCarousel30, alt: 'Officiante célébrant une cérémonie laïque devant les invités et les mariés émus' },
  { src: ceCarousel31, alt: 'Officiant masculin célébrant une cérémonie laïque sous une arche pampas en plein air' },
  { src: ceCarousel32, alt: 'Portrait d’une officiante au micro lors d’une cérémonie laïque en bord d’étang' },
  { src: ceCarousel33, alt: 'Officiante en robe orange célébrant une cérémonie laïque pour deux mariées au bord de l’eau' },
  { src: ceCarousel34, alt: 'Officiante animant une cérémonie laïque sous une tonnelle face à deux mariées' },
  { src: ceCarousel35, alt: 'Officiante et témoins prenant la parole pendant une cérémonie laïque en grande salle' },
  { src: ceremonyContent2, alt: 'Officiante au micro accompagnant les mariés pendant la signature des engagements' },
  { src: ceCarousel38, alt: 'Rituel des mains liées par des cordes tressées pendant une cérémonie laïque' },
  { src: ceremonyContent3, alt: 'Rituel du sable mêlé entre les mariés pendant une cérémonie laïque' },
  { src: ceCarousel40, alt: 'Rituel du ruban multicolore liant les mains des mariés pendant une cérémonie laïque' },
  { src: ceCarousel41, alt: 'Rituel des rubans colorés noués autour des mains des mariés en plein air' },
  { src: ceCarousel42, alt: 'Rituel du bouquet partagé entre la mariée et un proche pendant la cérémonie laïque' },
  { src: ceCarousel43, alt: 'Rituel du sable à quatre mains versé dans un sablier doré pendant une cérémonie laïque' },
  { src: ceCarousel44, alt: 'Rituel du sable partagé entre les mariées et leurs témoins dans un sablier' },
  { src: ceCarousel45, alt: 'Rituel de la capsule temporelle, mariés scellant une boîte en bois pendant la cérémonie' },
  { src: ceremonyContent4, alt: 'Rituel des fils tissés au-dessus des mariés par les invités pendant la cérémonie laïque' },
  { src: ceCarousel47, alt: 'Rituel du sable célébré par l’officiante avec les mariés autour d’un sablier' },
  { src: ceCarousel48, alt: 'Rituel du sable versé dans une fiole décorée lors d’une cérémonie laïque' },
  { src: ceCarousel49, alt: 'Rituel du sable scellé dans une fiole avec un cœur en bois pendant la cérémonie laïque' },
  { src: ceCarousel50, alt: 'Mariée écoutant les vœux de son partenaire au micro pendant la cérémonie laïque' },
  { src: ceCarousel51, alt: 'Mariées échangeant leurs vœux au micro devant un arche fleurie en pampa lors d’une cérémonie laïque' },
  { src: ceCarousel52, alt: 'Mariés se découvrant pour la première fois sous un grand arbre orné de fleurs lors des vœux' },
  { src: ceCarousel53, alt: 'Mariée prononçant ses vœux au micro devant son fiancé lors d’une cérémonie laïque en plein air' },
  { src: ceCarousel54, alt: 'Mariés main dans la main devant l’arche de cérémonie laïque sous une tente transparente' },
];

const OfficiantImageCarousel = () => <ImageCarouselSection images={officiantCarouselImages} title="Nos cérémonies en images" />;

const artRueCarouselImages: { src: string; alt: string }[] = [
  { src: arCarousel01, alt: "Fanfare festive avec danseuses brésiliennes en plumes pour animation événementielle" },
  { src: arCarousel02, alt: "Char lumineux illuminé dans une parade nocturne" },
  { src: arCarousel03, alt: "Cirque de rue avec acrobates sur une place" },
  { src: arCarousel04, alt: "Échassières en costumes féeriques dans un festival" },
  { src: arCarousel05, alt: "Fanfare défilant dans les rues pavées" },
  { src: arCarousel06, alt: "Cracheur de feu spectaculaire dans la nuit" },
  { src: arCarousel07, alt: "Artiste LED créant des spirales lumineuses" },
  { src: arCarousel08, alt: "Jongleur saltimbanque sur une place européenne" },
  { src: arCarousel09, alt: "Mascottes colorées animant un festival pour enfants" },
  { src: arCarousel10, alt: "Combat de chevaliers spectacle médiéval" },
  { src: arCarousel11, alt: "Statue vivante argentée sur une place publique" },
  { src: arCarousel12, alt: "Musicien accordéoniste ambianceur de rue" },
  { src: arCarousel13, alt: "Troupe de danse carnaval en parade colorée" },
  { src: arCarousel14, alt: "Feu d'artifice pyrotechnique spectaculaire" },
  { src: arCarousel15, alt: "Saltimbanque acrobate en équilibre sur chaises" },
  { src: arCarousel16, alt: "Échassiers papillons LED dans la nuit" },
  { src: arCarousel17, alt: "Troubadour médiéval jouant du luth" },
  { src: arCarousel18, alt: "Char décoré avec confettis dans un grand défilé" },
  { src: arCarousel19, alt: "Danseur de feu avec spirales de flammes" },
  { src: arCarousel20, alt: "Théâtre de rue avec comédiens costumés" },
  { src: arCarousel21, alt: "Échassières anges lumineux au marché de Noël" },
  { src: arCarousel22, alt: "Batucada percussion dans une parade festive" },
  { src: arCarousel23, alt: "Jongleur de feu avec torches enflammées" },
  { src: arCarousel24, alt: "Artiste monocycliste dans un festival de rue" },
  { src: arCarousel25, alt: "Grande parade de rue avec mascottes et chars" },
  { src: artRueMime01, alt: "Mime de rue en performance silencieuse devant le public" },
  { src: artRueMime02, alt: "Artiste mime et statue vivante en animation de rue" },
  { src: artRueMime04, alt: "Comédien mime en costume lors d'une déambulation" },
  { src: artRuePoint10MimeStatue, alt: "Statue vivante dans une ambiance de spectacle de rue" },
  { src: artRueMime07, alt: "Automate vivant en pose lors d'une animation urbaine" },
  { src: artRueMime08, alt: "Mime contemporain en représentation en extérieur" },
  { src: artRueMime378, alt: "Artiste suiveur en costume pour animation immersive de rue" },
  { src: artRueMime379, alt: "Personnage de théâtre de rue en déambulation visuelle" },
  { src: artRueMusique01, alt: "Musicien de rue jouant de la guitare au coucher du soleil" },
  { src: artRueMusique02, alt: "Homme orchestre coloré animant une place en plein air" },
  { src: artRueMusique03, alt: "Musicien avec orgue de Barbarie souriant au public" },
  { src: artRueMusique04, alt: "Enfants admirant un orgue de Barbarie en animation de rue" },
  { src: artRueMusique06, alt: "Musicien country en performance avec colombe" },
  { src: artRueMusique07, alt: "Musicien de rue sous les projecteurs en soirée" },
  { src: artRueMusique08, alt: "Musiciens jouant dans une rue animée" },
  { src: artRueMusique09, alt: "Groupe de rue et foule réunis en plein air" },
  { src: artRueMusique10, alt: "Violoniste en animation dans une rue européenne" },
  { src: artRueDanse01, alt: "Danseurs de carnaval brésilien en parade festive" },
  { src: artRueDanse02, alt: "Troupe de danse brésilienne en costume coloré" },
  { src: artRueDanse03, alt: "Danseuses de parade samba lors d'un défilé" },
  { src: artRueDanse04, alt: "Danseuse de carnaval en costume bleu et argent" },
  { src: artRueDanse05, alt: "Parade brésilienne en rue avec danseurs costumés" },
  { src: artRueDanse06, alt: "Danseurs tropicaux en procession festive" },
  { src: artRueDanse07, alt: "Danseuse en costume tribal lors d'un show visuel" },
  { src: artRueDanse08, alt: "Danseuses de carnaval en costumes glamour orange" },
  { src: artRueDanse09, alt: "Danseuses de troupe en coulisses avant le spectacle" },
  { src: artRueDanse10, alt: "Danseuses de carnaval en tenue étincelante argentée" },
  { src: artRueDanse11, alt: "Défilé en costumes colorés avec plumes en plein jour" },
  { src: artRueDanse12, alt: "Défilé nocturne lumineux et coloré en rue" },
  { src: artRueDanse13, alt: "Parade colorée dans les rues de la ville" },
  { src: artRueDanse14, alt: "Danseuses brésiliennes en parade avec ailes blanches et or" },
  { src: artRueDanse15, alt: "Performeuse impériale en costume doré rayonnant" },
  { src: artRueDanse16, alt: "Danseuses à pom-poms lors d'un événement sportif" },
  { src: artRueDanse17, alt: "Chorégraphie synchronisée pendant un show sportif" },
  { src: artRueLed01, alt: "Humanoïde lumineux en concert visuel avec guitare LED" },
];

const ArtRueImageCarousel = () => <ImageCarouselSection images={artRueCarouselImages} title="L'art de la rue en images" />;

const artSceneCarouselImages: { src: string; alt: string }[] = [
  { src: '/art-de-la-scene/comedien-01-faux-serveur-mariage.png', alt: 'Comédien infiltré faux serveur lors d’un mariage' },
  { src: '/art-de-la-scene/comedien-02-infiltre-table.png', alt: 'Comédien infiltré humour à table en soirée' },
  { src: '/art-de-la-scene/comedien-03-infiltre-coupes.png', alt: 'Comédien infiltré servant des coupes lors d’un cocktail' },
  { src: '/art-de-la-scene/comedien-04-faux-serveur-plat.png', alt: 'Faux serveur comique présentant un plat au restaurant' },
  { src: '/art-de-la-scene/comedien-05-faux-photographe.png', alt: 'Faux photographe comédien infiltré au moment du baiser des mariés' },
  { src: '/art-de-la-scene/comedien-06-faux-vigile.png', alt: 'Faux vigile comédien infiltré lors d’un mariage' },
  { src: '/art-de-la-scene/comedien-07-flash-mob.png', alt: 'Flash mob de danseurs en pleine performance urbaine' },
  { src: '/art-de-la-scene/ambianceur-01-pole-dance-blanche.jpg', alt: 'Ambianceuse pole dance en tenue blanche élégante' },
  { src: '/art-de-la-scene/ambianceur-02-pole-dance-aerienne.jpg', alt: 'Ambianceuse pole dance figure aérienne avec tissus rouges' },
  { src: '/art-de-la-scene/ambianceur-03-pole-dance-acrobatique.png', alt: 'Ambianceuse pole dance figure acrobatique scénique' },
  { src: '/art-de-la-scene/burlesque-cabaret-01-eventail-rouge.png', alt: 'Artiste burlesque cabaret en corset noir avec éventails de plumes rouges' },
  { src: '/art-de-la-scene/streetdance1-01-cheer-acrobatique.jpg', alt: 'Danse urbaine sportive avec porté acrobatique en tenue violette' },
  { src: '/art-de-la-scene/streetdance1-02-show-basket.png', alt: 'Show de danse urbaine en arena avec troupe sur parquet' },
  { src: '/art-de-la-scene/streetdance1-03-breakdance-battle.jpg', alt: 'Battle de breakdance en extérieur devant un public' },
  { src: '/art-de-la-scene/streetdance1-04-cheer-bleu.png', alt: 'Cheerleaders en bleu et blanc en performance sur terrain' },
  { src: '/art-de-la-scene/streetdance2-01-danse-trio-violet.jpg', alt: 'Trio de danse urbaine en lumière violette sur scène' },
  { src: '/art-de-la-scene/streetdance2-02-cheer-basket-rouge.png', alt: 'Danseuses urbaines en formation sur parquet de basket' },
  { src: '/art-de-la-scene/streetdance2-03-breakdance-club.jpg', alt: 'Breakdance en club sous projecteur' },
  { src: '/art-de-la-scene/streetdance2-04-breakdance-salle.jpg', alt: 'Breakdance en démonstration devant le public' },
  { src: '/art-de-la-scene/streetdance2-05-cheer-noel.png', alt: 'Troupe de danseuses en costumes rouges et blancs' },
  { src: '/art-de-la-scene/streetdance2-06-halloween.png', alt: 'Troupe de danse urbaine sur thème Halloween' },
  { src: '/art-de-la-scene/streetdance2-07-cheer-quai.png', alt: 'Cheerleaders et danseurs avec pompons dorés en extérieur' },
  { src: '/art-de-la-scene/streetdance2-08-breakdance-scene.png', alt: 'Breakdance sur scène avec fumée rouge et bleue' },
  { src: '/art-de-la-scene/streetdance2-09-crew-collage.png', alt: 'Collage street dance entre cheerleaders et crew urbain' },
  { src: '/art-de-la-scene/streetdance3-01-cheer-ligne-bleue.png', alt: 'Ligne de cheerleaders en bleu et blanc sur terrain' },
  { src: '/art-de-la-scene/streetdance3-02-cheer-or-noir.png', alt: 'Cheerleaders en tenues or et noir sur pelouse' },
  { src: '/art-de-la-scene/streetdance3-03-breakdance-saut.png', alt: 'Saut acrobatique de breakdance en costumes bordeaux' },
  { src: '/art-de-la-scene/streetdance3-04-show-arena-blanc.png', alt: 'Show de danse urbaine en blanc sur parquet d’arena' },
  { src: '/art-de-la-scene/streetdance3-05-acrobatie-basket.png', alt: 'Acrobatie urbaine au milieu d’un terrain de basket' },
  { src: '/art-de-la-scene/streetdance3-06-cheer-arena-or.png', alt: 'Cheerleaders avec pompons dorés dans une arena' },
  { src: '/art-de-la-scene/streetdance3-07-cheer-scene-acrobatique.jpg', alt: 'Cheerleading scénique avec grand écart acrobatique' },
  { src: '/art-de-la-scene/streetdance3-08-cheer-bleu-rouge.png', alt: 'Cheerleaders en bleu et rouge en performance sportive' },
  { src: '/art-de-la-scene/onemanshow-01-improvisation-theatre.png', alt: 'Humoriste one man show en improvisation théâtre sur scène' },
  { src: '/art-de-la-scene/hypnose-01-scene-dramatique.png', alt: 'Spectacle d’hypnose sur scène avec éclairage dramatique' },
  { src: '/art-de-la-scene/hypnose-02-public-participatif.png', alt: 'Hypnotiseur avec participation du public en animation scénique' },
  { src: '/art-de-la-scene/flair-01-bouteille-bras.jpg', alt: 'Jongleur de bar en équilibre avec bouteille sur le bras' },
  { src: '/art-de-la-scene/flair-02-bouteille-feu.png', alt: 'Flair bartender avec bouteille enflammée en animation cocktail' },
  { src: '/art-de-la-scene/flair-03-cocktails-service.jpg', alt: 'Barman flair préparant deux cocktails colorés' },
  { src: '/art-de-la-scene/flair-04-shaker-bouteille.png', alt: 'Jongleur de bar lançant shaker et bouteille derrière le comptoir' },
  { src: '/art-de-la-scene/flair-05-equilibre-feu.jpg', alt: 'Barman flair équilibrant des bouteilles enflammées' },
  { src: '/art-de-la-scene/flair-06-jonglage-bouteilles.jpg', alt: 'Show de jonglage de bouteilles par un barman flair' },
  { src: '/art-de-la-scene/flair-07-equilibre-biere.jpg', alt: 'Barman flair en équilibre avec bouteille sur le visage' },
  { src: '/art-de-la-scene/flair-08-shaker-bar.jpg', alt: 'Bartender jonglant avec un shaker dans un bar élégant' },
  { src: '/art-de-la-scene/flair-09-mixologie-fumee.jpg', alt: 'Mixologie spectaculaire avec fumée et verrerie de bar' },
  { src: '/art-de-la-scene/flair-10-bouteille-equilibre-scene.jpg', alt: 'Flair bartender sur scène avec bouteille en équilibre' },
  { src: '/art-de-la-scene/flair-11-shaker-glace-fumee.jpg', alt: 'Barman versant un cocktail avec effet de fumée glacée sur des verres à martini' },
  { src: '/art-de-la-scene/flair-12-pyramide-cocktails.jpg', alt: 'Barman réalisant une pyramide de cocktails colorés en cascade' },
  { src: '/art-de-la-scene/flair-13-barman-chateau-coucher-soleil.jpg', alt: 'Barman élégant devant un château au coucher de soleil avec cocktails signature' },
  { src: '/art-de-la-scene/flair-14-barman-souriant-cocktails-chateau.jpg', alt: 'Barman souriant présentant une sélection de cocktails lors d\'une réception au château' },
  { src: '/art-de-la-scene/led-01-fee-lumineuse-rubans.jpg', alt: 'Fée lumineuse LED en déambulation avec rubans lumineux multicolores' },
  { src: '/art-de-la-scene/led-02-duo-poi-feu-lumiere.png', alt: 'Duo d\'artistes en spectacle de poï mêlant feu et lumière' },
  { src: '/art-de-la-scene/led-03-robot-led-deambulation.jpg', alt: 'Robot LED géant en déambulation interactive lors d\'une fête foraine' },
  { src: '/art-de-la-scene/led-04-papillon-lumineux-ailes.png', alt: 'Performeuse papillon lumineux LED aux grandes ailes irisées' },
  { src: '/art-de-la-scene/led-05-echassier-led-pyrotechnie.jpg', alt: 'Échassier LED avec ailes pyrotechniques étincelantes en pleine nuit' },
  { src: '/art-de-la-scene/led-06-poi-lumineux-spirale.png', alt: 'Danseuse réalisant des spirales lumineuses en poï LED violet et orange' },
  { src: '/art-de-la-scene/led-07-echassier-papillon-led.jpg', alt: 'Échassier papillon LED aux ailes bleues lumineuses en déambulation événementielle' },
  { src: '/art-de-la-scene/led-08-robot-led-geant.png', alt: 'Robot LED géant tout en bandes lumineuses bleues et rouges sur scène' },
  { src: '/art-de-la-scene/led-09-duo-robot-fee-led.png', alt: 'Duo robot LED et fée lumineuse en performance scénique colorée' },
  { src: '/art-de-la-scene/led-10-cerceau-aerien-lumineux.png', alt: 'Acrobate aérienne dans un cerceau lumineux LED en spectacle nocturne' },
  { src: '/art-de-la-scene/led-11-troupe-led-anneaux-magiques.png', alt: 'Troupe d’artistes LED avec anneaux lumineux dans une mise en scène théâtrale' },
  { src: '/art-de-la-scene/led-12-jongleur-anneaux-lumineux.png', alt: 'Jongleur manipulant des anneaux LED verts et ambrés dans l’obscurité' },
  { src: '/art-de-la-scene/led-13-performeuse-led-rose-visiere.png', alt: 'Performeuse LED rose et violet avec visière lumineuse futuriste' },
  { src: '/art-de-la-scene/led-14-fee-lumineuse-ailes-bleues.png', alt: 'Fée lumineuse aux grandes ailes LED bleues sur fond noir' },
  { src: '/art-de-la-scene/led-15-papillon-led-bleu-nocturne.png', alt: 'Papillon LED bleu nocturne en pleine extension d’ailes lumineuses' },
  { src: '/art-de-la-scene/led-16-artiste-feu-dore-symetrique.png', alt: 'Artiste lumineux créant une composition symétrique dorée en longue exposition' },
  { src: '/art-de-la-scene/led-17-duo-barres-lumineuses.png', alt: 'Duo d’artistes manipulant des barres lumineuses dans une ambiance rouge et bleue' },
  { src: '/art-de-la-scene/led-18-duo-robots-led-tricolores.png', alt: 'Duo de robots LED tricolores en déambulation nocturne' },
  { src: '/art-de-la-scene/led-19-fee-led-violette.png', alt: 'Fée LED violette en gros plan avec costume lumineux futuriste' },
  { src: '/art-de-la-scene/magie-06-montres-illusion.png', alt: 'Magicien réalisant une illusion visuelle avec des montres en gros plan' },
  { src: '/art-de-la-scene/magie-07-tour-jury.jpg', alt: 'Magicien en interaction avec le public et le jury lors d’un tour de scène' },
  { src: '/art-de-la-scene/magie-08-scene-cage.png', alt: 'Illusionniste sur scène présentant un numéro visuel avec une cage' },
  { src: '/art-de-la-scene/magie-09-closeup-reception.jpg', alt: 'Magicien close-up animant une réception avec humour et surprise' },
  { src: '/art-de-la-scene/magie-10-tour-cocktail.png', alt: 'Magicien réalisant un tour de close-up lors d’un cocktail entre invités' },
  { src: '/art-de-la-scene/magie-11-ruban-anneau-closeup.jpg', alt: 'Tour de magie close-up avec anneau suspendu à un ruban rouge devant les invités' },
  { src: '/art-de-la-scene/magie-12-closeup-mariage-calculatrice.jpg', alt: 'Magicien close-up réalisant un tour interactif autour d’une calculatrice lors d’un mariage' },
  { src: '/art-de-la-scene/magie-13-cartes-volantes-closeup.jpg', alt: 'Magicien en close-up réalisant une cascade de cartes volante lors d’un événement' },
  { src: '/art-de-la-scene/sosie-01-chanteur-blond-scene.png', alt: 'Sosie chanteur blond sur scène avec micro et costume militaire' },
  { src: '/art-de-la-scene/sosie-02-portrait-rock-miroir.jpg', alt: 'Portrait dramatique d’un sosie rock devant un miroir brisé' },
  { src: '/art-de-la-scene/sosie-03-tribute-edith-piaf.png', alt: 'Sosie vocal et physique d’Édith Piaf sur scène devant un micro vintage' },
  { src: '/art-de-la-scene/sosie-04-chanteur-guitare-scene.webp', alt: 'Sosie chanteur à la guitare en concert sous lumière bleue' },
  { src: '/art-de-la-scene/sosie-05-artiste-rousse-scene.jpg', alt: 'Sosie chanteuse rousse en tenue de scène noire avec coiffure iconique' },
  { src: '/art-de-la-scene/sosie-06-tribute-celine-dion.png', alt: 'Tribute Céline Dion en concert avec micro et éclairages de scène' },
  { src: '/art-de-la-scene/sosie-07-chanteur-smoking-scene.webp', alt: 'Sosie chanteur en smoking pailleté interprétant un concert live' },
  { src: '/art-de-la-scene/sosie-08-chanteur-rock-foulard-rouge.jpg', alt: 'Sosie chanteur rock au blouson cuir et foulard rouge sur scène' },
  { src: '/art-de-la-scene/sosie-09-trio-costumes-noirs.png', alt: 'Trio de sosies masculins en costumes noirs et lunettes noires' },
  { src: '/art-de-la-scene/sosie-10-troupe-humoristique-cabaret.jpg', alt: 'Troupe de sosies humoristiques en costume de cabaret avec hôtesses' },
  { src: '/art-de-la-scene/sosie-11-veste-sequin-rouge-bleu.png', alt: 'Sosie chanteur en veste à sequins rouge, bleu et or, chemise satinée rouge' },
  { src: '/art-de-la-scene/sosie-12-tribute-michael-jackson.png', alt: 'Tribute Michael Jackson sur scène, veste à sequins noire et gant blanc' },
  { src: '/art-de-la-scene/sosie-13-tribute-elvis-presley.png', alt: 'Tribute Elvis Presley en combinaison blanche à strass, guitare et micro' },
  { src: '/art-de-la-scene/theatre-01-troupe-clowns-valises.png', alt: 'Troupe de théâtre en costumes et maquillages clownesques avec malles et valises' },
  { src: '/art-de-la-scene/theatre-02-comedie-duo-costumes.png', alt: 'Duo de comédiens en costumes d\'époque dans une pièce de théâtre comique' },
  { src: '/art-de-la-scene/coulisses-01-cyrille-acrobate-aerienne.jpg', alt: 'Cyrille Lecourt en coulisses avec une acrobate aérienne en costume doré et fleur de lotus avant son numéro' },
  { src: '/art-de-la-scene/coulisses-02-cyrille-danseuses-cabaret.jpg', alt: 'Cyrille Lecourt en costume avec deux danseuses de cabaret en tenues à strass rouge et noire devant un décor de Noël' },
  { src: '/art-de-la-scene/serveuse-01-bar-fleuri-coupes.webp', alt: 'Bar fleuri doré présentant coupes de champagne et verrines colorées en réception' },
  { src: '/art-de-la-scene/serveuse-02-robe-candy-cupcakes.webp', alt: 'Serveuse en robe candy rose présentant un plateau de cupcakes lumineux' },
  { src: '/art-de-la-scene/serveuse-03-robe-strass-plateau-led.webp', alt: 'Serveuse en robe strass argentée avec plateau LED de coupes de champagne' },
  { src: '/art-de-la-scene/serveuse-04-futuriste-argent-cuilleres.webp', alt: 'Serveuse futuriste en combinaison argentée avec plateau LED de cuillères apéritives' },
  { src: '/art-de-la-scene/serveuse-05-duo-corsets-cabaret-canapes.webp', alt: 'Duo de serveuses en corsets cabaret avec plateaux lumineux de canapés et bonbons' },
  { src: '/art-de-la-scene/serveuse-06-robe-champagne-doree-coupes.webp', alt: 'Robe à champagne dorée scintillante portant des coupes pour service en soirée de gala' },
  { src: '/art-de-la-scene/serveuse-07-robe-champagne-blanche-tutu.webp', alt: 'Robe à champagne blanche avec tutu et coupes en cascade lumineuse' },
  { src: '/art-de-la-scene/serveuse-08-collage-robes-champagne-canapes.webp', alt: 'Collage de serveuses en robes à champagne et plateaux de canapés en réception' },
  { src: '/art-de-la-scene/serveuse-09-duo-anges-plumes-canapes.webp', alt: 'Duo de serveuses ailées en plumes blanches portant des plateaux lumineux de coupes roses et canapés' },
  { src: '/art-de-la-scene/serveuse-10-robe-champagne-cirque-rouge.webp', alt: 'Serveuse en costume cirque rouge et or portant une robe à champagne dans un décor d\'orgue de Barbarie' },
  { src: '/art-de-la-scene/serveuse-11-robe-champagne-ombrelle-exterieur.webp', alt: 'Serveuse en robe à champagne dorée avec ombrelle en dentelle en extérieur ensoleillé' },
  { src: '/art-de-la-scene/serveuse-12-trio-plumes-bleues-plateaux-led.webp', alt: 'Trio de serveuses showgirls en plumes bleues avec plateaux LED de coupes de champagne' },
  { src: '/art-de-la-scene/serveuse-13-robe-champagne-noire-roses.webp', alt: 'Serveuse en robe à champagne noire à strass ornée de bouquets de roses roses' },
  { src: '/art-de-la-scene/serveuse-14-table-led-shooters-lounge.webp', alt: 'Table LED lumineuse de shooters portée par une danseuse en corset à franges en ambiance lounge' },
  { src: '/art-de-la-scene/serveuse-15-robe-doree-cuilleres-canapes.webp', alt: 'Robe dorée scintillante avec plateau lumineux de cuillères apéritives et coupes de champagne' },
  { src: '/art-de-la-scene/serveuse-16-plumes-blanches-plateau-mignardises.webp', alt: 'Serveuse showgirl en plumes blanches avec plateau lumineux de mignardises sucrées' },
];

const ArtSceneImageCarousel = () => <ImageCarouselSection images={artSceneCarouselImages} title="L'art de la scène en images" />;

const artsVisuelsCarouselImages: { src: string; alt: string }[] = [
  { src: avSilhouettistePortraitRue, alt: 'Silhouettiste de rue présentant un portrait découpé à un jeune homme' },
  { src: artsVisuelsContent2, alt: 'Caricaturiste en plein air dessinant le portrait d\u00A0une jeune femme' },
  { src: avSilhouettisteRue, alt: 'Silhouettiste découpant le profil d\u00A0une jeune femme dans la rue' },
  { src: avCaricatureRibery, alt: 'Portrait caricatural de Franck Ribéry en maillot des Bleus' },
  { src: avCaricatureGainsbourg, alt: 'Portrait caricatural de Serge Gainsbourg fumant une cigarette' },
  { src: avCaricaturesFamille, alt: 'Famille souriante tenant plusieurs portraits caricaturaux en noir et blanc' },
  { src: avCaricaturesHumoristiques, alt: 'Montage de portraits et caricatures humoristiques pour adultes et enfants' },
  { src: avSilhouettePrecision, alt: 'Silhouettiste découpant avec précision un profil noir sur carton blanc' },
  { src: avGarconPortraitCaricatural, alt: 'Jeune garçon tenant son portrait caricatural en noir et blanc' },
  { src: avSpeedpaintingChevalLive, alt: 'Performance de speed painting en extérieur devant une œuvre équestre monumentale' },
  { src: avSpeedpaintingDuoNeon, alt: 'Œuvre speed painting néon représentant deux visages en violet et bleu' },
  { src: avSpeedpaintingScenePortrait, alt: 'Artiste de speed painting sur scène devant un portrait en cours de création' },
  { src: avGlitterMercedesClasseB, alt: 'Glitter painting révélant une Mercedes Classe B sur fond coloré' },
  { src: avSpeedpaintingScenePortrait2, alt: 'Performeur de speed painting à genoux sur scène devant un portrait lumineux' },
  { src: avGlitterMercedesLogo, alt: 'Glitter painting du logo Mercedes-Benz avec coulures multicolores' },
  { src: avGlitterMariagePoussiere, alt: 'Performance glitter painting dévoilant le portrait d\u00A0un couple de mariés' },
  { src: artsVisuelsPoint3, alt: 'Mariés posant devant une œuvre speed painting de leur portrait en bleu et rose' },
  { src: avGlitterPortraitFemme, alt: 'Glitter painting sur fond noir révélant le portrait lumineux d\u2019une femme' },
  { src: avGlitterCitroenStage, alt: 'Œuvre glitter painting Citroën exposée sur scène sous des lumières violettes' },
  { src: avGlitterMariageCoupleCouleurs, alt: 'Glitter painting coloré révélant le portrait d\u2019un couple de mariés' },
  { src: avGlitterDsAutomobiles, alt: 'Glitter painting DS Automobiles avec coulures bleues, vertes et roses' },
  { src: avSpeedpaintingPortraitDuoBleu, alt: 'Portrait duo bleu en speed painting exposé en extérieur' },
  { src: avGlitterPortraitHommeCigarette, alt: 'Portrait glitter d\u2019un homme fumant une cigarette sur fond vert et bleu' },
  { src: avSpeedpaintingCoupleAtelier, alt: 'Couple posant devant un portrait speed painting bleu et vert en atelier' },
  { src: avGlitterGainsbourgBirkin, alt: 'Œuvre glitter painting représentant un duo iconique sur fond noir' },
  { src: avArtsVisuelsCollage, alt: 'Collage arts visuels mêlant glitter painting, portrait de couple et caricatures en noir et blanc' },
  { src: avBodyPaintingGala, alt: 'Body painting intégral coloré présenté lors d\u2019une soirée de gala' },
  { src: artsVisuelsContent1, alt: 'Body painting artistique en backstage avec deux maquilleuses au travail' },
];

const ArtsVisuelsImageCarousel = () => <ImageCarouselSection images={artsVisuelsCarouselImages} title="Les arts visuels en images" />;

const enfantsCarouselImages: { src: string; alt: string }[] = [
  { src: enAtelierCreatif01, alt: 'Atelier créatif scolaire\u00A0: enfants réalisant des bracelets en perles autour d\u2019une table' },
  { src: enAtelierCreatif02, alt: 'Atelier créatif enfants\u00A0: mains modelant l\u2019argile dans un bol en céramique' },
  { src: enAtelierCreatif03, alt: 'Atelier créatif enfants\u00A0: découpage et collage de papiers colorés autour d\u2019une grande table' },
  { src: enAtelierCreatif04, alt: 'Atelier créatif scrapbooking adultes et enfants avec rubans, paillettes et fleurs' },
  { src: enAtelierCreatif05, alt: 'Anniversaire enfants\u00A0: enfants joyeux allongés sous une pluie de confettis colorés' },
  { src: enAtelierCreatif06, alt: 'Atelier créatif parents-enfants\u00A0: peinture d\u2019œufs de Pâques violets' },
  { src: enAtelierCreatif07, alt: 'Atelier poterie enfants et adultes\u00A0: modelage et décoration de céramiques' },
  { src: enAtelierCreatif08, alt: 'Atelier peinture\u00A0: petite fille rieuse formant un cœur avec ses mains peintes' },
  { src: enAtelierCreatif09, alt: 'Atelier artistique\u00A0: mains préparant des pinceaux et pots de peinture sur un plan de travail' },
  { src: enAtelierCreatif10, alt: 'Atelier aquarelle enfants et adultes avec palettes de couleurs et pinceaux' },
  { src: enChasseTresor01, alt: 'Chasse au trésor pour événement familial\u00A0: carte ancienne déployée et marquée d\u2019une croix rouge' },
  { src: enChasseTresor02, alt: 'Chasse au trésor en intérieur\u00A0: enfants concentrés sur des indices accompagnés d\u2019une animatrice' },
  { src: enChasseTresor03, alt: 'Chasse au trésor en forêt\u00A0: deux enfants accroupis cherchant un indice dans les feuilles d\u2019automne' },
  { src: enChasseTresor04, alt: 'Chasse au trésor sur le thème pirates\u00A0: enfants joyeux avec longue-vue, carte et chapeau de pirate' },
  { src: enChasseTresor05, alt: 'Chasse au trésor en pleine nature\u00A0: coffre rempli de pièces d\u2019or, carte au trésor et boussole en forêt' },
  { src: enChasseTresor06, alt: 'Chasse au trésor en site patrimonial\u00A0: enfants explorateurs ouvrant un coffre avec une animatrice' },
  { src: enChasseTresor07, alt: 'Chasse au trésor familiale\u00A0: enfants découvrant une carte au trésor avec une animatrice dans un parc' },
  { src: enChasseTresor08, alt: 'Chasse au trésor pirates\u00A0: enfants avec chapeaux de pirate observant un trésor de pierres précieuses' },
  { src: enCirqueClown01, alt: 'Spectacle enfants clown et magie\u00A0: mime au béret jaune sur fond noir' },
  { src: enCirqueClown02, alt: 'Duo de clowns comiques\u00A0: personnages costumés pointant du doigt dans un décor théâtral' },
  { src: enCirqueClown03, alt: 'Clown sur scène\u00A0: artiste au nez rouge dansant avec une ombrelle pendant le spectacle' },
  { src: enCirqueClown04, alt: 'Sculpteur de bulles géantes\u00A0: duo de clowns colorés réalisant une immense bulle' },
  { src: enCirqueClown05, alt: 'Moment festif cirque\u00A0: duo de clowns aviateurs posant avec leurs malles' },
  { src: enCirqueClown06, alt: 'Tour de magie clownesque\u00A0: clown sur piste de cirque devant un décor rouge' },
  { src: enCirqueClown07, alt: 'Fête colorée avec clown et enfant\u00A0: échange complice au milieu de ballons multicolores' },
  { src: enCirqueClown08, alt: 'Clowns décalés sur tandem rouge\u00A0: duo costumé en uniforme sur vélo de parade' },
  { src: enCirqueClown09, alt: 'Clown pour enfants en extérieur\u00A0: artiste réalisant un ballon rose lors d\u2019une animation' },
  { src: enCirqueNoel01, alt: 'Cirque pour arbre de Noël\u00A0: décor de piste rouge avec rideaux, accessoires et mise en scène festive' },
  { src: enConteEnfants01, alt: 'Conte pour enfants sur scène\u00A0: troupe en costume lançant des serpentins pendant un spectacle vivant' },
  { src: enConteEnfants02, alt: 'Spectacle de magie de Noël\u00A0: magicien en costume de Père Noël avec lapin blanc et baguette' },
  { src: enConteEnfants03, alt: 'Conte improvisé\u00A0: enfants attentifs participant à une histoire créée en direct' },
  { src: enConteEnfants04, alt: 'La magie du 24\u00A0: comédie musicale féérique de Noël pour petits et grands' },
  { src: enConteEnfants05, alt: 'Conte de fées\u00A0: univers féérique avec petite fée et château illuminé' },
  { src: enConteEnfants06, alt: 'Conte musical de Noël\u00A0: scène féérique avec clown, Père Noël et enfants devant un sapin illuminé' },
  { src: enConteEnfants07, alt: 'Conte de Noël\u00A0: Père Noël dans un village enneigé au clair de lune' },
  { src: enConteEnfants08, alt: 'Spectacle arbre de Noël\u00A0: affiche illustrée avec rideau de scène vert et sapin décoré' },
  { src: enConteEnfants09, alt: 'Magic show for kids\u00A0: magicien avec lapin et colombes dans une affiche pour enfants' },
  { src: enConteEnfants10, alt: 'Conte fantastique pour enfants\u00A0: vieux magicien lisant un livre lumineux avec un enfant' },
  { src: enConteEnfants11, alt: 'Conte improvisé de Noël\u00A0: Père Noël lisant une histoire à des enfants' },
  { src: enConteEnfants12, alt: 'Conte de Noël improvisé\u00A0: enfant et fée devant un sapin illuminé dans une scène féérique' },
  { src: enEscapeGame01, alt: 'Escape game en famille\u00A0: participants réfléchissant ensemble face à une énigme' },
  { src: enEscapeGame02, alt: 'Escape game enfants\u00A0: groupe explorant une bibliothèque à la recherche d’indices' },
  { src: enEscapeGame03, alt: 'Escape game mystère\u00A0: porte ancienne du Secret Perdu entourée de livres et d’une lanterne' },
  { src: enEscapeGame04, alt: 'Escape game grandeur nature\u00A0: enfants fouillant une pièce secrète et découvrant des objets' },
  { src: enEscapeGame05, alt: 'Escape game à la lampe\u00A0: équipe déchiffrant un cadenas autour d’un livre ancien' },
  { src: enEscapeGame06, alt: 'Escape game immersif\u00A0: pièce sombre avec piano, miroir et porte verrouillée' },
  { src: enEscapeGame07, alt: 'Escape game ado\u00A0: jeunes résolvant ensemble une énigme avec clé et cadenas' },
  { src: enEscapeGame08, alt: 'Escape game immersif\u00A0: coffre ancien révélant le parchemin «\u00A0Trouvez la sortie\u00A0»' },
  { src: enEscapeGame09, alt: 'Escape game mystère\u00A0: cadenas à code et clé ancienne dans une bibliothèque vintage' },
  { src: enEscapeGame10, alt: 'Escape game enfants\u00A0: deux joueurs concentrés résolvant une énigme d’échecs géants' },
  { src: enMaquillageTatouage01, alt: 'Maquillage artistique enfants\u00A0: stand avec palettes de couleurs, pinceaux et modèles de tatouages éphémères' },
  { src: enMaquillageTatouage02, alt: 'Maquillage enfant\u00A0: artiste peignant des motifs violets sur le visage d’une petite fille' },
  { src: enMaquillageTatouage03, alt: 'Maquillage festif\u00A0: modèle adulte avec maquillage hivernal bleu et blanc pour arbre de Noël' },
  { src: enMaquillageTatouage04, alt: 'Maquillage artistique enfant\u00A0: peinture de visage bleue et blanche réalisée au pinceau fin' },
  { src: enMaquillageTatouage05, alt: 'Atelier maquillage enfants\u00A0: animation en cours autour d’un stand de face painting' },
  { src: enMaquillageTatouage06, alt: 'Tatouages pailletés enfants\u00A0: adolescente montrant plusieurs motifs colorés sur les bras et les mains' },
  { src: enMaquillageTatouage07, alt: 'Maquillage papillon enfant\u00A0: petite fille souriante avec peinture faciale colorée en extérieur' },
  { src: enMaquillageTatouage08, alt: 'Maquillage de Noël enfant\u00A0: jeune fille maquillée posant avec le Père Noël devant un sapin lumineux' },
  { src: enMaquillageTatouage09, alt: 'Maquillage chat enfant\u00A0: artiste finalisant un visage félin noir et blanc' },
  { src: enMaquillageTatouage10, alt: 'Maquillage artistique enfant\u00A0: motifs roses et noirs en cours de réalisation sur le visage d’une petite fille' },
  { src: enMaquillageTatouage11, alt: 'Face painting enfant\u00A0: maquillage rose stylisé appliqué avec précision au pinceau' },
  { src: enMaquillageTatouage12, alt: 'Maquillage festif\u00A0: motif de houx et arabesques blanches sur le visage d’une jeune participante' },
  { src: enMaquillageTatouage13, alt: 'Tatouage temporaire enfant\u00A0: petit drapeau appliqué sur la joue lors d’une animation' },
  { src: enMaquillageTatouage14, alt: 'Atelier maquillage de Noël\u00A0: animation en boutique avec artiste maquillant une jeune fille' },
  { src: enMaquillageTatouage15, alt: 'Maquillage renard enfant\u00A0: garçon souriant avec peinture faciale orange et blanche' },
  { src: enMaquillageTatouage16, alt: 'Maquillage féérique enfant\u00A0: artiste réalisant un décor violet et pailleté sur le visage' },
  { src: enMaquillageTatouage17, alt: 'Tatouage pailleté enfant\u00A0: pochoir rose appliqué au pinceau sur l’avant-bras' },
  { src: enMaquillageTatouage18, alt: 'Maquillage de Noël enfant\u00A0: artiste réalisant un visage de Père Noël sur un jeune garçon' },
  { src: enMaquillageTatouage19, alt: 'Tatouage temporaire enfant\u00A0: petit motif cœur et pulsation posé près du cou' },
  { src: enMaquillageTatouage20, alt: 'Maquillage biche enfant\u00A0: jeune fille souriante avec visage animalier pailleté' },
  { src: enMaquillageTatouage21, alt: 'Atelier maquillage enfants\u00A0: animation festive avec maquilleuse en tenue de lutin' },
  { src: enMaquillageTatouage22, alt: 'Stand maquillage artistique\u00A0: palettes, pinceaux, éponges et modèles d’inspiration pour enfants' },
  { src: enMascotte01, alt: 'Mascotte anniversaire enfant\u00A0: ours festif devant une arche de ballons pastel' },
  { src: enMascotte02, alt: 'Mascotte de Pâques\u00A0: personnage animalier en déambulation dans un magasin décoré' },
  { src: enMascotte03, alt: 'Mascottes de Noël\u00A0: duo festif en costumes rouges devant des sapins enneigés' },
  { src: enMascotte04, alt: 'Mascotte événementielle\u00A0: personnage animalier faisant un cœur avec les mains en galerie' },
  { src: enMascotte05, alt: 'Mascotte enfants\u00A0: personnage géant saluant le public lors d’une animation en extérieur' },
  { src: enMascotte06, alt: 'Mascotte fête foraine\u00A0: ours élégant posant devant un manège illuminé' },
  { src: enMascotte07, alt: 'Mascotte événementielle\u00A0: personnage animalier en costume posant dans un décor de château' },
  { src: enMascotte08, alt: 'Mascotte fête foraine\u00A0: chaton géant saluant les visiteurs dans une ambiance lumineuse' },
  { src: enMascotte09, alt: 'Mascotte chaton blanc Marie\u00A0: personnage assis saluant les enfants dans un parc verdoyant' },
  { src: enMascotte10, alt: 'Mascotte lapin brun\u00A0: personnage forestier au nœud coloré déambulant dans les bois' },
  { src: catMascottes, alt: 'Mascottes Mickey et Minnie de Noël\u00A0: duo en tenues festives rouges devant un décor hivernal' },
  { src: enMascotte12, alt: 'Mascotte chaton blanc Marie\u00A0: animation de Pâques dans un centre commercial avec décor floral' },
  { src: enChasseOeufs01, alt: 'Chasse aux œufs avec le lapin de Pâques\u00A0: enfants ramassant des œufs colorés dans une prairie fleurie' },
  { src: enPereNoel01, alt: 'Rencontre magique avec le Père Noël\u00A0: enfant complice échangeant un sourire devant le sapin illuminé' },
  { src: enPereNoel02, alt: 'Noël magique en famille avec le Père Noël\u00A0: deux enfants en bonnets rouges partageant un instant tendre' },
  { src: enPereNoel10, alt: 'Photo de Noël avec le Père Noël\u00A0: portrait d’un frère et d’une sœur encadrés par Santa devant les sapins' },
  { src: enPereNoel04, alt: 'Le secret de Noël\u00A0: enfant chuchotant sa liste de cadeaux à l’oreille du Père Noël' },
  { src: enBallon01, alt: 'Sculpteur sur ballon\u00A0: artiste créant une fleur en ballon devant une petite fille fascinée' },
  { src: enBallon02, alt: 'Sculptures de ballons\u00A0: créations colorées posées sur une table d’animation pendant les fêtes' },
  { src: enBallon03, alt: 'Animation sculpture sur ballon\u00A0: animatrice réalisant des formes pour enfants autour d’une table' },
  { src: enBallon04, alt: 'Ballons sculptés\u00A0: animaux colorés et accessoires exposés sur un stand événementiel' },
  { src: enBallon05, alt: 'Sculptures de ballons\u00A0: modèles colorés posés sur une table d’atelier pendant une animation' },
  { src: enBallon06, alt: 'Sculpteur sur ballon\u00A0: création d’un grand dinosaure en ballon pour un enfant émerveillé' },
  { src: enBallon07, alt: 'Ballons sculptés\u00A0: animaux colorés présentés dans un chapeau de magicien lors d’un événement' },
  { src: enBallon08, alt: 'Sculpteur sur ballon\u00A0: artiste offrant un chien en ballon et une épée à un enfant souriant' },
  { src: enBallon09, alt: 'Bouquet de fleurs en ballons\u00A0: composition colorée réalisée en sculpture sur ballon' },
  { src: enStructureGonflable01, alt: 'Structure gonflable pirate\u00A0: château avec toboggan installé en extérieur pour les enfants' },
  { src: enStructureGonflable30, alt: 'Structure gonflable\u00A0: enfants courant et jouant à l’intérieur d’un grand parcours coloré' },
  { src: enStructureGonflable03, alt: 'Parcours gonflable\u00A0: grande structure bleue, jaune et rouge installée dans un jardin' },
  { src: enStructureGonflable04, alt: 'Château gonflable\u00A0: enfants glissant et s’amusant sur une structure colorée' },
  { src: enStructureGonflable05, alt: 'Toboggan gonflable tropical\u00A0: grande structure installée en extérieur près d’une maison' },
  { src: enStructureGonflable06, alt: 'Structure gonflable\u00A0: groupe d’enfants courant sur un parcours gonflable en plein air' },
  { src: enStructureGonflable07, alt: 'Grand toboggan gonflable\u00A0: structure rouge, jaune et bleue prête pour une animation enfants' },
  { src: enStructureGonflable08, alt: 'Jeu gonflable interactif\u00A0: structure carrée rouge, jaune et bleue avec obstacles centraux' },
  { src: enStructureGonflable09, alt: 'Structure gonflable cirque\u00A0: château coloré avec toboggan rose installé en extérieur' },
  { src: enStructureGonflable10, alt: 'Jeu gonflable interactif\u00A0: seconde vue d’une structure à obstacles rouge, jaune et bleue' },
  { src: enStructureGonflable11, alt: 'Parcours gonflable géant\u00A0: vue d’ensemble d’une longue structure avec toboggan et passages' },
  { src: enStructureGonflable12, alt: 'Taureau mécanique gonflable\u00A0: arène rouge et bleue pour animation événementielle' },
  { src: enStructureGonflable13, alt: 'Toboggan gonflable tropical\u00A0: structure installée sur un parking prête pour une animation enfants' },
  { src: enStructureGonflable14, alt: 'Structure gonflable jungle\u00A0: petit château avec obstacles et toboggan sur pelouse' },
  { src: enStructureGonflable15, alt: 'Château gonflable avion\u00A0: structure aérienne rouge, bleue et noire pour enfants' },
  { src: enStructureGonflable16, alt: 'Structure gonflable féerique\u00A0: château Pixie Land avec grands champignons décoratifs' },
  { src: enStructureGonflable17, alt: 'Structure gonflable pirate\u00A0: bateau de pirate avec toboggan et palmiers pour enfants' },
  { src: enStructureGonflable18, alt: 'Structure gonflable La Plage\u00A0: parcours aquatique avec arche, requin et toboggan' },
  { src: enVentriloque01, alt: 'Affiche spectacle de ventriloquie\u00A0: Le Miroir des rires, La Voix de l’ombre avec Victor et Monsieur Brinquinette' },
  { src: enVentriloque02, alt: 'Ventriloque sur scène avec marionnette orange devant un jeune public attentif' },
  { src: enVentriloque03, alt: 'Animation ventriloque en école primaire\u00A0: marionnette singe et enfants en classe' },
  { src: enVentriloque04, alt: 'Ventriloque et ses deux marionnettes colorées\u00A0: monstre vert et fée rose pour spectacle enfants' },
  { src: enVentriloque05, alt: 'Spectacle de ventriloquie en plein air\u00A0: marionnette singe sur scène devant un public d’enfants' },
  { src: enVentriloque06, alt: 'Ventriloque et marionnette singe violet et orange lors d’un spectacle jeune public' },
  { src: enVentriloque07, alt: 'Ventriloque sur scène avec marionnette verte devant un public d’enfants' },
  { src: enVentriloque08, alt: 'Ventriloque avec marionnette guitariste lors d’un spectacle pour enfants' },
  { src: enVentriloque09, alt: 'Ventriloque et marionnette verte sur tabouret pendant une animation jeune public' },
  { src: enVentriloque10, alt: 'Ventriloque costumé avec marionnette cow-boy lors d’un numéro scénique' },
  { src: enVentriloque11, alt: 'Affiche de spectacle de ventriloquie\u00A0: L’Écho TV, Maîtres de programme avec Geoffroy et Patrice' },
  { src: enVentriloque12, alt: 'Ventriloque sur scène avec marionnette blanche en costume rouge' },
];

const EnfantsImageCarousel = () => <ImageCarouselSection images={enfantsCarouselImages} title="Les animations enfants en images" />;

const animateurCarouselImages: { src: string; alt: string }[] = [
  { src: animateurContent1, alt: 'Animateur micro en costume noir pointant vers le public en extérieur' },
  { src: animateurContent2, alt: 'Animateur micro en costume bleu sur scène avec éclairage de spectacle' },
  { src: amCarousel03, alt: 'Animateur micro énergique sur scène devant un rideau de théâtre' },
  { src: amCarousel04, alt: 'Maîtres de cérémonie variés animant des réceptions de mariage au micro' },
  { src: amCarousel05, alt: 'Animateurs micro variés en représentation devant un large public' },
];

const mascottesCarouselImages: { src: string; alt: string }[] = [
  { src: mascotteCarousel01, alt: 'Duo de mascottes de Noël posant dans un décor hivernal enneigé' },
  { src: mascotteCarousel02, alt: 'Mascottes Mickey et Minnie de Noël avec accessoires festifs dans un décor de fête' },
  { src: mascotteCarousel03, alt: 'Mascotte lapin brune saluant dans un parc arboré' },
  { src: mascotteCarousel04, alt: 'Mascotte ours élégante devant un manège illuminé de fête foraine' },
  { src: mascotteCarousel05, alt: 'Mascotte lapin brune formant un cœur dans une galerie marchande' },
  { src: mascotteCarousel06, alt: 'Mascotte ours d’anniversaire devant une arche de ballons pastel' },
  { src: mascotteCarousel07, alt: 'Mascotte lapin de Pâques en animation dans un magasin décoré' },
  { src: mascotteCarousel08, alt: 'Mascotte lapin brune dans un décor de château' },
  { src: mascotteCarousel09, alt: 'Mascotte chaton blanc saluant sur une fête foraine au coucher du soleil' },
  { src: mascotteCarousel10, alt: 'Mascotte chaton blanc dans un décor de Pâques avec coin photo' },
  { src: mascotteCarousel11, alt: 'Chasse aux œufs de Pâques avec mascotte lapin et enfants dans un parc fleuri' },
];

const MascottesImageCarousel = () => <ImageCarouselSection images={mascottesCarouselImages} title="Les mascottes en images" />;

const AnimateurImageCarousel = () => <ImageCarouselSection images={animateurCarouselImages} title="Nos animateurs en images" />;

const musiqueCarouselImages: { src: string; alt: string }[] = [
  { src: muCarousel01, alt: 'Saxophoniste DJ Sax en plein show dans un club avec ambiance lumineuse festive' },
  { src: muCarousel02, alt: 'DJ Sax : saxophoniste et DJ aux platines sous une pluie de confettis' },
  { src: muCarousel03, alt: 'Saxophoniste lors d’un concert sur un rooftop avec skyline urbaine' },
  { src: muCarousel04, alt: 'Saxophoniste en costume gilet beige sur scène avec décor lumineux vert' },
  { src: muCarousel05, alt: 'Saxophoniste en duo avec un DJ lors d’une réception en château' },
  { src: muCarousel06, alt: 'DJ Violon : violoniste électrique en duo avec DJ aux platines' },
  { src: muCarousel07, alt: 'Saxophoniste accompagnant une DJ lors d’une soirée privée' },
  { src: muCarousel08, alt: 'Saxophoniste en noir et blanc sous projecteurs lors d’un show en club' },
  { src: muCarousel09, alt: 'Saxophoniste jouant en duo avec la mariée lors d’une cérémonie en extérieur' },
  { src: muCarousel10, alt: 'Saxophoniste entouré des mariés et invités sur la piste de danse' },
  { src: muCarousel11, alt: 'DJ femme en plein mix derrière ses platines dans une ambiance nocturne' },
  { src: muCarousel12, alt: 'DJ Sax en live au milieu des invités avec DJ en fond de salle' },
  { src: muCarousel13, alt: 'DJ Sax sur scène en club avec danseuses et lumières néon' },
  { src: muCarousel14, alt: 'Saxophoniste et chanteuse en duo sur scène lors d’un show live' },
  { src: muCarousel15, alt: 'Violoniste électrique en performance scénique sous les projecteurs' },
  { src: muCarousel16, alt: 'Groupe pop rock sur scène avec chanteur et guitaristes en live' },
  { src: muCarousel17, alt: 'Duo pop lounge avec chanteuse et guitariste sur scène en extérieur' },
  { src: muCarousel18, alt: 'Groupe rock en concert devant une foule avec grands faisceaux lumineux' },
  { src: muCarousel19, alt: 'Groupe country sur scène avec chanteuse à la guitare et musiciens' },
  { src: muCarousel20, alt: 'Guitariste rock en contre-jour levant le poing pendant un concert' },
  { src: muCarousel21, alt: 'Groupe lounge pop avec chanteur guitariste et musiciens sur scène' },
  { src: muCarousel22, alt: 'Chanteur soul jazz au micro avec bretelles et chapeau dans une ambiance intimiste' },
  { src: muCarousel23, alt: 'Groupe rock métal en vestes noires devant un décor en flammes' },
  { src: muCarousel24, alt: 'Crowd surfing pendant un concert rock dans une salle bondée' },
  { src: muCarousel25, alt: 'Groupe rock en répétition ou showcase devant une enseigne lumineuse' },
  { src: muCarousel26, alt: 'Groupe pop rock avec chanteuse en robe rouge sur scène' },
  { src: muCarousel27, alt: 'Formation jazz lounge élégante en tenue de soirée avec contrebasse et saxophones' },
  { src: muCarousel28, alt: 'Duo rock énergique guitare et chant sur scène' },
  { src: muCarousel29, alt: 'Groupe soul funk jouant clavier batterie et guitare dans une ambiance chaleureuse' },
  { src: muCarousel30, alt: 'Groupe pop rock moderne sur scène avec lumière bleue et rouge' },
  { src: muCarousel31, alt: 'Duo saxophone et guitare en tenue moderne lors d’une prestation live' },
  { src: muCarousel32, alt: 'Groupe jazz avec chanteuse, saxophoniste, pianiste et guitariste dans un club intimiste' },
  { src: muCarousel33, alt: 'Chanteuse country guitare acoustique et bottes en cuir devant une grange en bois' },
  { src: muCarousel52, alt: 'Accordéoniste en extérieur avec grand chapeau et accordéon coloré' },
  { src: muCarousel53, alt: 'Batterie sur scène dans une lumière dorée avec micros et cymbales' },
  { src: muCarousel54, alt: 'Percussions africaines et djembés captés en gros plan avec micros de scène' },
  { src: muCarousel55, alt: 'Guitariste country assise contre une grange en bois avec bottes western' },
  { src: muCarousel56, alt: 'Pianiste en veste noire jouant un piano à queue dans une ambiance feutrée' },
  { src: muCarousel57, alt: 'Saxophoniste sur scène en chemise blanche et cravate dans une lumière chaude' },
  { src: muCarousel58, alt: 'Saxophoniste en veste en jean et lunettes tenant son instrument en studio' },
  { src: muCarousel59, alt: 'Saxophoniste élégant en costume noir lors d’une animation de mariage' },
  { src: muCarousel60, alt: 'Saxophoniste de scène en veste bleue dans une ambiance lumineuse violette' },
  { src: muCarousel61, alt: 'Violoniste en robe de mariée jouant lors d’une cérémonie élégante' },
  { src: muCarousel62, alt: 'Violoniste en robe blanche sur le Pont Alexandre III à Paris de nuit' },
  { src: muCarousel63, alt: 'Duo de violonistes en tenue noire lors d’une séance artistique' },
  { src: muCarousel64, alt: 'Duo violon et violoncelle en costume lors d’un cocktail élégant' },
  { src: muCarousel65, alt: 'Violoncelliste électrique en performance lumineuse rouge et bleue' },
  { src: muCarousel66, alt: 'Affiche Tribute Alain Souchon style vintage avec guitare acoustique' },
  { src: muCarousel67, alt: 'Affiche Tribute to Barry White avec orchestre soul et saxophone' },
  { src: muCarousel68, alt: 'Groupe Tribute Beatles sur scène avec guitares et batterie vintage' },
  { src: muCarousel69, alt: 'Chanteuse Tribute Céline Dion en concert sur scène illuminée de bleu' },
  { src: muCarousel70, alt: 'Affiche Tribute Coldplay aux silhouettes colorées arc-en-ciel' },
  { src: muCarousel71, alt: 'Groupe Tribute Eddy Mitchell avec cuivres et saxophone sur scène' },
  { src: muCarousel72, alt: 'Hommage Tribute Edith Piaf avec chanteuse, accordéon et contrebasse' },
  { src: muCarousel73, alt: 'Trio Tribute Elvis Presley en tenues rétro avec micro vintage' },
  { src: muCarousel74, alt: 'Chanteur Tribute Florent Pagny en veste à franges sur scène lumineuse' },
  { src: muCarousel75, alt: 'Groupe Tribute France Gall avec chanteuses dynamiques et batterie' },
  { src: muCarousel76, alt: 'Groupe Tribute Francis Cabrel en tenue sombre sous projecteurs' },
  { src: muCarousel77, alt: 'Quatuor Tribute Frank Sinatra en noir et blanc avec saxophone et chapeau' },
  { src: muCarousel78, alt: 'Affiche Tribute Gladiator style rétro avec guerrier romain' },
  { src: muCarousel79, alt: 'Affiche Tribute Guns N’ Roses avec revolver et rose rouge' },
  { src: muCarousel80, alt: 'Affiche Tribute Indochine style vintage avec dragon rouge' },
  { src: muCarousel81, alt: 'Affiche Tribute Jacques Higelin aux couleurs psychédéliques seventies' },
  { src: muCarousel82, alt: 'Groupe Tribute JJ Goldman sur scène avec guitares et chanteuse' },
  { src: muCarousel83, alt: 'Affiche Tribute Lady Gaga en illustration pop colorée' },
  { src: muCarousel84, alt: 'Affiche Tribute Hits Latino avec motifs floraux mexicains' },
  { src: muCarousel85, alt: 'Groupe Tribute Louise Attaque sur scène avec violon et éclairage vert' },
  { src: muCarousel86, alt: 'Affiche Tribute Manu Chao style reggae illustré aux couleurs chaudes' },
  { src: muCarousel87, alt: 'Chanteur Tribute Michael Jackson avec micro sur scène éclairée' },
  { src: muCarousel88, alt: 'Trio Tribute Muse en portrait cinématographique sombre' },
  { src: muCarousel89, alt: 'Chanteuse Tribute Mylène Farmer en tenue scénique métallique' },
  { src: muCarousel90, alt: 'Groupe Tribute Noir Désir en concert rock en sépia' },
  { src: muCarousel91, alt: 'Groupe Tribute Pink Floyd avec guitare et jeux de lumière multicolores' },
  { src: muCarousel92, alt: 'Quatuor Tribute Police sur fond rouge avec batterie et basse' },
  { src: muCarousel93, alt: 'Groupe Tribute Queen avec chanteur en débardeur blanc en concert' },
  { src: muCarousel94, alt: 'Affiche Tribute Red Hot Chili Peppers avec piments rouges stylisés' },
  { src: muCarousel95, alt: 'Portrait Tribute Renaud en noir et blanc avec foulard rouge' },
  { src: muCarousel96, alt: 'Groupe Tribute Scorpions en concert rock sous projecteurs sépia' },
  { src: muCarousel97, alt: 'Groupe Tribute Sting en concert noir et blanc avec choristes' },
  { src: muCarousel98, alt: 'Affiche Tribute The Cure style pictural avec lune et chauves-souris' },
  { src: muCarousel99, alt: 'Affiche Tribute U2 style rétro avec portraits des quatre membres' },
  { src: muCarousel100, alt: 'Chanteuse de variété internationale en robe à pois noir et blanc sur scène' },
  { src: muCarousel101, alt: 'Duo de chanteuses gospel en tenues scintillantes au micro vintage' },
  { src: muCarousel102, alt: 'Duo soul international guitariste et chanteuse sous lumière violette' },
  { src: muCarousel103, alt: 'Chanteuse de variété française en combinaison rouge sur scène avec batterie' },
  { src: muCarousel104, alt: 'Chanteuse gospel jazz au micro vintage sous lumière dorée tamisée' },
  { src: muCarousel105, alt: 'Chanteur de variété en veste à paillettes sous fumée rose et bleue' },
  { src: muCarousel106, alt: 'Silhouette de chanteur gospel au micro vintage sous lumière chaude' },
  { src: muCarousel107, alt: 'Chanteur soul en chapeau et bretelles au micro vintage sur scène sombre' },
  { src: muCarousel108, alt: 'Chanteur rock international en concert noir et blanc avec guitare Fender' },
  { src: muCarousel109, alt: 'Chorale gospel en robes traditionnelles avec soliste au micro' },
  { src: muCarousel110, alt: 'Trio soul international en concert lumières colorées au micro vintage' },
  { src: muCarousel111, alt: 'Chanteur de variété internationale en veste denim avec contrebassiste sur scène' },
  { src: muCarousel112, alt: 'Chanteur de variété sur scène sous lumière bleue avec guitariste' },
  { src: muCarousel113, alt: 'Chanteur country américain en débardeur sous lumières rouges et bleues' },
  { src: muCarousel114, alt: 'Chanteuse pop souriante en marinière sur scène sous lumière bleue' },
  { src: muCarousel115, alt: 'Quatuor gospel contemporain en tenues lavande dans une église' },
  { src: muCarousel116, alt: 'Chorale gospel féminine en robes blanches et étoles rouges en pleine prestation' },
];

const MusiqueImageCarousel = () => <ImageCarouselSection images={musiqueCarouselImages} title="L'art de la musique en images" />;

const cirqueCarouselImages: { src: string; alt: string }[] = [
  { src: cirqueAcrobateSuspendu, alt: 'Acrobate suspendu en plein vol sur mât chinois entouré de fumée' },
  { src: artCirqueContent3, alt: 'Duo d’acrobates en équilibre horizontal sur plateforme rouge' },
  { src: cirqueAcrobatesPyramide, alt: 'Pyramide humaine d’acrobates dans la brume bleutée' },
  { src: artCirqueContent2, alt: 'Aérialiste en suspension sous les lumières violettes' },
  { src: artCirquePoint1, alt: 'Aérialiste musclé suspendu à une corde dans la nuit' },
  { src: cirqueAerialisteTheatre, alt: 'Aérialiste suspendu sous la coupole d’un théâtre à l’italienne' },
  { src: cirqueArtisteCerceaux, alt: 'Artiste en action avec multiples cerceaux en rotation' },
  { src: cirqueAthletePlanche, alt: 'Athlète en planche sur scène avec éclairage dramatique' },
  { src: cirqueContorsionnisteEquilibre, alt: 'Contorsionniste en équilibre sous lumière bleue sur cannes d’équilibre' },
  { src: cirqueContorsionnistePerformance, alt: 'Contorsionniste en pleine performance acrobatique dans un costume flamboyant' },
  { src: cirqueContorsionnistePose, alt: 'Contorsionniste en pose extrême sur scène sous pluie de lumières' },
  { src: cirqueContorsionnisteDouce, alt: 'Contorsionniste sous lumière douce en costume noir et violet' },
  { src: cirqueDanseAerienne, alt: 'Danse aérienne en équilibre parfait avec costume vert et or' },
  { src: cirqueDanseuseAiles, alt: 'Danseuse en équilibre avec ailes translucides blanches' },
  { src: cirqueDuetAerien, alt: 'Duo aérien sous lumière dramatique avec éclats d’eau' },
  { src: cirqueJongleurDiabolo, alt: 'Jongleur au diabolo lumineux sous lumière noire' },
  { src: cirqueArcherPomme, alt: 'Numéro d’archerie avec pomme en équilibre en noir et blanc' },
  { src: cirqueDuoPluie, alt: 'Duo aérien sous la pluie dans une composition contemporaine' },
  { src: artCirqueContent1, alt: 'Portrait de clown maquillé sous lumière violette' },
  { src: cirqueDuoClowns, alt: 'Duo de clowns colorés avec petits parapluies' },
  { src: cirqueClownScene, alt: 'Clown en costume rayé sur scène dans une pose théâtrale' },
  { src: cirqueCerceauSpotlight, alt: 'Artiste au cerceau aérien isolée dans un faisceau de lumière' },
  { src: cirqueElfeNoel, alt: 'Personnage de cirque en costume d’elfe de Noël devant un décor festif' },
  { src: cirqueClownBouleCristal, alt: 'Clown en maquillage sombre équilibrant une boule de cristal' },
  { src: cirqueAcrobateCannes, alt: 'Acrobate en équilibre sur cannes sous projecteur' },
  { src: cirqueEquilibreBallon, alt: 'Artiste en équilibre sur planche posée sur un ballon de basket' },
  { src: cirqueClownJauneVelo, alt: 'Clown en costume jaune assis sur un petit vélo de cirque' },
];

const CirqueImageCarousel = () => <ImageCarouselSection images={cirqueCarouselImages} title="L'art du cirque en images" />;

const sportCarouselImages: { src: string; alt: string }[] = [
  { src: spNew01, alt: 'Art martial — combat de kendo en compétition' },
  { src: sportPoint1Shows, alt: 'Basket show freestyle — dunk acrobatique à travers un cerceau enflammé' },
  { src: spNew03, alt: 'Basket show freestyle — freestyler faisant tourner un ballon sur le doigt' },
  { src: spNew04, alt: 'BMX — rider en plein saut dans le ciel nuageux' },
  { src: sportPoint3Bmx, alt: 'BMX freestyle — figure d’équilibre en intérieur' },
  { src: spNew06, alt: 'BMX — saut au-dessus d’un dirt jump en forêt' },
  { src: spNew07, alt: 'BMX — show AcroBike sur scène avec éclairages violets' },
  { src: spNew08, alt: 'Danse et gymnastique en performance — show pom-pom et acrobatie au sol' },
  { src: spNew09, alt: 'Danseur aérien — performance acrobatique suspendue dans la lumière' },
  { src: spNew10, alt: 'Foot freestyle — jongles et équilibre sous une arche urbaine' },
  { src: spNew11, alt: 'Moto rodéo — wheelie de stunt devant le public' },
  { src: spNew12, alt: 'Moto voltige — figure de freestyle motocross en plein vol' },
  { src: spNew13, alt: 'Roller — saut agressif en rampe' },
  { src: spNew14, alt: 'Skateboard — figure en plein saut au-dessus d’un module' },
  { src: spNew15, alt: 'Skateboard — longboard posé en bord de quai' },
  { src: spNew16, alt: 'Sport de combat — démonstration scénique d’arts martiaux' },
  { src: spNew17, alt: 'Double Dutch — saut acrobatique à la corde en pleine démonstration' },
  { src: spNew18, alt: 'Sport street — break acrobatique en appui sur une main' },
  { src: spNew19, alt: 'Sport street — figures de groupe en lévitation' },
  { src: spNew20, alt: 'Trampoline — salto acrobatique en compétition' },
  { src: spNew21, alt: 'Trial BMX & moto — démonstration sur modules devant un public' },
  { src: spNew22, alt: 'Vélo — performance d’équilibre artistique sur bicyclette' },
];

const SportImageCarousel = () => <ImageCarouselSection images={sportCarouselImages} title="Sport & Spectacle en images" />;

const lieuxReceptionCarouselImages: { src: string; alt: string }[] = [
  { src: liChateau01, alt: 'Château classique en pierre claire avec toits d’ardoise et jardin à la française pour mariage' },
  { src: liChateau02, alt: 'Château de mariage avec briques rouges et allée de gravier au cœur d’un parc arboré' },
  { src: liChateau03, alt: 'Façade arrière d’un château de réception avec balustrade et perron en pierre' },
  { src: liChateau04, alt: 'Manoir en pierre couvert de vigne vierge avec terrasse en gravier pour réception champêtre' },
  { src: lieuxReceptionC2, alt: 'Tables rondes dressées en blanc dans le parc d’un château pour un dîner de mariage' },
  { src: liChateau06, alt: 'Vue aérienne d’un château avec jardins à la française et plans d’eau pour mariage d’exception' },
  { src: liChateau07, alt: 'Domaine viticole avec château et vignobles en terrasses pour réception de mariage' },
  { src: liChateau08, alt: 'Château romantique aux tourelles couvert de lierre, écrin idéal pour un mariage' },
  { src: liChateau09, alt: 'Domaine de réception avec longère en pierre et parc arboré pour mariage en plein air' },
  { src: liChateau10, alt: 'Château de la Loire avec topiaires en cônes et allée pavée pour mariage prestigieux' },
  { src: liChateau11, alt: 'Vue aérienne d’un château aux tourelles d’ardoise dans un parc aux arbres dorés d’automne' },
  { src: liChateau12, alt: 'Château romantique en pierre claire avec jardin à la française et roses en fleurs' },
  { src: liChateau13, alt: 'Longue table de mariage dressée dans une cour de pierre avec composition florale au coucher du soleil' },
  { src: liChateau14, alt: 'Couple de mariés devant un château avec arche fleurie blanche au coucher du soleil' },
  { src: liChateau15, alt: 'Mariés posant dans le jardin d’un château ancien couvert de lierre' },
  { src: liChateau16, alt: 'Château viticole majestueux aux multiples tourelles entouré de vignes pour mariage d’exception' },
];
const LieuxReceptionImageCarousel = () => <ImageCarouselSection images={lieuxReceptionCarouselImages} title="Nos lieux de réception en images" />;

const restaurationCarouselImages: { src: string; alt: string }[] = [
  { src: reCarousel01, alt: 'Verrines traiteur sucrées-salées dressées en enfilade sur plateaux de service' },
  { src: reCarousel02, alt: 'Buffet cocktail traiteur avec salades, brochettes et verrines colorées' },
  { src: reCarousel03, alt: 'Animation culinaire brasero avec chef servant des invités en extérieur' },
  { src: reCarousel04, alt: 'Préparation minute de mini-burgers par un traiteur en atelier live' },
  { src: reCarousel05, alt: 'Grand buffet traiteur haut de gamme avec fruits de mer, bouchées et verrines' },
  { src: reCarousel06, alt: 'Buffet raffiné mêlant pièces cocktail, mini-burgers, pâtisseries et composition florale' },
  { src: reCarousel07, alt: 'Table de fromages d’exception avec raisins, pains et assortiment de pâtes variées' },
  { src: reCarousel08, alt: 'Plateaux de mini-viennoiseries et bouchées salées pour brunch ou cocktail' },
  { src: reCarousel09, alt: 'Chef traiteur en cuisson live sur brasero avec légumes et poêles en extérieur' },
  { src: reCarousel10, alt: 'Assortiment de canapés et pièces cocktail gastronomiques dressés sur plateau' },
  { src: reCarousel11, alt: 'Plateau traiteur avec mini-bagels, verrines salées et bouchées cocktail' },
  { src: reCarousel12, alt: 'Grand buffet cocktail traiteur avec wraps, brochettes, mini-burgers et verrines de fruits' },
  { src: reCarousel13, alt: 'Table de douceurs et buffet sucré en extérieur avec fruits, fleurs et petites gourmandises' },
  { src: reCarousel14, alt: 'Buffet cocktail chic avec verrines, mini-burgers et cocktails colorés en soirée' },
  { src: reCarousel15, alt: 'Plateaux traiteur avec gougères, mini-sandwichs et assortiment de bouchées salées' },
  { src: reCarousel16, alt: 'Verrines traiteur orange et desserts en buffet élégant sur présentoirs transparents' },
  { src: reCarousel17, alt: 'Buffet traiteur généreux mêlant desserts, bouchées salées, fruits et verrines' },
  { src: reCarousel18, alt: 'Plateaux de pièces cocktail colorées avec navettes, roulés et verrines dressées' },
  { src: reCarousel21, alt: 'Buffet sucré-salé : choux à la crème, verrines fruitées, mini-burgers et wraps gourmands' },
  { src: reCarousel22, alt: 'Cocktail signature rosé pétillant servi en coupes givrées et plateau de mises en bouche' },
  { src: reCarousel23, alt: 'Service traiteur : présentation de bouchées canapés sur plateaux étagés par une serveuse gantée' },
  { src: reCarousel24, alt: 'Tapas chics : bouchées de jambon cru, fromage frais et fleurs comestibles sur ardoise' },
  { src: reCarousel25, alt: 'Plat de gambas marinées aux herbes fraîches et pousses, dressage gastronomique' },
  { src: reCarousel26, alt: 'Cuisine live à la plancha : brochettes de volaille marinées grillées minute' },
  { src: reCarousel27, alt: 'Plateau cocktail dînatoire : mini-burgers, hot-dogs, wraps, gaspacho et brochettes caprese' },
  { src: reCarousel28, alt: 'Planche fromages affinés et raisins frais, dressage généreux sur bois' },
  { src: reCarousel29, alt: 'Plateau charcuterie & fromages d’exception avec fruits frais, secs et confiseries' },
  { src: reCarousel30, alt: 'Planche XL charcuterie ibérique, fromages variés et accompagnements pour buffet d’honneur' },
  { src: reCarousel31, alt: 'Verrines panna cotta coulis de mangue et myrtilles fraîches, dessert raffiné en mignardise' },
  { src: reCarousel32, alt: 'Pièce montée de fromages d’exception : tour étagée de meules, tommes et bûches affinées' },
  { src: reCarousel33, alt: 'Buffet champêtre de mariage : sandwichs, mini-burgers et bouchées dressés sur supports en bois' },
  { src: reCarousel35, alt: 'Service à l’assiette de bouchées gastronomiques sur cuillères chinoises par un serveur' },
  { src: reCarousel36, alt: 'Verrines guacamole-tomate et bruschettas crevettes-noix sur étagères dorées en extérieur' },
  { src: reCarousel37, alt: 'Buffet ensoleillé en plein air : verrines bicolores et tartines bressaola dressées en cascade' },
  { src: reCarousel38, alt: 'Plancha brasero conviviale : brochettes, gambas et légumes grillés en cuisson live au jardin' },
  { src: reCarousel39, alt: 'Pièces montées de fromages affinés en wedding cake fromager fleuri pour mariage' },
  { src: reCarousel40, alt: 'Plateau de petits choux salés aux fleurs comestibles et navettes saumon fumé' },
  { src: reCarousel41, alt: 'Buffet salé d\u00A0généreux : mini-sandwichs, mignardises au saumon, gambas et verrines colorées sur présentoirs dorés' },
  { src: reCarousel42, alt: 'Présentoir bois en escalier avec verrines fraîcheur tomate, mozzarella, œuf et avocat pour cocktail extérieur' },
  { src: reCarousel43, alt: 'Cuillères apéritives : billes de fromage frais enrobées de chorizo et noisettes nappées de confit de fruits rouges' },
  { src: reCarousel44, alt: 'Pyramide de verrines martini garnies de mousse de crustacés et crevettes décortiquées en pièce centrale' },
  { src: reCarousel45, alt: 'Buffet d\u00A0apéritif chic : mini-burgers, briochettes garnies, cocktails violets et présentoirs cage dorée' },
  { src: reCarousel46, alt: 'Verrines dessert fraise-basilic façon cheesecake en shooters individuels sur planche bois' },
  { src: reCarousel47, alt: 'Plateau de tempuras de gambas servi en verrines hautes par un serveur en gants blancs' },
  { src: reCarousel48, alt: 'Bouchées canapés colorées : rosettes de jambon, mousse betterave, myrtilles et touche d\u00A0aneth sur écrins transparents' },
  { src: reCarousel49, alt: 'Cocktails signature mauves et rouges sablés en bordure, finition mûre fraîche pour vin d\u00A0honneur' },
  { src: reCarousel50, alt: 'Service à la française\u00A0: serveuse présentant un plateau de canapés saumon, tomate cerise et roastbeef' },
  { src: reCarousel51, alt: 'Cuisson live de noix de Saint-Jacques snackées à la plancha avec piment d\u00A0Espelette' },
  { src: reCarousel52, alt: 'Chef cuisinier en plein service plancha\u00A0: gambas, pièce de bœuf et légumes de saison grillés' },
  { src: reCarousel53, alt: 'Bar à eaux aromatisées et cocktails sans alcool au citron vert servis dans des verres givrés' },
  { src: reCarousel54, alt: 'Buffet cocktail luxueux\u00A0: tempuras de gambas, verrines de fruits frais, mille-feuilles et toasts saumon' },
  { src: reCarousel55, alt: 'Buffet de mariage doré opulent\u00A0: mini-burgers, brochettes, beignets de gambas et mignardises sucrées-salées' },
  { src: reCarousel56, alt: 'Découpe minute au couteau d\u00A0un jambon sec affiné servi en fines tranches lors du cocktail' },
  { src: reCarousel57, alt: 'Buffet traiteur premium\u00A0: salades fraîches, brochettes, viandes grillées et compositions florales pastel' },
  { src: reCarousel58, alt: 'Number cake lettre fruits rouges\u00A0: pâte sablée, chantilly mascarpone, fraises, framboises, myrtilles et macarons roses' },
  { src: reCarousel59, alt: 'Sweet table romantique vintage\u00A0: cupcakes pastel, mignardises et compositions florales roses et crème' },
  { src: reCarousel60, alt: 'Découpe spectaculaire d\u00A0une pièce montée wedding cake à étages sous une pluie de confettis' },
  { src: reCarousel61, alt: 'Verrines individuelles dessert\u00A0: mousse exotique mangue-passion et salade de fruits frais au physalis' },
  { src: reCarousel62, alt: 'Pièces montées traditionnelles françaises\u00A0: pyramide de macarons et croquembouche caramélisé fleuri' },
  { src: reCarousel63, alt: 'Wedding cake nature trois étages\u00A0: ganache vanille, base écorce chocolatée et cascade de roses pêche' },
  { src: reCarousel64, alt: 'Sablés bretons crème citron décorés de fleurs comestibles pansy violettes, jaunes et bleues' },
  { src: reCarousel65, alt: 'Number cake cœur Saint-Valentin\u00A0: chantilly, fraises, framboises, myrtilles et macarons rose poudré' },
  { src: reCarousel66, alt: 'Sweet table luxe\u00A0: pyramide de macarons, cake-pops, cupcakes pastel et présentoirs dorés en arche' },
  { src: reCarousel67, alt: 'Sélection de wedding cakes haute pâtisserie\u00A0: naked cake floral, étages buttercream et roses fraîches' },
  { src: reCarousel68, alt: 'Choux pâtissiers décorés\u00A0: crème bleu pastel, pétales de chocolat blanc et cœur doré à la feuille d\u2019or' },
  { src: reCarousel69, alt: 'Number cake cœur tout chocolat\u00A0: ganache montée, biscuits, ours guimauve enrobés et fleurs de pensées comestibles' },
  { src: reCarousel70, alt: 'Buffet de mignardises sucrées\u00A0: tartelettes aux fruits rouges, choux craquelin, religieuses et meringues flambées' },
  { src: reCarousel71, alt: 'Service en chambre raffiné\u00A0: viennoiseries, muffins, fruits frais et jus d\u2019orange dressés sur étagère argentée' },
  { src: reCarousel72, alt: 'Plateau de fruits frais sculptés\u00A0: pastèque, melon, raisin, framboises, mûres et fleurs comestibles pour buffet de mariage' },
  { src: reCarousel73, alt: 'Mignardises haute pâtisserie\u00A0: tartelettes framboise-chantilly, chocolat-pistache et meringues flambées au citron vert' },
  { src: reCarousel74, alt: 'Wedding cake majestueux à 6 étages\u00A0: dentelle blanche, perles dorées et cascade de roses en sucre sous lustres en cristal' },
  { src: reCarousel75, alt: 'Naked cake champêtre 4 étages\u00A0: alternance buttercream et biscuit nu, succulentes, chardons et roses pâles sur rondin de bois' },
  { src: reCarousel76, alt: 'Présentoir doré 3 étages\u00A0: bonbons au chocolat fin et carrés de chocolat blanc dans écrins fleurs en tissu pour mariage' },
  { src: reCarousel77, alt: 'Saint-Honoré traditionnel revisité\u00A0: choux caramélisés, pétales de chantilly vanille bourbon et éclats de feuille d\u2019or' },
  { src: reCarousel78, alt: 'Layer cake d\u2019anniversaire 50 ans\u00A0: buttercream rose poudré effet perles et roses fraîches blanches sur socle doré' },
  { src: reCarousel79, alt: 'Number cakes personnalisés\u00A0: chiffres en sablés breton, chantilly vanille fruits frais et version chocolat-biscuits' },
  { src: reCarousel80, alt: 'Sweet table champêtre extérieur\u00A0: pièce montée popcorn, cupcakes pastel, fraises et fontaines florales rose pêche' },
  { src: reCarousel81, alt: 'Buffet de desserts somptueux\u00A0: verrines fruits rouges, donuts glacés, cupcakes, tartelettes et présentoirs blancs étagés' },
  { src: reCarousel82, alt: 'Croquembouche traditionnel et tour de macarons\u00A0: pièces montées de mariage à la française, choux caramélisés et fleurs en sucre' },
  { src: reCarousel83, alt: 'Bouquet de cupcakes fleuris\u00A0: roses, tulipes et hortensias en buttercream bordeaux, pourpre, rose poudré et ivoire' },
  { src: reCarousel84, alt: 'Wedding cake nature 3 étages\u00A0: naked cake aux fruits rouges, roses ivoire et sucre glace au moment de la découpe des mariés' },
  { src: reCarousel85, alt: 'Pièce montée 3 étages crème blanche\u00A0: pivoines roses et blanches fraîches sur scénographie lumineuse de salle de réception' },
  { src: reCarousel86, alt: 'Détail wedding cake romantique\u00A0: roses pêche et rose poudré fraîches, eucalyptus et finition crème vanille texturée' },
  { src: reCarousel87, alt: 'Wedding cake 2 étages perles d\u2019argent\u00A0: pois en sucre, billes argentées et bouquet de roses crème pour cérémonie élégante' },
  { src: reCarousel88, alt: 'Sélection de wedding cakes raffinés\u00A0: naked cakes aux fleurs fraîches, pièce montée perlée et créations florales pastel pour mariage romantique' },
  { src: reCarousel89, alt: 'Sweet table sucré haut de gamme\u00A0: verrines fraises mascarpone, mangue, tiramisu et compositions florales roses et blanches sur supports blancs' },
  { src: reCarousel90, alt: 'Pièces montées traditionnelles françaises\u00A0: croquembouches de choux caramélisés ornés de fleurs en sucre et arabesques de caramel filé' },
  { src: reCarousel91, alt: 'Number cake pistache haute pâtisserie\u00A0: pochage de crème pistache, éclats de pistaches torréfiées et feuilles d\u2019or sur sablé breton' },
  { src: reCarousel92, alt: 'Wedding cake 4 étages dentelle ivoire\u00A0: glaçage royal brodé, fleurs en pâte à sucre et scénographie florale pampa et pivoines violettes' },
  { src: reCarousel93, alt: 'Tour de mini wedding cakes individuels\u00A0: petits gâteaux pâte à sucre rose poudré et ivoire ornés de roses en sucre pour dégustation personnalisée' },
  { src: reCarousel94, alt: 'Bouquet cake fleurs en crème au beurre\u00A0: roses rouges, pivoines crème, chrysanthèmes orange et tulipes jaunes pochées comme un vrai bouquet' },
  { src: reCarousel95, alt: 'Buffet de mignardises raffinées\u00A0: tartelettes fraises mascarpone, pavlovas, verrines framboises et entremets pécan-vanille pour réception' },
  { src: reCarousel96, alt: 'Croquembouches de prestige\u00A0: pièce montée caramel filé fleurs en sucre et version moderne aux macarons pastel, gypsophile et bougies cierges magiques' },
  { src: reCarousel97, alt: 'Wedding cake romantique 2 étages crème et rose poudré\u00A0: arabesques en glaçage royal et bouquet de pivoines roses et roses blanches fraîches' },
  { src: reCarousel98, alt: 'Wedding cake 3 étages pâte à sucre blanche\u00A0: rangs de strass argentés, pois en sucre et cascade de roses rose poudré et pivoines fraîches' },
  { src: reCarousel99, alt: 'Buffet de mignardises chocolat et fruits rouges\u00A0: cupcakes framboises, tartelettes chocolat-vanille, macarons et choux sur présentoirs argentés étagés' },
  { src: reCarousel100, alt: 'Wedding cake classique 3 étages glaçage blanc\u00A0: perles en sucre, marguerites, roses crème et pêche fraîches sur lit de fougère et lierre' },
  { src: reCarousel101, alt: 'Macarons cœur bicolores artisanaux\u00A0: coques framboise rose et chocolat noir disposées en alternance sur planche en bois pour mariage romantique' },
  { src: reCarousel102, alt: 'Layer cake d\u2019anniversaire personnalisé Stitch\u00A0: ganache montée bleu pastel, cœurs en chocolat, prénom Emma en pâte à sucre et topper sur mesure' },
  { src: reCarousel103, alt: 'Sweet table champêtre fleuri\u00A0: cupcakes vanille fraises, framboises fraîches et pivoines roses et pêche pour décor de réception extérieure' },
];
const RestaurationImageCarousel = () => restaurationCarouselImages.length === 0 ? null : <ImageCarouselSection images={restaurationCarouselImages} title="Restauration & traiteur en images" />;

const locationCarouselImages: { src: string; alt: string }[] = [
  { src: mascotteCarousel01, alt: 'Duo de mascottes de Noël posant dans un décor hivernal enneigé' },
  { src: mascotteCarousel02, alt: 'Mascottes Mickey et Minnie de Noël avec accessoires festifs dans un décor de fête' },
  { src: mascotteCarousel03, alt: 'Mascotte lapin brune saluant dans un parc arboré' },
  { src: mascotteCarousel04, alt: 'Mascotte ours élégante devant un manège illuminé de fête foraine' },
  { src: mascotteCarousel05, alt: 'Mascotte lapin brune formant un cœur dans une galerie marchande' },
  { src: mascotteCarousel06, alt: 'Mascotte ours d’anniversaire devant une arche de ballons pastel' },
  { src: mascotteCarousel07, alt: 'Mascotte lapin de Pâques en animation dans un magasin décoré' },
  { src: mascotteCarousel08, alt: 'Mascotte lapin brune dans un décor de château' },
  { src: mascotteCarousel09, alt: 'Mascotte chaton blanc saluant sur une fête foraine au coucher du soleil' },
  { src: mascotteCarousel10, alt: 'Mascotte chaton blanc dans un décor de Pâques avec coin photo' },
  { src: mascotteCarousel11, alt: 'Chasse aux œufs de Pâques avec mascotte lapin et enfants dans un parc fleuri' },
  { src: locCarousel18, alt: 'Invités posant devant une borne à selfie avec accessoires festifs lors d’un mariage' },
  { src: locCarousel19, alt: 'Mariée et invités souriants dans un cadre photobooth avec accessoires amusants' },
  { src: locCarousel20, alt: 'Groupe d’amis prenant un selfie avec borne photo extérieure lors d’un événement' },
  { src: locCarousel21, alt: 'Mariée en robe tournoyante devant une plateforme vidéo 360 pendant la soirée' },
  { src: locCarousel22, alt: 'Grand groupe d’invités rassemblés devant une borne à selfie pour une photo souvenir' },
  { src: locCarousel23, alt: 'Couple sur plateforme vidéo 360 avec pluie de confettis pendant la soirée de mariage' },
  { src: locCarousel24, alt: 'Mariée et amies dansant sur une plateforme 360 en extérieur avec couronnes festives' },
  { src: locCarousel25, alt: 'Installation photobooth avec miroir selfie, tapis rouge et cordons de cérémonie en extérieur' },
  { src: borneContent2, alt: 'Groupe d’invités déguisés autour d’une borne à selfie en bois avec pancartes festives' },
  { src: borneContent1, alt: 'Photo de groupe élégante devant une signalétique photobooth en ambiance rétro chic' },
  { src: locCarousel28, alt: 'Borne à selfie en bois présentée en salle de réception avec une mariée souriante' },
  { src: locCarousel29, alt: 'Borne à selfie en bois installée en extérieur dans un décor de mariage guinguette' },
  { src: locCarousel30, alt: 'Borne à selfie photobooth en extérieur entourée d’invités souriants lors d’un mariage champêtre' },
  { src: locCarousel31, alt: 'Machine à popcorn rétro rouge avec cornets garnis pour animation gourmande événementielle' },
  { src: locCarousel32, alt: 'Pack sonorisation et lumières DJ : enceintes sur pieds, jeux de lumière LED, lyres et machine à fumée' },
];
const LocationImageCarousel = () => <ImageCarouselSection images={locationCarouselImages} title="Notre matériel en images" />;

import photoboothCar01 from '@/assets/photobooth-carousel-01.webp';
import photoboothCar02 from '@/assets/photobooth-carousel-02.webp';
import photoboothCar03 from '@/assets/photobooth-carousel-03.webp';
import photoboothCar04 from '@/assets/photobooth-carousel-04.webp';
import photoboothCar06 from '@/assets/photobooth-carousel-06.webp';
import photoboothCar07 from '@/assets/photobooth-carousel-07.webp';
import photoboothCar08 from '@/assets/photobooth-carousel-08.webp';
import photoboothCar09 from '@/assets/photobooth-carousel-09.webp';
import photoboothCar10 from '@/assets/photobooth-carousel-10.webp';
import photoboothCar11 from '@/assets/photobooth-carousel-11.webp';

const photoboothCarouselImages = [
  { src: borneContent1, alt: 'Borne photobooth en bois moderne et élégante avec invités costumés en soirée de mariage' },
  { src: borneContent2, alt: 'Photobooth personnalisé aux couleurs de l’événement avec accessoires festifs et mariés' },
  { src: borneContent3, alt: 'Borne photo IA en bois clair présentée par une mariée souriante en salle de réception' },
  { src: borneContent4, alt: 'Groupe d’invités complices posant devant une borne à selfie lors d’un événement extérieur' },
  { src: borneEssentielle, alt: 'Borne à selfie en bois installée en extérieur dans un décor de mariage féerique' },
  { src: bornePremium, alt: 'Option Photo IA : borne photobooth en bois présentée par un invité enthousiaste' },
  { src: photoboothCar01, alt: 'Borne à selfie blanche avec mariée et invitées posant lors d’une réception champêtre' },
  { src: photoboothCar02, alt: 'Mariés et témoin posant avec accessoires dans un cadre photo personnalisé prénoms' },
  { src: photoboothCar03, alt: 'Groupe d’amis complices riant devant une borne à selfie noire en extérieur' },
  { src: photoboothCar04, alt: 'Mariée tournoyant en robe devant une plateforme vidéo 360 lors de la soirée' },
  { src: catPhotobooth, alt: 'Grande photo de groupe d’invités souriants devant une borne photobooth blanche en extérieur' },
  { src: photoboothCar06, alt: 'Couple de mariés sur une plateforme 360 sous une pluie de confettis lors de la soirée' },
  { src: photoboothCar07, alt: 'Invitées dansantes sur une plateforme 360 avec ring light dans un patio fleuri' },
  { src: photoboothCar08, alt: 'Borne miroir magique avec tapis rouge et cordons VIP installée en extérieur' },
  { src: photoboothCar09, alt: 'Mariés et invités costumés rieurs posant avec accessoires devant une borne photobooth en bois' },
  { src: photoboothCar10, alt: 'Photo de groupe rétro élégante posant devant une signalétique photobooth en bois' },
  { src: photoboothCar11, alt: 'Borne à selfie en bois installée en extérieur lors d’une réception de mariage féerique au coucher du soleil' },
];
const PhotoboothImageCarousel = () => <ImageCarouselSection images={photoboothCarouselImages} title="Le photobooth en images" />;

import feuDeJourCar03 from '@/assets/feu-de-jour-carousel-03.webp';
import feuDeJourCar04 from '@/assets/feu-de-jour-carousel-04.webp';
import feuDeJourCar05 from '@/assets/feu-de-jour-carousel-05.webp';
import feuDeJourCar06 from '@/assets/feu-de-jour-carousel-06.webp';
import feuDeJourCar07 from '@/assets/feu-de-jour-carousel-07.webp';
import feuDeJourCar09 from '@/assets/feu-de-jour-carousel-09.webp';
import feuDeJourCar10 from '@/assets/feu-de-jour-carousel-10.webp';
import feuDeJourCar11 from '@/assets/feu-de-jour-carousel-11.webp';
import feuDeJourCar12 from '@/assets/feu-de-jour-carousel-12.webp';
import feuDeJourCar13 from '@/assets/feu-de-jour-carousel-13.webp';
import feuDeJourCar14 from '@/assets/feu-de-jour-carousel-14.webp';
import feuDeJourCar16 from '@/assets/feu-de-jour-carousel-16.webp';
import feuDeJourCar17 from '@/assets/feu-de-jour-carousel-17.webp';

const feuDeJourCarouselImages = [
  { src: feuDeJourContent1, alt: 'Mariés s’embrassant devant des lettres lumineuses AMOUR avec fumigènes pastel et invités' },
  { src: feuDeJourContent2, alt: 'Cortège de mariage avec cortège brandissant des fumigènes roses et oranges en extérieur' },
  { src: feuDeJourCar03, alt: 'Mariés s’embrassant devant un rideau de fumigènes multicolores et compositions florales blanches' },
  { src: feuDeJourCar04, alt: 'Mariée joyeuse brandissant un fumigène orange à la sortie d’une porte ancienne en bois' },
  { src: feuDeJourCar05, alt: 'Couple de mariés s’embrassant face à la mer avec fumigènes arc-en-ciel et pièce montée' },
  { src: feuDeJourCar06, alt: 'Mariés enlacés sous une cascade de fumigènes colorés en jardin paysager' },
  { src: feuDeJourCar07, alt: 'Mariés s’embrassant sur la plage au coucher du soleil sous des fumigènes verts, jaunes et rouges' },
  { src: feuDeJourContent3, alt: 'Mariés sortant joyeux entre une haie d’invités brandissant des fumigènes pastel multicolores' },
  { src: feuDeJourCar09, alt: 'Sortie de cérémonie de mariés sous une cascade de fumigènes arc-en-ciel avec invités enthousiastes' },
  { src: feuDeJourCar10, alt: 'Mariés dansant joyeusement sur la pelouse devant un nuage de fumigènes bleus et verts' },
  { src: feuDeJourCar11, alt: 'Mariés enlacés la nuit en forêt sous une cascade de fumigène violet et rose' },
  { src: feuDeJourCar12, alt: 'Cérémonie de mariage avec gerbes de fumigènes blancs et rouges en arrière-plan' },
  { src: feuDeJourCar13, alt: 'Mariés joyeux sortant de cérémonie sous une haie de fumigènes violets, rouges et jaunes' },
  { src: feuDeJourCar14, alt: 'Cortège nuptial brandissant des fumigènes arc-en-ciel autour des mariés s’embrassant' },
  { src: feuDeJourContent4, alt: 'Mariés s’embrassant devant lettres LOVE et gerbes pyrotechniques dorées la nuit' },
  { src: feuDeJourCar16, alt: 'Jeune femme entourée d’un nuage dense de fumigène turquoise en pleine nature' },
  { src: feuDeJourCar17, alt: 'Femme brandissant un fumigène turquoise dans un nuage de fumée violette' },
];
const FeuDeJourImageCarousel = () => <ImageCarouselSection images={feuDeJourCarouselImages} title="Le feu de jour en images" />;

import isCarousel01 from '@/assets/image-souvenirs-carousel-01.jpg';
import isCarousel02 from '@/assets/image-souvenirs-carousel-02.png';
import isCarousel04 from '@/assets/image-souvenirs-carousel-04.jpg';
import isCarousel05 from '@/assets/image-souvenirs-carousel-05.png';
import isCarousel06 from '@/assets/image-souvenirs-carousel-06.png';
import isCarousel07 from '@/assets/image-souvenirs-carousel-07.png';
import isCarousel08 from '@/assets/image-souvenirs-carousel-08.png';
import isCarousel09 from '@/assets/image-souvenirs-carousel-09.png';
import isCarousel10 from '@/assets/image-souvenirs-carousel-10.png';
import isCarousel11 from '@/assets/image-souvenirs-carousel-11.png';

const imageSouvenirsCarouselImages: { src: string; alt: string }[] = [
  { src: isCarousel01, alt: 'Photographe professionnel cadrant les mariées sur écran arrière d\'appareil photo' },
  { src: isCarousel02, alt: 'Équipe image : photographe, vidéaste et opérateur drone en tenue de production' },
  { src: imageSouvenirsC4, alt: 'Prise de vue aérienne par drone : mariés allongés dans l\'herbe' },
  { src: isCarousel04, alt: 'Drone professionnel en vol pour captation aérienne d\'événement' },
  { src: isCarousel05, alt: 'Matériel professionnel : appareils photo, caméra, drone et accessoires' },
  { src: isCarousel06, alt: 'Vidéaste filmant une cérémonie au reflex avec micro directionnel' },
  { src: isCarousel07, alt: 'Photographe de mariage capturant un couple en extérieur près d\'un mur en briques' },
  { src: isCarousel08, alt: 'Photographe de mariage au téléobjectif lors d\'une cérémonie en plein air' },
  { src: isCarousel09, alt: 'Photographe montrant un aperçu des images aux mariés pendant le shooting' },
  { src: isCarousel10, alt: 'Caméra stabilisée sur gimbal pour captation vidéo événementielle' },
  { src: isCarousel11, alt: 'Montage photo et vidéo de mariage avec portraits et prise de vue aérienne' },
];
const ImageSouvenirsImageCarousel = () => <ImageCarouselSection images={imageSouvenirsCarouselImages} title="Image & souvenirs en images" />;

const beauteBienEtreCarouselImages: { src: string; alt: string }[] = [
  { src: beCarousel01, alt: 'Massage du visage relaxant en institut' },
  { src: beCarousel02, alt: 'Soin bien-être crânien et relaxation' },
  { src: beCarousel03, alt: 'Massage aux pierres sur le dos' },
  { src: beCarousel04, alt: 'Massage relaxant du corps' },
  { src: beCarousel05, alt: 'Huile de soin versée pour massage bien-être' },
  { src: beCarousel06, alt: 'Soin du visage apaisant et détente profonde' },
  { src: beCarousel07, alt: 'Composition florale séchée et pampas en éventail' },
  { src: beCarousel08, alt: 'Bouquet de mariée en fleurs séchées dans une lumière dorée' },
  { src: beCarousel09, alt: 'Arche florale pastel avec roses et fleurs séchées' },
  { src: beCarousel10, alt: 'Grande composition florale séchée sur arche de cérémonie' },
  { src: beCarousel11, alt: 'Mariée souriante avec bouquet de fleurs séchées naturelles' },
  { src: beCarousel12, alt: 'Bouquet de mariée aux tons terracotta et nude' },
  { src: beCarousel13, alt: 'Bouquet de mariée blanc et beige aux fleurs séchées' },
  { src: beCarousel14, alt: 'Décor floral séché avec pampas et eucalyptus' },
  { src: beCarousel15, alt: 'Bouquet floral avec orchidées sombres et rubans pastel' },
  { src: beCarousel16, alt: 'Arche florale sur échelle en bois avec roses et dahlias aux tons terracotta' },
  { src: beCarousel17, alt: 'Bouquet de mariée en fleurs séchées avec pampas et roses blanches' },
  { src: beCarousel18, alt: 'Compositions florales sur paniers tressés avec pampas et roses' },
  { src: beCarousel19, alt: 'Bouquet champêtre aux roses pêche et herbes séchées' },
  { src: beCarousel20, alt: 'Composition florale séchée aux tons terracotta et eucalyptus' },
  { src: beCarousel21, alt: 'Bouquet champêtre automnal aux dahlias et fougères' },
  { src: beCarousel22, alt: 'Compositions sur supports dorés en pampas et dahlias terracotta' },
  { src: beCarousel23, alt: 'Bouquet de mariée intime en roses blanches et pampas' },
  { src: beCarousel24, alt: 'Composition florale colorée en roses pastel, hortensias bleus et fleurs violettes' },
  { src: beCarousel25, alt: 'Décor floral bohème sur cadre avec pampas, roses nude et drapé ivoire' },
  { src: beCarousel26, alt: 'Mise en beauté et coiffure en préparation avec maquillage en salon' },
  { src: beCarousel27, alt: 'Coiffure de mariée tressée et chignon travaillé en préparation' },
  { src: beCarousel28, alt: 'Coiffeuse réalisant une mise en forme avec spray fixant' },
  { src: beCarousel29, alt: 'Détail d’une coiffure élégante travaillée au peigne' },
  { src: beCarousel30, alt: 'Coloration capillaire appliquée au pinceau en salon de coiffure' },
  { src: beCarousel31, alt: 'Coiffage au lisseur pour une mise en forme élégante' },
  { src: beCarousel32, alt: 'Maquilleuse réalisant un maquillage des yeux en préparation' },
  { src: beCarousel33, alt: 'Mise en beauté avec maquillage professionnel du regard et du teint' },
  { src: beautePoint1Maquillage, alt: 'Application de gloss lors d’un maquillage élégant' },
  { src: beCarousel35, alt: 'Maquillage de mariée en préparation avec finition des yeux et des cils' },
  { src: beCarousel36, alt: 'Table de maquillage avec pinceaux, palettes et accessoires professionnels' },
  { src: beCarousel37, alt: 'Retouches maquillage et coiffure pour un rendu naturel et lumineux' },
  { src: beCarousel38, alt: 'Maquillage des lèvres et mise en beauté en lumière chaude' },
  { src: beCarousel39, alt: 'Maquilleuse en préparation du regard sur modèle en noir et blanc' },
  { src: beCarousel40, alt: 'Préparation complète coiffure et maquillage avec pinceaux professionnels' },
  { src: beCarousel41, alt: 'Produits et accessoires de maquillage sur table de préparation' },
  { src: beCarousel42, alt: 'Application précise du maquillage des lèvres lors d’une mise en beauté' },
  { src: beCarousel43, alt: 'Pose de vernis en cabine avec lampe UV pour manucure soignée' },
  { src: beCarousel44, alt: 'Détail d’onglerie blanche avec incrustations et finition brillante' },
  { src: beCarousel45, alt: 'Nail art rose métallisé avec motifs délicats en onglerie' },
  { src: beCarousel46, alt: 'Application de vernis rose nacré lors d’une séance de manucure professionnelle' },
  { src: beCarousel47, alt: 'Onglerie créative avec ongles stiletto pailletés or et maquillage assorti' },
  { src: beCarousel48, alt: 'Nounou animatrice enfants — accompagnement d’enfants à la cueillette de pâquerettes dans un parc' },
  { src: beCarousel49, alt: 'Nounou animatrice enfants — jeune femme souriante entourée d’un groupe d’enfants joyeux en extérieur' },
  { src: beCarousel50, alt: 'Nounou animatrice enfants — animatrices et enfants jouant ensemble assis dans l’herbe' },
  { src: beCarousel51, alt: 'Nounou animatrice enfants — groupe d’enfants courant main dans la main dans une prairie ensoleillée' },
  { src: beCarousel52, alt: 'Nounou animatrice enfants — atelier dessin et coloriage en plein air avec animatrices et enfants' },
  { src: beCarousel53, alt: 'Nounou animatrice enfants — animateurs clowns proposant un spectacle de jonglage entouré de ballons pour les enfants' },
  { src: beCarousel54, alt: 'Nounou animatrice enfants — atelier bulles de savon partagé entre animatrices et enfants dans un jardin' },
  { src: beCarousel55, alt: 'Nounou animatrice enfants — enfants allongés dans l’herbe jouant avec leurs mains autour des yeux' },
  { src: beCarousel56, alt: 'Nounou animatrice enfants — animatrices présentant un atelier éducatif à un groupe d’enfants en extérieur' },
  { src: beCarousel57, alt: 'Nounou animatrice enfants — ronde d’enfants en intérieur guidée par une baby-sitter lors d’un jeu collectif' },
  { src: beCarousel58, alt: 'Nounou animatrice enfants — photo de groupe joyeuse avec animatrices et enfants assis en plein air' },
  { src: beCarousel59, alt: 'Nounou animatrice enfants — atelier peinture et dessin en intérieur avec une animatrice' },
  { src: beCarousel60, alt: 'Nounou animatrice enfants — conte et animation avec une mascotte ours devant des enfants attentifs' },
  { src: beCarousel61, alt: 'Nounou animatrice enfants — atelier pâte à modeler et activités manuelles autour d’une table' },
  { src: beCarousel62, alt: 'Nounou animatrice enfants — jeu collectif en intérieur avec une animatrice et un groupe d’enfants en salle d’activités' },
];
const BeauteBienEtreImageCarousel = () => beauteBienEtreCarouselImages.length === 0 ? null : <ImageCarouselSection images={beauteBienEtreCarouselImages} title="Beauté & bien-être en images" />;

const transportCarouselImages: { src: string; alt: string }[] = [
  { src: transportC1, alt: 'Mariés saluant à bord d’une voiture vintage cabriolet décorée de fleurs devant un château au coucher du soleil' },
  { src: trCarousel02, alt: 'Mariés en cabriolet vintage roulant sur une route de vignes au soleil couchant' },
  { src: trCarousel03, alt: 'Mariés accueillis par un chauffeur devant une Rolls-Royce noire fleurie au pied d’un manoir illuminé' },
  { src: trCarousel04, alt: 'Couple de mariés posant devant une Ferrari blanche cabriolet et un château illuminé au crépuscule' },
  { src: trCarousel05, alt: 'Chauffeur en uniforme ouvrant la porte d’une berline blanche fleurie sous une allée de guirlandes lumineuses' },
  { src: trCarousel06, alt: 'Séjour balnéaire haut de gamme avec cocktails face à une plage turquoise et des villas en bord de mer' },
  { src: trCarousel07, alt: 'Voyage de luxe avec piscine à débordement, transats et vue panoramique sur une baie tropicale au coucher du soleil' },
  { src: trCarousel08, alt: 'Escapade nature face à un lac de montagne turquoise entouré de sommets et de forêts' },
  { src: trCarousel09, alt: 'Séjour cocooning en chalet avec café chaud et panorama sur une vallée enneigée au lever du soleil' },
  { src: trCarouselCaleche01, alt: 'Calèche blanche fleurie de roses sur un chemin forestier baigné de lumière pour un mariage champêtre romantique' },
  { src: transportC2, alt: 'Attelage de mariage tiré par deux chevaux de trait devant un château champenois en pierre' },
  { src: trCarouselCaleche03, alt: 'Calèche noire de prestige tirée par deux chevaux bais ornés de fleurs blanches pour une cérémonie élégante' },
  { src: trCarouselCaleche04, alt: 'Carrosse Cendrillon blanc tiré par un cheval blanc devant un château aubois au coucher du soleil' },
  { src: trCarouselCaleche05, alt: 'Cocher en haut-de-forme conduisant un attelage bordeaux tiré par un cheval de trait devant une demeure champenoise' },
  { src: trCarouselCaleche06, alt: 'Calèche noire fleurie de bouquets blancs et rubans tirée par un cheval de trait sur un chemin de campagne au crépuscule' },
  { src: trVtc01, alt: 'Location de véhicule avec chauffeur — mariée saluant à bord d’une Rolls-Royce cabriolet bleue conduite par un chauffeur sur une route de campagne' },
  { src: trVtc02, alt: 'Location de véhicule avec chauffeur — Ford Mustang vintage blanche d’exception sur fond noir studio' },
  { src: trVtc03, alt: 'Location de véhicule avec chauffeur — mariés à bord d’une décapotable blanche fleurie de roses rouges conduite par un chauffeur' },
  { src: trVtc04, alt: 'Location de véhicule avec chauffeur — Rolls-Royce blanche de prestige fleurie devant un château pour un mariage' },
  { src: trVtc05, alt: 'Location de véhicule avec chauffeur — limousine Hummer blanche pour un couple de mariés devant un château illuminé' },
  { src: trVtc06, alt: 'Location de véhicule avec chauffeur — limousine Lincoln blanche stationnée en bord de parc' },
  { src: trVtc07, alt: 'Location de véhicule avec chauffeur — Coccinelle Volkswagen vintage décorée de fleurs blanches face aux montagnes' },
  { src: trVtc08, alt: 'Location de véhicule avec chauffeur — Ford Mustang blanche à bandes bleues, voiture de collection avec chauffeur' },
  { src: trVtc09, alt: 'Location de véhicule avec chauffeur — mariés posant devant une berline vintage crème fleurie pour leur mariage' },
  { src: trVtc10, alt: 'Location de véhicule avec chauffeur — Cadillac Escalade SUV noire haut de gamme pour transferts VIP' },
  { src: trVtc11, alt: 'Location de véhicule avec chauffeur — chauffeur en gants blancs ouvrant la portière d’une Rolls-Royce noire vintage devant un palace' },
  { src: trVtc12, alt: 'Location de véhicule avec chauffeur — berline vintage bleu nuit décorée de rubans blancs pour mariage en bord de parc' },
  { src: trVtc13, alt: 'Location de véhicule avec chauffeur — Rolls-Royce Phantom noire fleurie de roses blanches pour cérémonie de prestige' },
  { src: trVtc14, alt: 'Location de véhicule avec chauffeur — Bentley Mulsanne bicolore et SUV noir pour cortège de mariage haut de gamme' },
  { src: trVtc15, alt: 'Location de véhicule avec chauffeur — mariés posant devant une Bentley vintage bleu et crème conduite par un chauffeur' },
  { src: trVtc16, alt: 'Location de véhicule avec chauffeur — Citroën 2CV blanche vintage décapotable, voiture de collection française' },
  { src: trVtc17, alt: 'Location de véhicule avec chauffeur — Rolls-Royce blanche fleurie et chauffeur en smoking devant un opéra illuminé' },
  { src: trVtc18, alt: 'Location de véhicule avec chauffeur — Rolls-Royce Wraith noire portière ouverte sur intérieur cuir crème, dans un parc de château' },
  { src: trVtc19, alt: 'Location de véhicule avec chauffeur — Ford Mustang GT cabriolet blanche à bandes bleues, voiture sportive de prestige' },
  { src: trVtc20, alt: 'Location de véhicule avec chauffeur — Chevrolet Camaro cabriolet noire à bande blanche, intérieur cuir blanc, dans une rue haussmannienne' },
  { src: trVtc21, alt: 'Location de véhicule avec chauffeur — Chevrolet Camaro SS cabriolet blanche à bandes noires, muscle car américaine de prestige' },
  { src: trVtc22, alt: 'Location de véhicule avec chauffeur — mariés posant devant une Rolls-Royce de collection noire ornée de rubans blancs en sous-bois' },
  { src: trVtc23, alt: 'Location de véhicule avec chauffeur — limousine Rolls-Royce Phantom blanche allongée stationnée devant une demeure de prestige' },
  { src: trVtc24, alt: 'Location de véhicule avec chauffeur — Rolls-Royce Phantom blanche cabriolet ornée de rubans de mariage en ville' },
  { src: trVtc25, alt: 'Location de véhicule avec chauffeur — Rolls-Royce Phantom bicolore bleu et blanc avec rubans de mariage dans un parc' },
  { src: trVtc26, alt: 'Location de véhicule avec chauffeur — Rolls-Royce Phantom blanche avec bouquet de roses sur le capot devant un palais à colonnades' },
  { src: trVtc27, alt: 'Location de véhicule avec chauffeur — Excalibur cabriolet blanche et beige de style années 30 décorée de fleurs pour un mariage' },
  { src: trVtc28, alt: 'Location de véhicule avec chauffeur — Citroën Traction Avant noire de collection ornée de nœuds blancs pour un mariage' },
  { src: trVtc29, alt: 'Location de véhicule avec chauffeur — berline Mercedes-Benz Classe S noire de prestige avec rubans de mariage en milieu urbain' },
];
const TransportImageCarousel = () => transportCarouselImages.length === 0 ? null : <ImageCarouselSection images={transportCarouselImages} title="Transport & voyages en images" />;

const aventureCarouselImages: { src: string; alt: string }[] = [
  { src: adCarousel01, alt: 'Coupes de champagne trinquant sous le soleil dans les vignes' },
  { src: adCarousel02, alt: 'Balade en moto trail dans les vignes au coucher du soleil' },
  { src: adCarousel03, alt: 'Sortie quad tout-terrain entre amis' },
  { src: adCarousel04, alt: 'Randonnée VTT dans les vignes au lever du soleil' },
  { src: adCarousel05, alt: 'Équipement de voyage et d\'aventure mis à plat' },
  { src: aventureC2, alt: 'Groupe de cyclistes en VTT dans les collines viticoles' },
  { src: aventureOutdoor, alt: 'Descente en rafting en eaux vives entre amis' },
  { src: adCarousel08, alt: 'Trois motos trail roulant dans les vignes au coucher du soleil' },
  { src: adCarousel09, alt: 'VTT électrique au sommet d\'une montagne au coucher du soleil' },
  { src: adCarousel10, alt: 'Groupe de motards enduro roulant dans les vignes' },
  { src: adCarousel11, alt: 'Sortie quad en forêt entre amis' },
  { src: adCarousel12, alt: 'Randonnée en montagne dans des paysages sauvages' },
  { src: aventureC3, alt: 'Tyrolienne en forêt avec sourire et adrénaline' },
  { src: adCarousel14, alt: 'Randonnée en quad en file dans la nature' },
  { src: aventureBienetre, alt: 'Dégustation de vin face aux vignes en Champagne' },
  { src: adCarousel16, alt: 'Équipe joyeuse en rafting sur rivière turquoise' },
];
const AventureImageCarousel = () => aventureCarouselImages.length === 0 ? null : <ImageCarouselSection images={aventureCarouselImages} title="Aventure & loisirs en images" />;

const animationsSpecialesCarouselImages: { src: string; alt: string }[] = [
  { src: asJeuxBois01, alt: 'Jeu de quilles nordiques en bois posé sur l’herbe pour une animation extérieure conviviale' },
  { src: asJeuxBois02, alt: 'Jeu de lancer de boîtes sur support en toile de jute pour mariage champêtre' },
  { src: asJeuxBois03, alt: 'Ensemble de grands jeux en bois avec cornhole, puissance 4 géant et tour en bois dans un jardin fleuri' },
  { src: asJeuxBois04, alt: 'Sélection de jeux en bois géants installés dans un parc pour une animation intergénérationnelle' },
  { src: asJeuxBois05, alt: 'Collection de jeux en bois traditionnels et colorés disposés sur pelouse pour une animation événementielle' },
  { src: asJeuxBois06, alt: 'Grand espace de jeux en bois et jeux d’adresse en plein air pour cocktail ou vin d’honneur' },
  { src: asJeuxBois07, alt: 'Puissance 4 géant en bois installé en extérieur avec caisse de palets à côté' },
  { src: asJeuxBois08, alt: 'Jeu en bois d’adresse avec pistes numérotées et balles en extérieur sous les arbres' },
  { src: asBartender01, alt: 'Flair bartender versant deux cocktails colorés au shaker sur fond studio' },
  { src: asBartender02, alt: 'Cocktail rose dressé au bar avec décoration florale pour animation bartender' },
  { src: asBartender03, alt: 'Jongleur de bar réalisant un lancer de bouteille derrière un comptoir éclairé' },
  { src: asBartender04, alt: 'Bartender en chemise blanche réalisant un service cocktail au shaker sur avant-bras' },
  { src: asBartender05, alt: 'Sélection de cocktails colorés servis au bar lors d’une animation flair bartender' },
  { src: asBartender06, alt: 'Barman en gilet noir préparant un cocktail au shaker dans un bar à ambiance tamisée' },
  { src: asBartender07, alt: 'Cocktail rouge servi en coupe avec framboise pour prestation cocktail premium' },
  { src: asBartender08, alt: 'Jongleur de bar avec bouteille enflammée pour show flair bartender spectaculaire' },
  { src: asBartender09, alt: 'Flair bartender au milieu de fumée et cocktails colorés pendant un show visuel' },
  { src: asBartender10, alt: 'Bartender en nœud papillon réalisant un lancer de bouteille dans un bar lumineux' },
  { src: asBartender11, alt: 'Cocktail dégradé bleu et orange présenté en verre à pied pour animation cocktail' },
  { src: asBartender12, alt: 'Jongleur de bar manipulant un shaker et un gobelet fluorescent derrière le comptoir' },
  { src: asBartender13, alt: 'Bartender servant un cocktail ambré face caméra dans un bar à l’ambiance feutrée' },
  { src: asBartender14, alt: 'Flair bartender versant un cocktail au shaker et à la bouteille dans un bar doré' },
];
const AnimationsSpecialesImageCarousel = () => animationsSpecialesCarouselImages.length === 0 ? null : <ImageCarouselSection images={animationsSpecialesCarouselImages} title="Animations spéciales & expériences en images" />;
const lieuxHubCarouselImages: { src: string; alt: string }[] = [
  { src: lhCarousel01, alt: 'Château de réception illuminé au golden hour' },
  { src: lhCarousel02, alt: 'Salle de séminaire corporate avec tables dressées' },
  { src: lhCarousel03, alt: 'Buffet traiteur gastronomique avec charcuterie et fromages' },
  { src: lhCarousel04, alt: 'Chef cuisinier en live cooking lors d\'un gala' },
  { src: lhCarousel05, alt: 'Photographe professionnel en action lors d\'un mariage' },
  { src: lhCarousel06, alt: 'Vidéaste avec drone filmant une cérémonie' },
  { src: lhCarousel07, alt: 'Calèche blanche avec mariés devant un château' },
  { src: lhCarousel08, alt: 'Maquilleuse préparant la mariée' },
  { src: lhCarousel09, alt: 'Voiture de collection vintage décorée pour mariage' },
  { src: lhCarousel10, alt: 'Composition florale artisanale pampa et roses' },
  { src: lhCarousel11, alt: 'Massage bien-être lors d\'un événement corporate' },
  { src: lhCarousel12, alt: 'Barman flair jonglant avec des bouteilles' },
  { src: lhCarousel13, alt: 'Fumigènes colorés et confettis lors d\'un mariage' },
  { src: lhCarousel14, alt: 'Show LED high-tech lors d\'un gala corporate' },
  { src: lhCarousel15, alt: 'Jeux de bois géants en extérieur entre générations' },
  { src: lhCarousel16, alt: 'Fontaine de champagne lors d\'une réception de luxe' },
  { src: lhCarousel17, alt: 'Mobilier et décoration lounge pour réception en plein air' },
  { src: lhCarousel18, alt: 'Animatrice et baby-sitter avec enfants lors d\'un mariage' },
  { src: lhCarousel19, alt: 'Feu d\'artifice de jour lors d\'un mariage en extérieur' },
  { src: lhCarousel20, alt: 'Aventure accrobranche en team building' },
  { src: lhCarousel21, alt: 'Coiffeuse réalisant un chignon de mariée fleuri' },
  { src: lhCarousel22, alt: 'Grange rénovée avec guirlandes pour dîner de réception' },
  { src: lhCarousel23, alt: 'Verrines et finger food lors d\'un cocktail de luxe' },
  { src: lhCarousel24, alt: 'Fleuriste créant une composition florale artisanale' },
  { src: lhCarousel25, alt: 'Table de réception dressée avec argenterie et fleurs' },
];
const LieuxHubImageCarousel = () => <ImageCarouselSection images={lieuxHubCarouselImages} title="Nos lieux & services en images" />;

const bookingCarouselImages: { src: string; alt: string }[] = [
  { src: asCarousel07, alt: 'Comédien infiltré surprenant les invités' },
  { src: asCarousel11, alt: 'DJ set ambiance festive' },
  { src: arCarousel05, alt: 'Fanfare festive dans la rue' },
  { src: asCarousel09, alt: 'Danseurs contemporains sur scène' },
  { src: ciCarousel01, alt: 'Artiste de cirque en performance' },
  { src: enCarousel06, alt: 'Spectacle de magie pour enfants' },
  { src: spCarousel01, alt: 'Performance sportive freestyle' },
  { src: asCarousel15, alt: 'Groupe de musique live en concert' },
  { src: arCarousel06, alt: 'Spectacle de feu et pyrotechnie' },
  { src: ciCarousel05, alt: 'Acrobate aérien sous chapiteau' },
  { src: enCarousel07, alt: 'Manège enchanté pour enfants' },
  { src: asCarousel13, alt: 'Magicien grande illusion' },
  { src: asCarousel16, alt: 'Saxophoniste ambiance lounge' },
  { src: arCarousel08, alt: 'Jongleur saltimbanque de rue' },
  { src: spCarousel03, alt: 'BMX freestyle spectacle' },
  { src: ciCarousel03, alt: 'Contorsionniste et jongleuse' },
  { src: enCarousel08, alt: 'Maquillage artistique enfants' },
  { src: arCarousel13, alt: 'Troupe de danse parade colorée' },
  { src: spCarousel06, alt: 'Performance trial vélo' },
  { src: asCarousel12, alt: 'Hypnotiseur sur scène' },
  { src: enCarousel15, alt: 'Mascotte géante avec enfants' },
];
const BookingImageCarousel = () => <ImageCarouselSection images={bookingCarouselImages} title="Nos artistes & spectacles en images" />;


const EventsImageCarousel = () => <ImageCarouselSection images={eventsCarouselImages} title="Nos événements en images" />;

const ServiceDetail = () => {
  const { slug } = useParams<{ slug: string }>();
  const service = services.find((s) => s.slug === slug);
  const serviceIndex = services.findIndex((s) => s.slug === slug);

  if (!service) return <NotFound />;

  const Icon = service.icon;
  const otherServices = services.filter((s) => s.slug !== slug).slice(0, 4);

  return (
    <>
      <SEO
        title={`${service.title} — Cygnature Production | Troyes`}
        description={service.shortDesc || service.heroSubtitle}
        path={`/services/${slug}`}
        keywords={[service.title, 'Cygnature Production', 'Troyes', service.category]}
        jsonLd={[
          breadcrumbSchema([
            { name: 'Accueil', path: '/' },
            { name: 'Services', path: '/services' },
            { name: service.title, path: `/services/${slug}` },
          ]),
          serviceSchema({ name: service.title, description: service.shortDesc || service.heroSubtitle, slug: slug!, category: service.category }),
          ...(service.faq && service.faq.length ? [faqSchema(service.faq.map((f) => ({ question: f.question, answer: f.answer })))] : []),
        ]}
      />
      {/* Hero */}
      <section className="px-6 lg:px-8 py-20 md:py-28 bg-petrol text-petrol-foreground">
        <div className="max-w-7xl mx-auto">
          <Link
            to="/services"
            onClick={() => window.scrollTo(0, 0)}
            className="inline-flex items-center gap-2 text-xs text-petrol-foreground/60 hover:text-primary transition-colors mb-6"
          >
            <ArrowLeft size={14} />
            Retour aux services
          </Link>
          <div className="flex items-center gap-4 mb-4">
            <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center">
              <Icon size={24} className="text-primary" strokeWidth={1.5} />
            </div>
          </div>
          <p className="text-xs font-heading font-semibold uppercase tracking-[0.15em] text-primary/80 mb-3">Votre partenaire de la réussite…</p>
          <h1 className="font-heading text-3xl md:text-5xl font-bold leading-tight">{service.title}</h1>
          <p className="mt-3 font-heading text-lg md:text-xl text-petrol-foreground/70 italic">
            Chaque événement devient une œuvre unique
          </p>
          <p className="mt-5 text-petrol-foreground/60 max-w-2xl text-sm md:text-base leading-relaxed">
            {service.heroSubtitle}
          </p>
          {service.tagline && (
            <div className="mt-6">
              <p className="font-heading text-sm md:text-base font-bold uppercase tracking-wide text-primary">
                {service.tagline}
              </p>
              <p className="mt-2 text-xs text-petrol-foreground/50 italic font-heading">Liste non exhaustive — <Link to="/contact" onClick={() => window.scrollTo(0, 0)} className="text-primary hover:underline">contactez-nous</Link></p>
            </div>
          )}
          {service.slug === 'evenements-publics-prives' && (
            <p className="mt-4 font-heading text-lg md:text-2xl text-petrol-foreground/80 italic tracking-wide">
              Votre histoire commence <span className="text-primary font-medium">ICI</span>
            </p>
          )}
          <div className="flex flex-wrap gap-3 mt-8">
            <Link to="/contact" onClick={() => window.scrollTo(0, 0)} className="inline-flex items-center gap-2 bg-primary text-primary-foreground rounded-full px-7 py-3 font-heading font-medium text-sm hover:bg-primary/90 transition-colors">
              Demander un devis <ArrowRight size={14} />
            </Link>
            <a href="tel:+33671351550" className="inline-flex items-center gap-2 rounded-full px-7 py-3 border border-petrol-foreground/20 text-petrol-foreground font-heading font-medium text-sm hover:border-primary hover:text-primary transition-colors">
              <Phone size={14} /> 06 71 35 15 50
            </a>
            <a
              href={buildWhatsAppUrl(`Bonjour, je vous contacte au sujet de la prestation « ${service.title} ».`)}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full px-7 py-3 border border-petrol-foreground/20 text-petrol-foreground font-heading font-medium text-sm hover:border-primary hover:text-primary transition-colors"
            >
              <MessageCircle size={14} /> WhatsApp
            </a>
          </div>
        </div>
      </section>

      {/* Mini process bar */}
      <section className="px-6 lg:px-8 py-8 bg-card border-b border-border/30">
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {processSteps.map((step, i) => {
              const StepIcon = step.icon;
              return (
                <div key={i} className="flex items-center gap-3 p-3 rounded-xl">
                  <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
                    <StepIcon size={18} className="text-primary" strokeWidth={1.5} />
                  </div>
                  <div>
                    <p className="text-sm font-heading font-bold text-foreground">{step.label}</p>
                    <p className="text-xs text-muted-foreground">{step.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>


      {/* Content blocks — alternating layout with numbered headings */}
      <section className="px-6 lg:px-8 py-16 md:py-20 bg-background">
        <div className="max-w-5xl mx-auto space-y-16">
          {service.slug === 'booking-artistes-spectacles' && (
            <div className="text-center">
              <p className="font-heading text-lg md:text-xl text-primary/90 italic max-w-3xl mx-auto">
                « L'Art de Transformer Vos Rêves en Réalité. »
              </p>
            </div>
          )}
          {service.content.map((block, i) => {
            // Extract bullet-like items from long text
            const sentences = block.text.split(/(?<=\.)\s+/).filter(Boolean);
            const intro = sentences[0];
            const hasLists = block.text.includes(',') && sentences.length >= 2;
            
            // Find sentence with enumeration
            let listItems: string[] = [];
            let remaining: string[] = [];
            
            if (hasLists) {
              for (const s of sentences.slice(1)) {
                const commaCount = (s.match(/,/g) || []).length;
                if (commaCount >= 3 && listItems.length === 0) {
                  // Extract comma-separated items
                  const colonIdx = s.indexOf(':');
                  if (colonIdx > -1) {
                    listItems = s.slice(colonIdx + 1).split(/,\s*/).map(item => item.replace(/\.$/, '').replace(/…$/, '').trim()).filter(item => item.length > 2);
                  } else {
                    listItems = s.split(/,\s*/).map(item => item.replace(/\.$/, '').replace(/…$/, '').trim()).filter(item => item.length > 3);
                  }
                } else {
                  remaining.push(s);
                }
              }
            } else {
              remaining = sentences.slice(1);
            }

            return (
              <div key={i}>
                <div className={`flex flex-col ${i % 2 === 1 ? 'md:flex-row-reverse' : 'md:flex-row'} gap-8 md:gap-12 items-start`}>
                  {/* Image placeholder */}
                  <div className="w-full md:w-5/12 shrink-0">
                    <div className="aspect-[4/3] flex items-center justify-center overflow-hidden">
                      {contentImages[service.slug]?.[i] ? (
                        <img src={contentImages[service.slug][i]} alt={block.heading} className="w-full h-full object-contain" loading="lazy" />
                      ) : (
                        <div className="text-center p-4">
                          <Camera size={28} className="text-muted-foreground/30 mx-auto mb-2" />
                          <p className="text-[11px] text-muted-foreground/40 font-heading">Photo à venir</p>
                        </div>
                      )}
                    </div>
                  </div>
                  {/* Text */}
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/20 flex items-center justify-center shrink-0">
                        <span className="font-heading font-black text-primary text-sm">{String(i + 1).padStart(2, '0')}</span>
                      </div>
                      <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground">
                        {block.heading}
                      </h2>
                    </div>
                    <div className="space-y-3">
                      <p className="text-sm md:text-base text-muted-foreground leading-relaxed">{intro}</p>
                      
                      {listItems.length >= 3 && (
                        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 mt-3">
                          {listItems.slice(0, 8).map((item, j) => (
                            <li key={j} className="flex items-start gap-2">
                              <Check size={14} className="text-primary mt-0.5 shrink-0" />
                              <span className="text-sm md:text-base text-muted-foreground">{item}</span>
                            </li>
                          ))}
                        </ul>
                      )}
                      
                      {remaining.length > 0 && (
                        <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                          {remaining.join(' ')}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* Artist Categories — Visual Mosaic */}
      {service.artistCategories && service.artistCategories.length > 0 && (
        <section className="px-6 lg:px-8 py-16 md:py-20 bg-petrol">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <p className="text-xs font-heading font-semibold uppercase tracking-[0.15em] text-primary mb-2">Notre catalogue</p>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-petrol-foreground mb-3">
                {service.slug === 'lieux-services-associes' ? 'Des prestataires d\'excellence pour chaque besoin' : 'Des artistes pluridisciplinaires pour chaque univers'}
              </h2>
              <p className="text-sm text-petrol-foreground/60 max-w-2xl mx-auto">
                {service.slug === 'lieux-services-associes' ? 'Chaque prestataire est rencontré, évalué et validé pour son professionnalisme, sa fiabilité et la qualité de sa prestation.' : 'Chaque artiste est auditionné, puis sélectionné pour son professionnalisme, sa fiabilité et la qualité de sa prestation.'}
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {service.artistCategories.map((cat, i) => {
                const catImage = cat.imageKey ? categoryImages[cat.imageKey] : null;
                const linkTarget = cat.linkedService ? `/services/${cat.linkedService}` : null;
                const CardWrapper = linkTarget ? Link : 'div';
                const cardProps = linkTarget
                  ? { to: linkTarget, onClick: () => window.scrollTo(0, 0) }
                  : { onClick: () => { const el = document.getElementById(`cat-detail-${i}`); el?.scrollIntoView({ behavior: 'smooth', block: 'center' }); } };
                return (
                  <CardWrapper
                    key={i}
                    {...(cardProps as any)}
                    className={`group relative rounded-2xl overflow-hidden cursor-pointer block ${
                      i >= 6 ? 'sm:col-span-1 lg:col-span-1' : ''
                    }`}
                    style={{ minHeight: '320px' }}
                  >
                    {/* Background image */}
                    {catImage && (
                      <img
                        src={catImage}
                        alt={cat.category}
                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                        loading="lazy"
                        width={640}
                        height={800}
                      />
                    )}
                    {/* Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/20 group-hover:from-black/85 group-hover:via-black/50 transition-all duration-300" />
                    {/* Content */}
                    <div className="relative z-10 h-full flex flex-col items-center justify-center text-center p-6">
                      <h3 className="font-heading text-lg md:text-xl font-black text-white uppercase tracking-wider mb-3">
                        {cat.category}
                      </h3>
                      {cat.tagline && (
                        <p className="text-white/80 text-sm italic leading-relaxed max-w-[220px]">
                          {cat.tagline}
                        </p>
                      )}
                      <span className="mt-5 inline-flex items-center gap-2 px-5 py-2 rounded-sm border border-white/40 text-white text-xs font-heading font-medium uppercase tracking-wider hover:bg-white/10 transition-colors">
                        Voir plus
                      </span>
                    </div>
                  </CardWrapper>
                );
              })}
            </div>

            {/* CTA — Réserver une prestation */}
            <div className="mt-12 text-center">
              <Link
                to="/contact"
                onClick={() => window.scrollTo(0, 0)}
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary text-primary-foreground font-heading font-medium text-sm hover:bg-primary/90 transition-colors"
              >
                Réserver une prestation <ArrowRight size={15} />
              </Link>
            </div>
          </div>
        </section>
      )}

      {/* Formulas / Packages */}
      {service.formulas && service.formulas.length > 0 && (
        <section className="px-6 lg:px-8 py-16 md:py-20 bg-petrol text-petrol-foreground">
          <div className="max-w-5xl mx-auto">
            <p className="text-xs font-heading font-semibold uppercase tracking-[0.15em] text-primary mb-2">Nos formules</p>
            <h2 className="font-heading text-xl md:text-2xl font-bold mb-3">Des services adaptés à vos besoins</h2>
            <p className="text-base text-petrol-foreground/70 mb-12 leading-relaxed">
              Parce que chaque projet est unique, découvrez nos formules détaillées pour répondre à vos besoins spécifiques.
            </p>

            <div className="space-y-16">
              {service.formulas.map((formula, i) => (
                <div key={i} className={`flex flex-col ${i % 2 === 1 ? 'md:flex-row-reverse' : 'md:flex-row'} gap-8 md:gap-12 items-start`}>
                  {/* Image */}
                  <div className="w-full md:w-5/12 shrink-0">
                    <div className="aspect-[4/5] overflow-hidden">
                      {formula.imageKeyword && formulaImages[formula.imageKeyword] ? (
                        <img src={formulaImages[formula.imageKeyword]} alt={formula.title} className="w-full h-full object-cover" loading="lazy" width={800} height={1024} />
                      ) : (
                        <div className="w-full h-full bg-gradient-to-br from-primary/15 to-primary/5 flex items-center justify-center">
                          <div className="text-center p-6">
                            <div className="w-16 h-16 rounded-full bg-primary/20 flex items-center justify-center mx-auto mb-4">
                              <Icon size={28} className="text-primary" strokeWidth={1.5} />
                            </div>
                            <p className="font-heading text-sm font-bold text-petrol-foreground/60">{formula.title}</p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Content */}
                  <div className="flex-1">
                    <h3 className="font-heading text-2xl md:text-3xl font-bold text-primary mb-2">{formula.title}</h3>
                    {formula.subtitle && (
                      <p className="text-xs text-petrol-foreground/50 uppercase tracking-wider mb-5">{formula.subtitle}</p>
                    )}
                    
                    {formula.description && (
                      <p className="text-base text-petrol-foreground/80 leading-[1.8] mb-6">
                        {formula.description}
                      </p>
                    )}

                    <div className="rounded-xl border border-petrol-foreground/10 bg-petrol-foreground/5 overflow-hidden">
                      <Accordion type="single" collapsible>
                        <AccordionItem value={`formula-${i}`} className="border-none">
                          <AccordionTrigger className="px-5 py-4 hover:bg-petrol-foreground/10 text-base font-heading font-medium text-petrol-foreground/85 hover:no-underline">
                            <span className="flex items-center gap-2">
                              <span className="text-primary">+</span> Le détail de la prestation « {formula.title} »
                            </span>
                          </AccordionTrigger>
                          <AccordionContent className="px-5 pb-5 pt-3">
                            <ul className="space-y-3">
                              {formula.details.map((detail, j) => (
                                <li key={j} className="flex items-start gap-3">
                                  <CheckCircle2 size={16} className="text-primary mt-1 shrink-0" />
                                  <span className="text-base text-petrol-foreground/80 leading-relaxed">{detail}</span>
                                </li>
                              ))}
                            </ul>
                          </AccordionContent>
                        </AccordionItem>
                      </Accordion>
                    </div>

                    {formula.conclusion && (
                      <p className="text-base text-petrol-foreground/70 italic leading-[1.8] mt-5">
                        {formula.conclusion}
                      </p>
                    )}

                    {formula.whyChoose && (
                      <div className="mt-7 pt-6 border-t border-petrol-foreground/10">
                        <h4 className="font-heading text-base font-bold text-petrol-foreground mb-3">Pourquoi choisir cette formule&nbsp;?</h4>
                        <p className="text-base text-petrol-foreground/80 leading-[1.8]">
                          {formula.whyChoose}
                        </p>
                      </div>
                    )}

                    <div className="mt-5 flex items-center justify-between">
                      <span className="font-heading text-sm font-bold uppercase tracking-wider text-primary">{formula.price}</span>
                      <Link to="/contact" onClick={() => window.scrollTo(0, 0)} className="inline-flex items-center gap-2 rounded-full border border-petrol-foreground/30 px-5 py-2 text-xs font-heading font-bold uppercase tracking-wider text-petrol-foreground hover:border-primary hover:text-primary transition-colors">
                        Me contacter
                      </Link>
                    </div>

                    {formula.ctaButtons && formula.ctaButtons.length > 0 && (
                      <div className="mt-4 flex flex-wrap gap-2">
                        {formula.ctaButtons.map((label, j) => (
                          <Link
                            key={j}
                            to="/contact"
                            onClick={() => window.scrollTo(0, 0)}
                            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-primary/10 text-primary text-xs font-heading font-medium hover:bg-primary hover:text-primary-foreground transition-colors"
                          >
                            {label} <ArrowRight size={12} />
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Artist Recruitment CTA — only for booking page */}
      {service.slug === 'booking-artistes-spectacles' && (
        <section className="px-6 lg:px-8 py-16 md:py-20 bg-muted/30">
          <div className="max-w-4xl mx-auto text-center">
            <p className="text-xs font-heading font-semibold uppercase tracking-[0.15em] text-primary mb-2">Vous êtes artiste ?</p>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground mb-3 italic">
              Rejoignez notre sélection et développez votre visibilité
            </h2>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-2xl mx-auto mb-8">
              Vous souhaitez intégrer notre catalogue ou bénéficier d'un accompagnement pour faire évoluer votre projet artistique ? Nous étudions chaque profil avec attention, puis nous vous orientons selon votre univers, votre potentiel et les opportunités adaptées à votre positionnement.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 max-w-3xl mx-auto mb-8">
              {[
                'Évaluation de votre profil artistique',
                'Mise en relation avec des organisateurs',
                'Intégration à notre catalogue d\'artistes',
                'Accompagnement à la professionnalisation',
                'Conseils scéniques et techniques',
                'Visibilité sur nos supports de communication',
              ].map((item) => (
                <div key={item} className="flex items-start gap-2 text-left">
                  <Check size={14} className="text-primary mt-0.5 shrink-0" />
                  <span className="text-xs text-muted-foreground">{item}</span>
                </div>
              ))}
            </div>
            <Link
              to="/artistes#candidater"
              onClick={() => window.scrollTo(0, 0)}
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary text-primary-foreground font-heading font-medium text-sm hover:bg-primary/90 transition-colors"
            >
              Candidater <ArrowRight size={15} />
            </Link>
          </div>
        </section>
      )}

      {/* Value Proposition Band — All services */}
      <section className="relative px-4 lg:px-8 py-5 md:py-6 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-primary via-primary/90 to-primary/70" />
        <div className="relative z-10 max-w-6xl mx-auto">
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
            {(service.slug === 'wedding-planner-designer' ? [
              { icon: Key, title: 'Clé en main' },
              { icon: Flower2, title: 'Sur-mesure' },
              { icon: Medal, title: 'Prestataires triés' },
              { icon: Hourglass, title: 'Sérénité absolue' },
            ] : service.slug === 'officiant-ceremonies-laiques' ? [
              { icon: Heart, title: 'Émotion unique' },
              { icon: Flower2, title: 'Sur-mesure' },
              { icon: Award, title: 'Expérience certifiée' },
              { icon: Sparkles, title: 'Moments magiques' },
            ] : service.slug === 'booking-artistes-spectacles' ? [
              { icon: Star, title: 'Artistes vérifiés' },
              { icon: Flower2, title: 'Sur-mesure' },
              { icon: Medal, title: 'Réseau premium' },
              { icon: Zap, title: 'Réactivité' },
            ] : service.slug === 'animations-enfants-famille' ? [
              { icon: Heart, title: 'Adapté aux enfants' },
              { icon: Flower2, title: 'Sur-mesure' },
              { icon: Shield, title: 'Sécurité assurée' },
              { icon: Sparkles, title: 'Magie garantie' },
            ] : service.slug === 'musique-ambiance' ? [
              { icon: Zap, title: 'Ambiance assurée' },
              { icon: Flower2, title: 'Sur-mesure' },
              { icon: Star, title: 'Artistes pro' },
              { icon: Medal, title: 'Tous styles' },
            ] : service.slug === 'a-la-location' ? [
              { icon: Key, title: 'Clé en main' },
              { icon: Shield, title: 'Matériel pro' },
              { icon: Zap, title: 'Installation incluse' },
              { icon: Award, title: 'Support technique' },
            ] : service.slug === 'lieux-services-associes' ? [
              { icon: MapPin, title: 'Lieux sélectionnés' },
              { icon: Flower2, title: 'Sur-mesure' },
              { icon: Medal, title: 'Partenaires vérifiés' },
              { icon: Key, title: 'Coordination totale' },
            ] : service.slug === 'animations-speciales-experiences' ? [
              { icon: Sparkles, title: 'Expériences uniques' },
              { icon: Flower2, title: 'Sur-mesure' },
              { icon: Star, title: 'Effet wow' },
              { icon: Award, title: 'Exclusivités' },
            ] : [
              { icon: Key, title: 'Clé en main' },
              { icon: Flower2, title: 'Sur-mesure' },
              { icon: Medal, title: 'Prestataires qualité' },
              { icon: Hourglass, title: 'Sérénité garantie' },
            ]).map((item, i) => (
              <div key={i} className="flex items-center gap-2">
                <item.icon size={18} className="text-primary-foreground" strokeWidth={1.5} />
                <span className="text-xs md:text-sm font-heading font-semibold text-primary-foreground">{item.title}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Carrousels images — toujours sous le bandeau */}
      {service.slug === 'wedding-planner-designer' && <WeddingImageCarousel />}
      {service.slug === 'officiant-ceremonies-laiques' && <OfficiantImageCarousel />}
      {service.slug === 'art-de-la-rue' && <ArtRueImageCarousel />}
      {service.slug === 'art-de-la-scene' && <ArtSceneImageCarousel />}
      {service.slug === 'arts-visuels' && <ArtsVisuelsImageCarousel />}
      {service.slug === 'evenements-publics-prives' && <EventsImageCarousel />}
      {service.slug === 'animations-enfants-famille' && <EnfantsImageCarousel />}
      {service.slug === 'animateur-micro' && <AnimateurImageCarousel />}
      {service.slug === 'musique-ambiance' && <MusiqueImageCarousel />}
      {service.slug === 'art-du-cirque' && <CirqueImageCarousel />}
      {service.slug === 'sport-spectacle' && <SportImageCarousel />}
      {service.slug === 'lieux-reception' && <LieuxReceptionImageCarousel />}
      {service.slug === 'restauration-traiteur' && <RestaurationImageCarousel />}
      {service.slug === 'a-la-location' && <LocationImageCarousel />}
      {service.slug === 'mascottes' && <MascottesImageCarousel />}
      {service.slug === 'photobooth' && <PhotoboothImageCarousel />}
      {service.slug === 'feu-de-jour' && <FeuDeJourImageCarousel />}
      {service.slug === 'image-souvenirs' && <ImageSouvenirsImageCarousel />}
      {service.slug === 'beaute-bien-etre' && <BeauteBienEtreImageCarousel />}
      {service.slug === 'transport-voyages' && <TransportImageCarousel />}
      {service.slug === 'aventure-loisirs' && <AventureImageCarousel />}
      {service.slug === 'lieux-services-associes' && <LieuxHubImageCarousel />}
      {service.slug === 'booking-artistes-spectacles' && <BookingImageCarousel />}
      {service.slug === 'animations-speciales-experiences' && <AnimationsSpecialesImageCarousel />}

      {/* Teaser YouTube — Événements only */}
      {service.slug === 'evenements-publics-prives' && (
        <section className="px-6 lg:px-8 py-16 md:py-20 bg-background">
          <div className="max-w-4xl mx-auto text-center">
            <p className="text-xs font-heading font-semibold uppercase tracking-[0.15em] text-primary mb-2">Vidéo teaser</p>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground mb-3">Découvrez notre univers événementiel</h2>
            <p className="text-sm text-muted-foreground max-w-xl mx-auto mb-8">Un aperçu de notre énergie, notre savoir-faire et notre passion pour créer des moments inoubliables.</p>
            <div className="relative w-full rounded-2xl overflow-hidden border border-border shadow-lg" style={{ paddingBottom: '56.25%' }}>
              <iframe
                className="absolute inset-0 w-full h-full"
                src="https://www.youtube.com/embed/FWtN1gi7sRQ?rel=0&modestbranding=1"
                title="Cygnature Production — Teaser événementiel"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                loading="lazy"
              />
            </div>
          </div>
        </section>
      )}

      {service.relatedServices && service.relatedServices.length > 0 && (
        <section className="px-6 lg:px-8 py-16 md:py-20 bg-background">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <p className="text-xs font-heading font-semibold uppercase tracking-[0.15em] text-primary mb-2">Services complémentaires</p>
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground mb-3">Complétez votre événement</h2>
              <p className="text-sm text-muted-foreground max-w-2xl mx-auto">
                Ces prestations s'associent parfaitement avec {service.title.toLowerCase()} pour un événement encore plus réussi.
              </p>
            </div>
            <div className="flex flex-wrap justify-center gap-5">
              {service.relatedServices.map((relSlug) => {
                const rel = services.find((s) => s.slug === relSlug);
                if (!rel) return null;
                const RelIcon = rel.icon;
                return (
                  <Link
                    key={rel.slug}
                    to={`/services/${rel.slug}`}
                    onClick={() => window.scrollTo(0, 0)}
                    className="group w-full max-w-sm sm:max-w-[calc(50%-0.625rem)] lg:max-w-[calc(25%-0.9375rem)] lg:flex-[0_1_calc(25%-0.9375rem)] p-5 rounded-xl border border-border bg-card hover:border-primary/30 hover:shadow-md transition-all text-center"
                  >
                    <div className="w-11 h-11 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-3 group-hover:bg-primary/20 transition-colors">
                      <RelIcon size={20} className="text-primary" strokeWidth={1.5} />
                    </div>
                    <h3 className="font-heading font-bold text-sm text-foreground">{rel.title}</h3>
                    <p className="mt-1.5 text-xs text-muted-foreground leading-relaxed line-clamp-2">{rel.shortDesc}</p>
                    <span className="mt-3 inline-flex items-center gap-1 text-xs text-primary font-medium group-hover:gap-2 transition-all">
                      Découvrir <ArrowRight size={12} />
                    </span>
                  </Link>
                );
              })}
            </div>
            <div className="text-center mt-10">
              <Link
                to="/services"
                onClick={() => window.scrollTo(0, 0)}
                className="inline-flex items-center gap-2 text-sm font-heading font-medium text-primary hover:gap-3 transition-all"
              >
                <ArrowLeft size={14} /> Voir tous nos services
              </Link>
            </div>
          </div>
        </section>
      )}

      {service.featuredArtists && service.featuredArtists.length > 0 && (
        <section className="px-6 lg:px-8 py-16 md:py-20 bg-background">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-12">
              <p className="text-xs font-heading font-semibold uppercase tracking-[0.15em] text-primary mb-2">Nos talents</p>
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground mb-3">Artistes à l'affiche</h2>
              <p className="text-sm text-muted-foreground max-w-2xl mx-auto">
                Des talents sélectionnés avec exigence pour créer l'instant juste, au bon moment, devant le bon public.
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {service.featuredArtists.map((artist, i) => (
                <div key={i} className="group relative rounded-2xl border border-border bg-card overflow-hidden hover:border-primary/30 hover:shadow-lg transition-all">
                  <div className="aspect-[3/4] overflow-hidden">
                    {artist.imageKeyword && formulaImages[artist.imageKeyword] ? (
                      <img src={formulaImages[artist.imageKeyword]} alt={artist.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" width={768} height={1024} />
                    ) : (
                      <div className="w-full h-full bg-gradient-to-br from-primary/10 via-muted/20 to-primary/5 flex items-center justify-center">
                        <div className="text-center p-6">
                          <div className="w-20 h-20 rounded-full bg-primary/15 border-2 border-primary/20 flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                            <User size={32} className="text-primary" strokeWidth={1.5} />
                          </div>
                          <p className="text-[11px] text-muted-foreground/50 font-heading">Photo à venir</p>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="p-5">
                    <h3 className="font-heading font-bold text-foreground text-sm">{artist.name}</h3>
                    <p className="text-xs text-primary font-medium mt-1">{artist.specialty}</p>
                    <p className="text-xs text-muted-foreground mt-2 leading-relaxed">{artist.description}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="text-center mt-10">
              <Link to="/contact" onClick={() => window.scrollTo(0, 0)} className="inline-flex items-center gap-2 bg-primary text-primary-foreground rounded-full px-7 py-3 font-heading font-medium text-sm hover:bg-primary/90 transition-colors">
                <Sparkles size={16} /> Réserver une prestation
              </Link>
            </div>
          </div>
        </section>
      )}

      {/* Bullet points */}
      <section className="px-6 lg:px-8 py-16 md:py-20 bg-card">
        <div className="max-w-4xl mx-auto">
          <p className="text-xs font-heading font-semibold uppercase tracking-[0.15em] text-primary mb-2">Ce qui est inclus</p>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground mb-3">Points clés de cette prestation</h2>
          <p className="text-sm text-muted-foreground mb-8">Chaque élément ci-dessous fait partie de notre offre. Tout est personnalisable selon vos besoins.</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {service.bulletPoints.map((point, i) => (
              <div key={i} className="flex items-start gap-3 p-4 rounded-xl border border-border bg-background">
                <div className="w-7 h-7 rounded-full bg-primary/10 flex items-center justify-center shrink-0 mt-0.5">
                  <Check size={14} className="text-primary" />
                </div>
                <span className="text-sm text-foreground font-heading font-medium">{point}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonial */}
      <section className="px-6 lg:px-8 py-16 md:py-20 bg-background">
        <div className="max-w-3xl mx-auto text-center">
          <Quote size={32} className="text-primary/30 mx-auto mb-4" />
          <blockquote className="font-heading text-base md:text-lg text-foreground leading-relaxed italic">
            « {service.testimonial.quote} »
          </blockquote>
          <p className="mt-4 text-sm text-muted-foreground">— <strong className="text-foreground">{service.testimonial.author}</strong>, {service.testimonial.event}</p>
          <div className="flex justify-center gap-0.5 mt-3">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star key={i} size={14} className="fill-primary/80 text-primary/80" />
            ))}
          </div>
        </div>
      </section>

      {/* Highlight Flamme Olympique — Events page only */}
      {service.slug === 'evenements-publics-prives' && (
        <section className="px-6 lg:px-8 py-16 md:py-20 bg-petrol text-petrol-foreground">
          <div className="max-w-5xl mx-auto">
            <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-center">
              <FlammeOlympiqueCarousel className="w-full md:w-1/2" />
              <div className="w-full md:w-1/2">
                <p className="text-xs font-heading font-semibold uppercase tracking-[0.15em] text-primary mb-2">Ils nous ont fait confiance</p>
                <h3 className="font-heading text-xl md:text-2xl font-bold text-petrol-foreground mb-3 inline-flex items-center gap-2 flex-wrap">
                  <Flame size={20} className="text-primary" strokeWidth={1.5} /> Flamme Olympique Paris 2024 — Nogent-sur-Seine
                </h3>
                <p className="text-sm text-petrol-foreground/70 leading-relaxed mb-4">
                  Cygnature Production a animé le passage de la Flamme Olympique avec un spectacle de cheerleaders devant des milliers de spectateurs. La preuve que notre agence est capable de gérer des événements d'envergure nationale avec le même souci du détail que pour vos événements privés.
                </p>
                <div className="flex flex-wrap gap-3">
                  <a
                    href="https://www.facebook.com/watch/?v=2482639325458192"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 bg-primary text-primary-foreground rounded-full px-6 py-2.5 font-heading font-medium text-sm hover:bg-primary/90 transition-colors"
                  >
                    <Eye size={14} /> Voir la vidéo sur Facebook
                  </a>
                  <Link
                    to="/blog/animation-flamme-olympique-nogent-sur-seine"
                    onClick={() => window.scrollTo(0, 0)}
                    className="inline-flex items-center gap-2 rounded-full px-6 py-2.5 border border-primary text-petrol-foreground font-heading font-medium text-sm hover:bg-primary hover:text-primary-foreground transition-colors"
                  >
                    Lire l'article <ArrowRight size={14} />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Why choose us for this service */}
      <section className="px-6 lg:px-8 py-16 md:py-20 bg-card">
        <div className="max-w-4xl mx-auto">
          <p className="text-xs font-heading font-semibold uppercase tracking-[0.15em] text-primary mb-2">L'avantage Cygnature</p>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground mb-3">Pourquoi choisir Cygnature pour cette prestation ?</h2>
          <p className="text-sm text-muted-foreground mb-6">Au-delà du service, c'est une philosophie et une exigence qui font la différence au quotidien.</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {whyUsItems.map((item) => {
              const ItemIcon = item.icon;
              return (
                <div key={item.title} className="p-5 rounded-xl border border-border bg-background hover:border-primary/20 transition-colors">
                  <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-primary/15 to-primary/5 border border-primary/10 flex items-center justify-center mb-3">
                    <ItemIcon size={18} className="text-primary" strokeWidth={1.5} />
                  </div>
                  <h3 className="font-heading font-bold text-sm text-foreground">{item.title}</h3>
                  <p className="text-xs text-muted-foreground mt-1.5 leading-relaxed">{item.desc}</p>
                </div>
              );
            })}
          </div>
          <div className="mt-8 p-5 rounded-xl border border-border bg-muted/30 flex items-center gap-4">
            <div className="flex gap-0.5 shrink-0">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} size={16} className="fill-primary/80 text-primary/80" />
              ))}
            </div>
            <p className="text-sm text-muted-foreground flex-1">
              <strong className="text-foreground">4,9/5 sur Google</strong> — 32 avis clients vérifiés. La meilleure preuve que nos clients sont satisfaits.
            </p>
            <a href="https://www.mariages.net/organisation-mariage/cygnature-production--e311506" target="_blank" rel="noopener noreferrer" className="shrink-0">
              <img src={badgeMariagesNet} alt="Recommandé sur Mariages.net" className="h-14 w-auto" width={56} height={56} loading="lazy" />
            </a>
          </div>
        </div>
      </section>

      {/* Inline contact CTA */}
      <ServiceContactCTA serviceTitle={service.title} />

      {/* FAQ */}
      {service.faq.length > 0 && (
        <section className="px-6 lg:px-8 py-16 md:py-20 bg-background">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-10">
              <p className="text-xs font-heading font-semibold uppercase tracking-[0.15em] text-primary mb-2">Questions fréquentes</p>
            </div>
            <Accordion type="single" collapsible className="space-y-3">
              {service.faq.map((item, i) => (
                <AccordionItem key={i} value={`faq-${i}`} className="border border-border rounded-xl px-6 bg-background data-[state=open]:border-primary/30">
                  <AccordionTrigger className="font-heading text-sm font-semibold text-foreground hover:no-underline py-5">
                    {item.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm text-muted-foreground leading-relaxed pb-5">
                    <ServiceFAQRichAnswer answer={item.answer} />
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
            <div className="text-center mt-8">
              <Link to="/faq" onClick={() => window.scrollTo(0, 0)} className="inline-flex items-center gap-2 text-primary font-heading font-medium text-sm hover:gap-3 transition-all">
                Voir toutes nos questions <ArrowRight size={14} />
              </Link>
            </div>
          </div>
        </section>
      )}

      {/* SEO block */}
      <section className="px-6 lg:px-8 py-12 md:py-16 bg-card">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading text-lg font-bold text-foreground mb-4">{service.title} à Troyes dans l'Aube et partout en France</h2>
          <p className="text-sm text-muted-foreground leading-relaxed">{service.seoBlock}</p>
        </div>
      </section>



      {service.tagline && (
        <section className="py-10 px-6 lg:px-8 bg-petrol">
          <p className="text-center font-heading text-lg md:text-xl italic text-primary max-w-3xl mx-auto">
            « {service.tagline.replace(/\.$/, '')} »
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3 mt-6 text-xs text-petrol-foreground/70">
            {['Interlocuteur unique', 'Coordination complète', 'De 10 à 5 000 invités', 'Intervention partout en France'].map((badge) => (
              <span key={badge} className="px-3 py-1.5 rounded-full border border-petrol-foreground/20 bg-petrol-foreground/5 font-heading">{badge}</span>
            ))}
          </div>
          <div className="text-center mt-6">
            <Link to="/contact" onClick={() => window.scrollTo(0, 0)} className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary text-primary-foreground font-heading font-medium text-sm hover:bg-primary/90 transition-colors">
              Demander une proposition <ArrowRight size={15} />
            </Link>
          </div>
        </section>
      )}

      <CTASection
        title="Intéressé par cette prestation ?"
        subtitle="Contactez-nous pour un premier échange gratuit et sans engagement. Devis personnalisé sous 48 à 72h. Troyes, Grand Est et toute la France."
        buttonLabel="Demander un devis gratuit"
      />
      <ServiceStickyBar text={service.stickyBarText} buttonLabel={service.stickyBarButton} />
    </>
  );
};

export default ServiceDetail;
